! function(e, t) {
    "use strict";
    "object" == typeof module && "object" == typeof module.exports ? module.exports = e.document ? t(e, !0) : function(e) {
        if (!e.document) throw new Error("jQuery requires a window with a document");
        return t(e)
    } : t(e)
}("undefined" != typeof window ? window : this, function(C, e) {
    "use strict";

    function m(e) {
        return null != e && e === e.window
    }
    var t = [],
        S = C.document,
        n = Object.getPrototypeOf,
        s = t.slice,
        g = t.concat,
        l = t.push,
        o = t.indexOf,
        i = {},
        r = i.toString,
        y = i.hasOwnProperty,
        a = y.toString,
        c = a.call(Object),
        v = {},
        w = function(e) {
            return "function" == typeof e && "number" != typeof e.nodeType
        },
        d = {
            type: !0,
            src: !0,
            noModule: !0
        };

    function b(e, t, i) {
        var n, o = (t = t || S).createElement("script");
        if (o.text = e, i)
            for (n in d) i[n] && (o[n] = i[n]);
        t.head.appendChild(o).parentNode.removeChild(o)
    }

    function $(e) {
        return null == e ? e + "" : "object" == typeof e || "function" == typeof e ? i[r.call(e)] || "object" : typeof e
    }
    var _ = function(e, t) {
            return new _.fn.init(e, t)
        },
        u = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;

    function p(e) {
        var t = !!e && "length" in e && e.length,
            i = $(e);
        return !w(e) && !m(e) && ("array" === i || 0 === t || "number" == typeof t && 0 < t && t - 1 in e)
    }
    _.fn = _.prototype = {
        jquery: "3.3.1",
        constructor: _,
        length: 0,
        toArray: function() {
            return s.call(this)
        },
        get: function(e) {
            return null == e ? s.call(this) : e < 0 ? this[e + this.length] : this[e]
        },
        pushStack: function(e) {
            var t = _.merge(this.constructor(), e);
            return t.prevObject = this, t
        },
        each: function(e) {
            return _.each(this, e)
        },
        map: function(i) {
            return this.pushStack(_.map(this, function(e, t) {
                return i.call(e, t, e)
            }))
        },
        slice: function() {
            return this.pushStack(s.apply(this, arguments))
        },
        first: function() {
            return this.eq(0)
        },
        last: function() {
            return this.eq(-1)
        },
        eq: function(e) {
            var t = this.length,
                i = +e + (e < 0 ? t : 0);
            return this.pushStack(0 <= i && i < t ? [this[i]] : [])
        },
        end: function() {
            return this.prevObject || this.constructor()
        },
        push: l,
        sort: t.sort,
        splice: t.splice
    }, _.extend = _.fn.extend = function() {
        var e, t, i, n, o, r, a = arguments[0] || {},
            s = 1,
            l = arguments.length,
            c = !1;
        for ("boolean" == typeof a && (c = a, a = arguments[s] || {}, s++), "object" == typeof a || w(a) || (a = {}), s === l && (a = this, s--); s < l; s++)
            if (null != (e = arguments[s]))
                for (t in e) i = a[t], a !== (n = e[t]) && (c && n && (_.isPlainObject(n) || (o = Array.isArray(n))) ? (r = o ? (o = !1, i && Array.isArray(i) ? i : []) : i && _.isPlainObject(i) ? i : {}, a[t] = _.extend(c, r, n)) : void 0 !== n && (a[t] = n));
        return a
    }, _.extend({
        expando: "jQuery" + ("3.3.1" + Math.random()).replace(/\D/g, ""),
        isReady: !0,
        error: function(e) {
            throw new Error(e)
        },
        noop: function() {},
        isPlainObject: function(e) {
            var t, i;
            return !(!e || "[object Object]" !== r.call(e) || (t = n(e)) && ("function" != typeof(i = y.call(t, "constructor") && t.constructor) || a.call(i) !== c))
        },
        isEmptyObject: function(e) {
            var t;
            for (t in e) return !1;
            return !0
        },
        globalEval: function(e) {
            b(e)
        },
        each: function(e, t) {
            var i, n = 0;
            if (p(e))
                for (i = e.length; n < i && !1 !== t.call(e[n], n, e[n]); n++);
            else
                for (n in e)
                    if (!1 === t.call(e[n], n, e[n])) break;
            return e
        },
        trim: function(e) {
            return null == e ? "" : (e + "").replace(u, "")
        },
        makeArray: function(e, t) {
            var i = t || [];
            return null != e && (p(Object(e)) ? _.merge(i, "string" == typeof e ? [e] : e) : l.call(i, e)), i
        },
        inArray: function(e, t, i) {
            return null == t ? -1 : o.call(t, e, i)
        },
        merge: function(e, t) {
            for (var i = +t.length, n = 0, o = e.length; n < i; n++) e[o++] = t[n];
            return e.length = o, e
        },
        grep: function(e, t, i) {
            for (var n = [], o = 0, r = e.length, a = !i; o < r; o++) !t(e[o], o) != a && n.push(e[o]);
            return n
        },
        map: function(e, t, i) {
            var n, o, r = 0,
                a = [];
            if (p(e))
                for (n = e.length; r < n; r++) null != (o = t(e[r], r, i)) && a.push(o);
            else
                for (r in e) null != (o = t(e[r], r, i)) && a.push(o);
            return g.apply([], a)
        },
        guid: 1,
        support: v
    }), "function" == typeof Symbol && (_.fn[Symbol.iterator] = t[Symbol.iterator]), _.each("Boolean Number String Function Array Date RegExp Object Error Symbol".split(" "), function(e, t) {
        i["[object " + t + "]"] = t.toLowerCase()
    });
    var h = function(i) {
        function u(e, t, i) {
            var n = "0x" + t - 65536;
            return n != n || i ? t : n < 0 ? String.fromCharCode(65536 + n) : String.fromCharCode(n >> 10 | 55296, 1023 & n | 56320)
        }

        function o() {
            x()
        }
        var e, h, b, r, a, f, p, m, $, l, c, x, C, s, S, g, d, y, v, _ = "sizzle" + 1 * new Date,
            w = i.document,
            k = 0,
            n = 0,
            T = ae(),
            E = ae(),
            j = ae(),
            A = function(e, t) {
                return e === t && (c = !0), 0
            },
            D = {}.hasOwnProperty,
            t = [],
            P = t.pop,
            I = t.push,
            L = t.push,
            N = t.slice,
            z = function(e, t) {
                for (var i = 0, n = e.length; i < n; i++)
                    if (e[i] === t) return i;
                return -1
            },
            q = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",
            O = "[\\x20\\t\\r\\n\\f]",
            M = "(?:\\\\.|[\\w-]|[^\0-\\xa0])+",
            F = "\\[" + O + "*(" + M + ")(?:" + O + "*([*^$|!~]?=)" + O + "*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + M + "))|)" + O + "*\\]",
            B = ":(" + M + ")(?:\\((('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|((?:\\\\.|[^\\\\()[\\]]|" + F + ")*)|.*)\\)|)",
            H = new RegExp(O + "+", "g"),
            R = new RegExp("^" + O + "+|((?:^|[^\\\\])(?:\\\\.)*)" + O + "+$", "g"),
            W = new RegExp("^" + O + "*," + O + "*"),
            U = new RegExp("^" + O + "*([>+~]|" + O + ")" + O + "*"),
            V = new RegExp("=" + O + "*([^\\]'\"]*?)" + O + "*\\]", "g"),
            G = new RegExp(B),
            Q = new RegExp("^" + M + "$"),
            X = {
                ID: new RegExp("^#(" + M + ")"),
                CLASS: new RegExp("^\\.(" + M + ")"),
                TAG: new RegExp("^(" + M + "|[*])"),
                ATTR: new RegExp("^" + F),
                PSEUDO: new RegExp("^" + B),
                CHILD: new RegExp("^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + O + "*(even|odd|(([+-]|)(\\d*)n|)" + O + "*(?:([+-]|)" + O + "*(\\d+)|))" + O + "*\\)|)", "i"),
                bool: new RegExp("^(?:" + q + ")$", "i"),
                needsContext: new RegExp("^" + O + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + O + "*((?:-\\d)?\\d*)" + O + "*\\)|)(?=[^-]|$)", "i")
            },
            Y = /^(?:input|select|textarea|button)$/i,
            J = /^h\d$/i,
            Z = /^[^{]+\{\s*\[native \w/,
            K = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,
            ee = /[+~]/,
            te = new RegExp("\\\\([\\da-f]{1,6}" + O + "?|(" + O + ")|.)", "ig"),
            ie = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g,
            ne = function(e, t) {
                return t ? "\0" === e ? "�" : e.slice(0, -1) + "\\" + e.charCodeAt(e.length - 1).toString(16) + " " : "\\" + e
            },
            oe = ve(function(e) {
                return !0 === e.disabled && ("form" in e || "label" in e)
            }, {
                dir: "parentNode",
                next: "legend"
            });
        try {
            L.apply(t = N.call(w.childNodes), w.childNodes), t[w.childNodes.length].nodeType
        } catch (i) {
            L = {
                apply: t.length ? function(e, t) {
                    I.apply(e, N.call(t))
                } : function(e, t) {
                    for (var i = e.length, n = 0; e[i++] = t[n++];);
                    e.length = i - 1
                }
            }
        }

        function re(e, t, i, n) {
            var o, r, a, s, l, c, d, u = t && t.ownerDocument,
                p = t ? t.nodeType : 9;
            if (i = i || [], "string" != typeof e || !e || 1 !== p && 9 !== p && 11 !== p) return i;
            if (!n && ((t ? t.ownerDocument || t : w) !== C && x(t), t = t || C, S)) {
                if (11 !== p && (l = K.exec(e)))
                    if (o = l[1]) {
                        if (9 === p) {
                            if (!(a = t.getElementById(o))) return i;
                            if (a.id === o) return i.push(a), i
                        } else if (u && (a = u.getElementById(o)) && v(t, a) && a.id === o) return i.push(a), i
                    } else {
                        if (l[2]) return L.apply(i, t.getElementsByTagName(e)), i;
                        if ((o = l[3]) && h.getElementsByClassName && t.getElementsByClassName) return L.apply(i, t.getElementsByClassName(o)), i
                    } if (h.qsa && !j[e + " "] && (!g || !g.test(e))) {
                    if (1 !== p) u = t, d = e;
                    else if ("object" !== t.nodeName.toLowerCase()) {
                        for ((s = t.getAttribute("id")) ? s = s.replace(ie, ne) : t.setAttribute("id", s = _), r = (c = f(e)).length; r--;) c[r] = "#" + s + " " + ye(c[r]);
                        d = c.join(","), u = ee.test(e) && me(t.parentNode) || t
                    }
                    if (d) try {
                        return L.apply(i, u.querySelectorAll(d)), i
                    } catch (e) {} finally {
                        s === _ && t.removeAttribute("id")
                    }
                }
            }
            return m(e.replace(R, "$1"), t, i, n)
        }

        function ae() {
            var n = [];
            return function e(t, i) {
                return n.push(t + " ") > b.cacheLength && delete e[n.shift()], e[t + " "] = i
            }
        }

        function se(e) {
            return e[_] = !0, e
        }

        function le(e) {
            var t = C.createElement("fieldset");
            try {
                return !!e(t)
            } catch (e) {
                return !1
            } finally {
                t.parentNode && t.parentNode.removeChild(t), t = null
            }
        }

        function ce(e, t) {
            for (var i = e.split("|"), n = i.length; n--;) b.attrHandle[i[n]] = t
        }

        function de(e, t) {
            var i = t && e,
                n = i && 1 === e.nodeType && 1 === t.nodeType && e.sourceIndex - t.sourceIndex;
            if (n) return n;
            if (i)
                for (; i = i.nextSibling;)
                    if (i === t) return -1;
            return e ? 1 : -1
        }

        function ue(t) {
            return function(e) {
                return "input" === e.nodeName.toLowerCase() && e.type === t
            }
        }

        function pe(i) {
            return function(e) {
                var t = e.nodeName.toLowerCase();
                return ("input" === t || "button" === t) && e.type === i
            }
        }

        function he(t) {
            return function(e) {
                return "form" in e ? e.parentNode && !1 === e.disabled ? "label" in e ? "label" in e.parentNode ? e.parentNode.disabled === t : e.disabled === t : e.isDisabled === t || e.isDisabled !== !t && oe(e) === t : e.disabled === t : "label" in e && e.disabled === t
            }
        }

        function fe(a) {
            return se(function(r) {
                return r = +r, se(function(e, t) {
                    for (var i, n = a([], e.length, r), o = n.length; o--;) e[i = n[o]] && (e[i] = !(t[i] = e[i]))
                })
            })
        }

        function me(e) {
            return e && void 0 !== e.getElementsByTagName && e
        }
        for (e in h = re.support = {}, a = re.isXML = function(e) {
                var t = e && (e.ownerDocument || e).documentElement;
                return !!t && "HTML" !== t.nodeName
            }, x = re.setDocument = function(e) {
                var t, i, n = e ? e.ownerDocument || e : w;
                return n !== C && 9 === n.nodeType && n.documentElement && (s = (C = n).documentElement, S = !a(C), w !== C && (i = C.defaultView) && i.top !== i && (i.addEventListener ? i.addEventListener("unload", o, !1) : i.attachEvent && i.attachEvent("onunload", o)), h.attributes = le(function(e) {
                    return e.className = "i", !e.getAttribute("className")
                }), h.getElementsByTagName = le(function(e) {
                    return e.appendChild(C.createComment("")), !e.getElementsByTagName("*").length
                }), h.getElementsByClassName = Z.test(C.getElementsByClassName), h.getById = le(function(e) {
                    return s.appendChild(e).id = _, !C.getElementsByName || !C.getElementsByName(_).length
                }), h.getById ? (b.filter.ID = function(e) {
                    var t = e.replace(te, u);
                    return function(e) {
                        return e.getAttribute("id") === t
                    }
                }, b.find.ID = function(e, t) {
                    if (void 0 !== t.getElementById && S) {
                        var i = t.getElementById(e);
                        return i ? [i] : []
                    }
                }) : (b.filter.ID = function(e) {
                    var i = e.replace(te, u);
                    return function(e) {
                        var t = void 0 !== e.getAttributeNode && e.getAttributeNode("id");
                        return t && t.value === i
                    }
                }, b.find.ID = function(e, t) {
                    if (void 0 !== t.getElementById && S) {
                        var i, n, o, r = t.getElementById(e);
                        if (r) {
                            if ((i = r.getAttributeNode("id")) && i.value === e) return [r];
                            for (o = t.getElementsByName(e), n = 0; r = o[n++];)
                                if ((i = r.getAttributeNode("id")) && i.value === e) return [r]
                        }
                        return []
                    }
                }), b.find.TAG = h.getElementsByTagName ? function(e, t) {
                    return void 0 !== t.getElementsByTagName ? t.getElementsByTagName(e) : h.qsa ? t.querySelectorAll(e) : void 0
                } : function(e, t) {
                    var i, n = [],
                        o = 0,
                        r = t.getElementsByTagName(e);
                    if ("*" !== e) return r;
                    for (; i = r[o++];) 1 === i.nodeType && n.push(i);
                    return n
                }, b.find.CLASS = h.getElementsByClassName && function(e, t) {
                    if (void 0 !== t.getElementsByClassName && S) return t.getElementsByClassName(e)
                }, d = [], g = [], (h.qsa = Z.test(C.querySelectorAll)) && (le(function(e) {
                    s.appendChild(e).innerHTML = "<a id='" + _ + "'></a><select id='" + _ + "-\r\\' msallowcapture=''><option selected=''></option></select>", e.querySelectorAll("[msallowcapture^='']").length && g.push("[*^$]=" + O + "*(?:''|\"\")"), e.querySelectorAll("[selected]").length || g.push("\\[" + O + "*(?:value|" + q + ")"), e.querySelectorAll("[id~=" + _ + "-]").length || g.push("~="), e.querySelectorAll(":checked").length || g.push(":checked"), e.querySelectorAll("a#" + _ + "+*").length || g.push(".#.+[+~]")
                }), le(function(e) {
                    e.innerHTML = "<a href='' disabled='disabled'></a><select disabled='disabled'><option/></select>";
                    var t = C.createElement("input");
                    t.setAttribute("type", "hidden"), e.appendChild(t).setAttribute("name", "D"), e.querySelectorAll("[name=d]").length && g.push("name" + O + "*[*^$|!~]?="), 2 !== e.querySelectorAll(":enabled").length && g.push(":enabled", ":disabled"), s.appendChild(e).disabled = !0, 2 !== e.querySelectorAll(":disabled").length && g.push(":enabled", ":disabled"), e.querySelectorAll("*,:x"), g.push(",.*:")
                })), (h.matchesSelector = Z.test(y = s.matches || s.webkitMatchesSelector || s.mozMatchesSelector || s.oMatchesSelector || s.msMatchesSelector)) && le(function(e) {
                    h.disconnectedMatch = y.call(e, "*"), y.call(e, "[s!='']:x"), d.push("!=", B)
                }), g = g.length && new RegExp(g.join("|")), d = d.length && new RegExp(d.join("|")), t = Z.test(s.compareDocumentPosition), v = t || Z.test(s.contains) ? function(e, t) {
                    var i = 9 === e.nodeType ? e.documentElement : e,
                        n = t && t.parentNode;
                    return e === n || !(!n || 1 !== n.nodeType || !(i.contains ? i.contains(n) : e.compareDocumentPosition && 16 & e.compareDocumentPosition(n)))
                } : function(e, t) {
                    if (t)
                        for (; t = t.parentNode;)
                            if (t === e) return !0;
                    return !1
                }, A = t ? function(e, t) {
                    if (e === t) return c = !0, 0;
                    var i = !e.compareDocumentPosition - !t.compareDocumentPosition;
                    return i || (1 & (i = (e.ownerDocument || e) === (t.ownerDocument || t) ? e.compareDocumentPosition(t) : 1) || !h.sortDetached && t.compareDocumentPosition(e) === i ? e === C || e.ownerDocument === w && v(w, e) ? -1 : t === C || t.ownerDocument === w && v(w, t) ? 1 : l ? z(l, e) - z(l, t) : 0 : 4 & i ? -1 : 1)
                } : function(e, t) {
                    if (e === t) return c = !0, 0;
                    var i, n = 0,
                        o = e.parentNode,
                        r = t.parentNode,
                        a = [e],
                        s = [t];
                    if (!o || !r) return e === C ? -1 : t === C ? 1 : o ? -1 : r ? 1 : l ? z(l, e) - z(l, t) : 0;
                    if (o === r) return de(e, t);
                    for (i = e; i = i.parentNode;) a.unshift(i);
                    for (i = t; i = i.parentNode;) s.unshift(i);
                    for (; a[n] === s[n];) n++;
                    return n ? de(a[n], s[n]) : a[n] === w ? -1 : s[n] === w ? 1 : 0
                }), C
            }, re.matches = function(e, t) {
                return re(e, null, null, t)
            }, re.matchesSelector = function(e, t) {
                if ((e.ownerDocument || e) !== C && x(e), t = t.replace(V, "='$1']"), h.matchesSelector && S && !j[t + " "] && (!d || !d.test(t)) && (!g || !g.test(t))) try {
                    var i = y.call(e, t);
                    if (i || h.disconnectedMatch || e.document && 11 !== e.document.nodeType) return i
                } catch (e) {}
                return 0 < re(t, C, null, [e]).length
            }, re.contains = function(e, t) {
                return (e.ownerDocument || e) !== C && x(e), v(e, t)
            }, re.attr = function(e, t) {
                (e.ownerDocument || e) !== C && x(e);
                var i = b.attrHandle[t.toLowerCase()],
                    n = i && D.call(b.attrHandle, t.toLowerCase()) ? i(e, t, !S) : void 0;
                return void 0 !== n ? n : h.attributes || !S ? e.getAttribute(t) : (n = e.getAttributeNode(t)) && n.specified ? n.value : null
            }, re.escape = function(e) {
                return (e + "").replace(ie, ne)
            }, re.error = function(e) {
                throw new Error("Syntax error, unrecognized expression: " + e)
            }, re.uniqueSort = function(e) {
                var t, i = [],
                    n = 0,
                    o = 0;
                if (c = !h.detectDuplicates, l = !h.sortStable && e.slice(0), e.sort(A), c) {
                    for (; t = e[o++];) t === e[o] && (n = i.push(o));
                    for (; n--;) e.splice(i[n], 1)
                }
                return l = null, e
            }, r = re.getText = function(e) {
                var t, i = "",
                    n = 0,
                    o = e.nodeType;
                if (o) {
                    if (1 === o || 9 === o || 11 === o) {
                        if ("string" == typeof e.textContent) return e.textContent;
                        for (e = e.firstChild; e; e = e.nextSibling) i += r(e)
                    } else if (3 === o || 4 === o) return e.nodeValue
                } else
                    for (; t = e[n++];) i += r(t);
                return i
            }, (b = re.selectors = {
                cacheLength: 50,
                createPseudo: se,
                match: X,
                attrHandle: {},
                find: {},
                relative: {
                    ">": {
                        dir: "parentNode",
                        first: !0
                    },
                    " ": {
                        dir: "parentNode"
                    },
                    "+": {
                        dir: "previousSibling",
                        first: !0
                    },
                    "~": {
                        dir: "previousSibling"
                    }
                },
                preFilter: {
                    ATTR: function(e) {
                        return e[1] = e[1].replace(te, u), e[3] = (e[3] || e[4] || e[5] || "").replace(te, u), "~=" === e[2] && (e[3] = " " + e[3] + " "), e.slice(0, 4)
                    },
                    CHILD: function(e) {
                        return e[1] = e[1].toLowerCase(), "nth" === e[1].slice(0, 3) ? (e[3] || re.error(e[0]), e[4] = +(e[4] ? e[5] + (e[6] || 1) : 2 * ("even" === e[3] || "odd" === e[3])), e[5] = +(e[7] + e[8] || "odd" === e[3])) : e[3] && re.error(e[0]), e
                    },
                    PSEUDO: function(e) {
                        var t, i = !e[6] && e[2];
                        return X.CHILD.test(e[0]) ? null : (e[3] ? e[2] = e[4] || e[5] || "" : i && G.test(i) && (t = f(i, !0)) && (t = i.indexOf(")", i.length - t) - i.length) && (e[0] = e[0].slice(0, t), e[2] = i.slice(0, t)), e.slice(0, 3))
                    }
                },
                filter: {
                    TAG: function(e) {
                        var t = e.replace(te, u).toLowerCase();
                        return "*" === e ? function() {
                            return !0
                        } : function(e) {
                            return e.nodeName && e.nodeName.toLowerCase() === t
                        }
                    },
                    CLASS: function(e) {
                        var t = T[e + " "];
                        return t || (t = new RegExp("(^|" + O + ")" + e + "(" + O + "|$)")) && T(e, function(e) {
                            return t.test("string" == typeof e.className && e.className || void 0 !== e.getAttribute && e.getAttribute("class") || "")
                        })
                    },
                    ATTR: function(i, n, o) {
                        return function(e) {
                            var t = re.attr(e, i);
                            return null == t ? "!=" === n : !n || (t += "", "=" === n ? t === o : "!=" === n ? t !== o : "^=" === n ? o && 0 === t.indexOf(o) : "*=" === n ? o && -1 < t.indexOf(o) : "$=" === n ? o && t.slice(-o.length) === o : "~=" === n ? -1 < (" " + t.replace(H, " ") + " ").indexOf(o) : "|=" === n && (t === o || t.slice(0, o.length + 1) === o + "-"))
                        }
                    },
                    CHILD: function(f, e, t, m, g) {
                        var y = "nth" !== f.slice(0, 3),
                            v = "last" !== f.slice(-4),
                            w = "of-type" === e;
                        return 1 === m && 0 === g ? function(e) {
                            return !!e.parentNode
                        } : function(e, t, i) {
                            var n, o, r, a, s, l, c = y != v ? "nextSibling" : "previousSibling",
                                d = e.parentNode,
                                u = w && e.nodeName.toLowerCase(),
                                p = !i && !w,
                                h = !1;
                            if (d) {
                                if (y) {
                                    for (; c;) {
                                        for (a = e; a = a[c];)
                                            if (w ? a.nodeName.toLowerCase() === u : 1 === a.nodeType) return !1;
                                        l = c = "only" === f && !l && "nextSibling"
                                    }
                                    return !0
                                }
                                if (l = [v ? d.firstChild : d.lastChild], v && p) {
                                    for (h = (s = (n = (o = (r = (a = d)[_] || (a[_] = {}))[a.uniqueID] || (r[a.uniqueID] = {}))[f] || [])[0] === k && n[1]) && n[2], a = s && d.childNodes[s]; a = ++s && a && a[c] || (h = s = 0) || l.pop();)
                                        if (1 === a.nodeType && ++h && a === e) {
                                            o[f] = [k, s, h];
                                            break
                                        }
                                } else if (p && (h = s = (n = (o = (r = (a = e)[_] || (a[_] = {}))[a.uniqueID] || (r[a.uniqueID] = {}))[f] || [])[0] === k && n[1]), !1 === h)
                                    for (;
                                        (a = ++s && a && a[c] || (h = s = 0) || l.pop()) && ((w ? a.nodeName.toLowerCase() !== u : 1 !== a.nodeType) || !++h || (p && ((o = (r = a[_] || (a[_] = {}))[a.uniqueID] || (r[a.uniqueID] = {}))[f] = [k, h]), a !== e)););
                                return (h -= g) === m || h % m == 0 && 0 <= h / m
                            }
                        }
                    },
                    PSEUDO: function(e, r) {
                        var t, a = b.pseudos[e] || b.setFilters[e.toLowerCase()] || re.error("unsupported pseudo: " + e);
                        return a[_] ? a(r) : 1 < a.length ? (t = [e, e, "", r], b.setFilters.hasOwnProperty(e.toLowerCase()) ? se(function(e, t) {
                            for (var i, n = a(e, r), o = n.length; o--;) e[i = z(e, n[o])] = !(t[i] = n[o])
                        }) : function(e) {
                            return a(e, 0, t)
                        }) : a
                    }
                },
                pseudos: {
                    not: se(function(e) {
                        var n = [],
                            o = [],
                            s = p(e.replace(R, "$1"));
                        return s[_] ? se(function(e, t, i, n) {
                            for (var o, r = s(e, null, n, []), a = e.length; a--;)(o = r[a]) && (e[a] = !(t[a] = o))
                        }) : function(e, t, i) {
                            return n[0] = e, s(n, null, i, o), n[0] = null, !o.pop()
                        }
                    }),
                    has: se(function(t) {
                        return function(e) {
                            return 0 < re(t, e).length
                        }
                    }),
                    contains: se(function(t) {
                        return t = t.replace(te, u),
                            function(e) {
                                return -1 < (e.textContent || e.innerText || r(e)).indexOf(t)
                            }
                    }),
                    lang: se(function(i) {
                        return Q.test(i || "") || re.error("unsupported lang: " + i), i = i.replace(te, u).toLowerCase(),
                            function(e) {
                                var t;
                                do {
                                    if (t = S ? e.lang : e.getAttribute("xml:lang") || e.getAttribute("lang")) return (t = t.toLowerCase()) === i || 0 === t.indexOf(i + "-")
                                } while ((e = e.parentNode) && 1 === e.nodeType);
                                return !1
                            }
                    }),
                    target: function(e) {
                        var t = i.location && i.location.hash;
                        return t && t.slice(1) === e.id
                    },
                    root: function(e) {
                        return e === s
                    },
                    focus: function(e) {
                        return e === C.activeElement && (!C.hasFocus || C.hasFocus()) && !!(e.type || e.href || ~e.tabIndex)
                    },
                    enabled: he(!1),
                    disabled: he(!0),
                    checked: function(e) {
                        var t = e.nodeName.toLowerCase();
                        return "input" === t && !!e.checked || "option" === t && !!e.selected
                    },
                    selected: function(e) {
                        return e.parentNode && e.parentNode.selectedIndex, !0 === e.selected
                    },
                    empty: function(e) {
                        for (e = e.firstChild; e; e = e.nextSibling)
                            if (e.nodeType < 6) return !1;
                        return !0
                    },
                    parent: function(e) {
                        return !b.pseudos.empty(e)
                    },
                    header: function(e) {
                        return J.test(e.nodeName)
                    },
                    input: function(e) {
                        return Y.test(e.nodeName)
                    },
                    button: function(e) {
                        var t = e.nodeName.toLowerCase();
                        return "input" === t && "button" === e.type || "button" === t
                    },
                    text: function(e) {
                        var t;
                        return "input" === e.nodeName.toLowerCase() && "text" === e.type && (null == (t = e.getAttribute("type")) || "text" === t.toLowerCase())
                    },
                    first: fe(function() {
                        return [0]
                    }),
                    last: fe(function(e, t) {
                        return [t - 1]
                    }),
                    eq: fe(function(e, t, i) {
                        return [i < 0 ? i + t : i]
                    }),
                    even: fe(function(e, t) {
                        for (var i = 0; i < t; i += 2) e.push(i);
                        return e
                    }),
                    odd: fe(function(e, t) {
                        for (var i = 1; i < t; i += 2) e.push(i);
                        return e
                    }),
                    lt: fe(function(e, t, i) {
                        for (var n = i < 0 ? i + t : i; 0 <= --n;) e.push(n);
                        return e
                    }),
                    gt: fe(function(e, t, i) {
                        for (var n = i < 0 ? i + t : i; ++n < t;) e.push(n);
                        return e
                    })
                }
            }).pseudos.nth = b.pseudos.eq, {
                radio: !0,
                checkbox: !0,
                file: !0,
                password: !0,
                image: !0
            }) b.pseudos[e] = ue(e);
        for (e in {
                submit: !0,
                reset: !0
            }) b.pseudos[e] = pe(e);

        function ge() {}

        function ye(e) {
            for (var t = 0, i = e.length, n = ""; t < i; t++) n += e[t].value;
            return n
        }

        function ve(s, e, t) {
            var l = e.dir,
                c = e.next,
                d = c || l,
                u = t && "parentNode" === d,
                p = n++;
            return e.first ? function(e, t, i) {
                for (; e = e[l];)
                    if (1 === e.nodeType || u) return s(e, t, i);
                return !1
            } : function(e, t, i) {
                var n, o, r, a = [k, p];
                if (i) {
                    for (; e = e[l];)
                        if ((1 === e.nodeType || u) && s(e, t, i)) return !0
                } else
                    for (; e = e[l];)
                        if (1 === e.nodeType || u)
                            if (o = (r = e[_] || (e[_] = {}))[e.uniqueID] || (r[e.uniqueID] = {}), c && c === e.nodeName.toLowerCase()) e = e[l] || e;
                            else {
                                if ((n = o[d]) && n[0] === k && n[1] === p) return a[2] = n[2];
                                if ((o[d] = a)[2] = s(e, t, i)) return !0
                            } return !1
            }
        }

        function we(o) {
            return 1 < o.length ? function(e, t, i) {
                for (var n = o.length; n--;)
                    if (!o[n](e, t, i)) return !1;
                return !0
            } : o[0]
        }

        function be(e, t, i, n, o) {
            for (var r, a = [], s = 0, l = e.length, c = null != t; s < l; s++)(r = e[s]) && (i && !i(r, n, o) || (a.push(r), c && t.push(s)));
            return a
        }

        function $e(h, f, m, g, y, e) {
            return g && !g[_] && (g = $e(g)), y && !y[_] && (y = $e(y, e)), se(function(e, t, i, n) {
                var o, r, a, s = [],
                    l = [],
                    c = t.length,
                    d = e || function(e, t, i) {
                        for (var n = 0, o = t.length; n < o; n++) re(e, t[n], i);
                        return i
                    }(f || "*", i.nodeType ? [i] : i, []),
                    u = !h || !e && f ? d : be(d, s, h, i, n),
                    p = m ? y || (e ? h : c || g) ? [] : t : u;
                if (m && m(u, p, i, n), g)
                    for (o = be(p, l), g(o, [], i, n), r = o.length; r--;)(a = o[r]) && (p[l[r]] = !(u[l[r]] = a));
                if (e) {
                    if (y || h) {
                        if (y) {
                            for (o = [], r = p.length; r--;)(a = p[r]) && o.push(u[r] = a);
                            y(null, p = [], o, n)
                        }
                        for (r = p.length; r--;)(a = p[r]) && -1 < (o = y ? z(e, a) : s[r]) && (e[o] = !(t[o] = a))
                    }
                } else p = be(p === t ? p.splice(c, p.length) : p), y ? y(null, t, p, n) : L.apply(t, p)
            })
        }

        function xe(e) {
            for (var o, t, i, n = e.length, r = b.relative[e[0].type], a = r || b.relative[" "], s = r ? 1 : 0, l = ve(function(e) {
                    return e === o
                }, a, !0), c = ve(function(e) {
                    return -1 < z(o, e)
                }, a, !0), d = [function(e, t, i) {
                    var n = !r && (i || t !== $) || ((o = t).nodeType ? l(e, t, i) : c(e, t, i));
                    return o = null, n
                }]; s < n; s++)
                if (t = b.relative[e[s].type]) d = [ve(we(d), t)];
                else {
                    if ((t = b.filter[e[s].type].apply(null, e[s].matches))[_]) {
                        for (i = ++s; i < n && !b.relative[e[i].type]; i++);
                        return $e(1 < s && we(d), 1 < s && ye(e.slice(0, s - 1).concat({
                            value: " " === e[s - 2].type ? "*" : ""
                        })).replace(R, "$1"), t, s < i && xe(e.slice(s, i)), i < n && xe(e = e.slice(i)), i < n && ye(e))
                    }
                    d.push(t)
                } return we(d)
        }
        return ge.prototype = b.filters = b.pseudos, b.setFilters = new ge, f = re.tokenize = function(e, t) {
            var i, n, o, r, a, s, l, c = E[e + " "];
            if (c) return t ? 0 : c.slice(0);
            for (a = e, s = [], l = b.preFilter; a;) {
                for (r in i && !(n = W.exec(a)) || (n && (a = a.slice(n[0].length) || a), s.push(o = [])), i = !1, (n = U.exec(a)) && (i = n.shift(), o.push({
                        value: i,
                        type: n[0].replace(R, " ")
                    }), a = a.slice(i.length)), b.filter) !(n = X[r].exec(a)) || l[r] && !(n = l[r](n)) || (i = n.shift(), o.push({
                    value: i,
                    type: r,
                    matches: n
                }), a = a.slice(i.length));
                if (!i) break
            }
            return t ? a.length : a ? re.error(e) : E(e, s).slice(0)
        }, p = re.compile = function(e, t) {
            var i, g, y, v, w, n = [],
                o = [],
                r = j[e + " "];
            if (!r) {
                for (i = (t = t || f(e)).length; i--;)(r = xe(t[i]))[_] ? n.push(r) : o.push(r);
                (r = j(e, (g = o, v = 0 < (y = n).length, w = 0 < g.length, v ? se(a) : a))).selector = e
            }

            function a(e, t, i, n, o) {
                var r, a, s, l = 0,
                    c = "0",
                    d = e && [],
                    u = [],
                    p = $,
                    h = e || w && b.find.TAG("*", o),
                    f = k += null == p ? 1 : Math.random() || .1,
                    m = h.length;
                for (o && ($ = t === C || t || o); c !== m && null != (r = h[c]); c++) {
                    if (w && r) {
                        for (a = 0, t || r.ownerDocument === C || (x(r), i = !S); s = g[a++];)
                            if (s(r, t || C, i)) {
                                n.push(r);
                                break
                            } o && (k = f)
                    }
                    v && ((r = !s && r) && l--, e && d.push(r))
                }
                if (l += c, v && c !== l) {
                    for (a = 0; s = y[a++];) s(d, u, t, i);
                    if (e) {
                        if (0 < l)
                            for (; c--;) d[c] || u[c] || (u[c] = P.call(n));
                        u = be(u)
                    }
                    L.apply(n, u), o && !e && 0 < u.length && 1 < l + y.length && re.uniqueSort(n)
                }
                return o && (k = f, $ = p), d
            }
            return r
        }, m = re.select = function(e, t, i, n) {
            var o, r, a, s, l, c = "function" == typeof e && e,
                d = !n && f(e = c.selector || e);
            if (i = i || [], 1 === d.length) {
                if (2 < (r = d[0] = d[0].slice(0)).length && "ID" === (a = r[0]).type && 9 === t.nodeType && S && b.relative[r[1].type]) {
                    if (!(t = (b.find.ID(a.matches[0].replace(te, u), t) || [])[0])) return i;
                    c && (t = t.parentNode), e = e.slice(r.shift().value.length)
                }
                for (o = X.needsContext.test(e) ? 0 : r.length; o-- && (a = r[o], !b.relative[s = a.type]);)
                    if ((l = b.find[s]) && (n = l(a.matches[0].replace(te, u), ee.test(r[0].type) && me(t.parentNode) || t))) {
                        if (r.splice(o, 1), !(e = n.length && ye(r))) return L.apply(i, n), i;
                        break
                    }
            }
            return (c || p(e, d))(n, t, !S, i, !t || ee.test(e) && me(t.parentNode) || t), i
        }, h.sortStable = _.split("").sort(A).join("") === _, h.detectDuplicates = !!c, x(), h.sortDetached = le(function(e) {
            return 1 & e.compareDocumentPosition(C.createElement("fieldset"))
        }), le(function(e) {
            return e.innerHTML = "<a href='#'></a>", "#" === e.firstChild.getAttribute("href")
        }) || ce("type|href|height|width", function(e, t, i) {
            if (!i) return e.getAttribute(t, "type" === t.toLowerCase() ? 1 : 2)
        }), h.attributes && le(function(e) {
            return e.innerHTML = "<input/>", e.firstChild.setAttribute("value", ""), "" === e.firstChild.getAttribute("value")
        }) || ce("value", function(e, t, i) {
            if (!i && "input" === e.nodeName.toLowerCase()) return e.defaultValue
        }), le(function(e) {
            return null == e.getAttribute("disabled")
        }) || ce(q, function(e, t, i) {
            var n;
            if (!i) return !0 === e[t] ? t.toLowerCase() : (n = e.getAttributeNode(t)) && n.specified ? n.value : null
        }), re
    }(C);

    function f(e, t, i) {
        for (var n = [], o = void 0 !== i;
            (e = e[t]) && 9 !== e.nodeType;)
            if (1 === e.nodeType) {
                if (o && _(e).is(i)) break;
                n.push(e)
            } return n
    }

    function x(e, t) {
        for (var i = []; e; e = e.nextSibling) 1 === e.nodeType && e !== t && i.push(e);
        return i
    }
    _.find = h, _.expr = h.selectors, _.expr[":"] = _.expr.pseudos, _.uniqueSort = _.unique = h.uniqueSort, _.text = h.getText, _.isXMLDoc = h.isXML, _.contains = h.contains, _.escapeSelector = h.escape;
    var k = _.expr.match.needsContext;

    function T(e, t) {
        return e.nodeName && e.nodeName.toLowerCase() === t.toLowerCase()
    }
    var E = /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i;

    function j(e, i, n) {
        return w(i) ? _.grep(e, function(e, t) {
            return !!i.call(e, t, e) !== n
        }) : i.nodeType ? _.grep(e, function(e) {
            return e === i !== n
        }) : "string" != typeof i ? _.grep(e, function(e) {
            return -1 < o.call(i, e) !== n
        }) : _.filter(i, e, n)
    }
    _.filter = function(e, t, i) {
        var n = t[0];
        return i && (e = ":not(" + e + ")"), 1 === t.length && 1 === n.nodeType ? _.find.matchesSelector(n, e) ? [n] : [] : _.find.matches(e, _.grep(t, function(e) {
            return 1 === e.nodeType
        }))
    }, _.fn.extend({
        find: function(e) {
            var t, i, n = this.length,
                o = this;
            if ("string" != typeof e) return this.pushStack(_(e).filter(function() {
                for (t = 0; t < n; t++)
                    if (_.contains(o[t], this)) return !0
            }));
            for (i = this.pushStack([]), t = 0; t < n; t++) _.find(e, o[t], i);
            return 1 < n ? _.uniqueSort(i) : i
        },
        filter: function(e) {
            return this.pushStack(j(this, e || [], !1))
        },
        not: function(e) {
            return this.pushStack(j(this, e || [], !0))
        },
        is: function(e) {
            return !!j(this, "string" == typeof e && k.test(e) ? _(e) : e || [], !1).length
        }
    });
    var A, D = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/;
    (_.fn.init = function(e, t, i) {
        var n, o;
        if (!e) return this;
        if (i = i || A, "string" != typeof e) return e.nodeType ? (this[0] = e, this.length = 1, this) : w(e) ? void 0 !== i.ready ? i.ready(e) : e(_) : _.makeArray(e, this);
        if (!(n = "<" === e[0] && ">" === e[e.length - 1] && 3 <= e.length ? [null, e, null] : D.exec(e)) || !n[1] && t) return !t || t.jquery ? (t || i).find(e) : this.constructor(t).find(e);
        if (n[1]) {
            if (t = t instanceof _ ? t[0] : t, _.merge(this, _.parseHTML(n[1], t && t.nodeType ? t.ownerDocument || t : S, !0)), E.test(n[1]) && _.isPlainObject(t))
                for (n in t) w(this[n]) ? this[n](t[n]) : this.attr(n, t[n]);
            return this
        }
        return (o = S.getElementById(n[2])) && (this[0] = o, this.length = 1), this
    }).prototype = _.fn, A = _(S);
    var P = /^(?:parents|prev(?:Until|All))/,
        I = {
            children: !0,
            contents: !0,
            next: !0,
            prev: !0
        };

    function L(e, t) {
        for (;
            (e = e[t]) && 1 !== e.nodeType;);
        return e
    }
    _.fn.extend({
        has: function(e) {
            var t = _(e, this),
                i = t.length;
            return this.filter(function() {
                for (var e = 0; e < i; e++)
                    if (_.contains(this, t[e])) return !0
            })
        },
        closest: function(e, t) {
            var i, n = 0,
                o = this.length,
                r = [],
                a = "string" != typeof e && _(e);
            if (!k.test(e))
                for (; n < o; n++)
                    for (i = this[n]; i && i !== t; i = i.parentNode)
                        if (i.nodeType < 11 && (a ? -1 < a.index(i) : 1 === i.nodeType && _.find.matchesSelector(i, e))) {
                            r.push(i);
                            break
                        } return this.pushStack(1 < r.length ? _.uniqueSort(r) : r)
        },
        index: function(e) {
            return e ? "string" == typeof e ? o.call(_(e), this[0]) : o.call(this, e.jquery ? e[0] : e) : this[0] && this[0].parentNode ? this.first().prevAll().length : -1
        },
        add: function(e, t) {
            return this.pushStack(_.uniqueSort(_.merge(this.get(), _(e, t))))
        },
        addBack: function(e) {
            return this.add(null == e ? this.prevObject : this.prevObject.filter(e))
        }
    }), _.each({
        parent: function(e) {
            var t = e.parentNode;
            return t && 11 !== t.nodeType ? t : null
        },
        parents: function(e) {
            return f(e, "parentNode")
        },
        parentsUntil: function(e, t, i) {
            return f(e, "parentNode", i)
        },
        next: function(e) {
            return L(e, "nextSibling")
        },
        prev: function(e) {
            return L(e, "previousSibling")
        },
        nextAll: function(e) {
            return f(e, "nextSibling")
        },
        prevAll: function(e) {
            return f(e, "previousSibling")
        },
        nextUntil: function(e, t, i) {
            return f(e, "nextSibling", i)
        },
        prevUntil: function(e, t, i) {
            return f(e, "previousSibling", i)
        },
        siblings: function(e) {
            return x((e.parentNode || {}).firstChild, e)
        },
        children: function(e) {
            return x(e.firstChild)
        },
        contents: function(e) {
            return T(e, "iframe") ? e.contentDocument : (T(e, "template") && (e = e.content || e), _.merge([], e.childNodes))
        }
    }, function(n, o) {
        _.fn[n] = function(e, t) {
            var i = _.map(this, o, e);
            return "Until" !== n.slice(-5) && (t = e), t && "string" == typeof t && (i = _.filter(t, i)), 1 < this.length && (I[n] || _.uniqueSort(i), P.test(n) && i.reverse()), this.pushStack(i)
        }
    });
    var N = /[^\x20\t\r\n\f]+/g;

    function z(e) {
        return e
    }

    function q(e) {
        throw e
    }

    function O(e, t, i, n) {
        var o;
        try {
            e && w(o = e.promise) ? o.call(e).done(t).fail(i) : e && w(o = e.then) ? o.call(e, t, i) : t.apply(void 0, [e].slice(n))
        } catch (e) {
            i.apply(void 0, [e])
        }
    }
    _.Callbacks = function(n) {
        var e, i;

        function o() {
            for (s = s || n.once, a = r = !0; c.length; d = -1)
                for (t = c.shift(); ++d < l.length;) !1 === l[d].apply(t[0], t[1]) && n.stopOnFalse && (d = l.length, t = !1);
            n.memory || (t = !1), r = !1, s && (l = t ? [] : "")
        }
        n = "string" == typeof n ? (e = n, i = {}, _.each(e.match(N) || [], function(e, t) {
            i[t] = !0
        }), i) : _.extend({}, n);
        var r, t, a, s, l = [],
            c = [],
            d = -1,
            u = {
                add: function() {
                    return l && (t && !r && (d = l.length - 1, c.push(t)), function i(e) {
                        _.each(e, function(e, t) {
                            w(t) ? n.unique && u.has(t) || l.push(t) : t && t.length && "string" !== $(t) && i(t)
                        })
                    }(arguments), t && !r && o()), this
                },
                remove: function() {
                    return _.each(arguments, function(e, t) {
                        for (var i; - 1 < (i = _.inArray(t, l, i));) l.splice(i, 1), i <= d && d--
                    }), this
                },
                has: function(e) {
                    return e ? -1 < _.inArray(e, l) : 0 < l.length
                },
                empty: function() {
                    return l = l && [], this
                },
                disable: function() {
                    return s = c = [], l = t = "", this
                },
                disabled: function() {
                    return !l
                },
                lock: function() {
                    return s = c = [], t || r || (l = t = ""), this
                },
                locked: function() {
                    return !!s
                },
                fireWith: function(e, t) {
                    return s || (t = [e, (t = t || []).slice ? t.slice() : t], c.push(t), r || o()), this
                },
                fire: function() {
                    return u.fireWith(this, arguments), this
                },
                fired: function() {
                    return !!a
                }
            };
        return u
    }, _.extend({
        Deferred: function(e) {
            var r = [
                    ["notify", "progress", _.Callbacks("memory"), _.Callbacks("memory"), 2],
                    ["resolve", "done", _.Callbacks("once memory"), _.Callbacks("once memory"), 0, "resolved"],
                    ["reject", "fail", _.Callbacks("once memory"), _.Callbacks("once memory"), 1, "rejected"]
                ],
                o = "pending",
                a = {
                    state: function() {
                        return o
                    },
                    always: function() {
                        return s.done(arguments).fail(arguments), this
                    },
                    catch: function(e) {
                        return a.then(null, e)
                    },
                    pipe: function() {
                        var o = arguments;
                        return _.Deferred(function(n) {
                            _.each(r, function(e, t) {
                                var i = w(o[t[4]]) && o[t[4]];
                                s[t[1]](function() {
                                    var e = i && i.apply(this, arguments);
                                    e && w(e.promise) ? e.promise().progress(n.notify).done(n.resolve).fail(n.reject) : n[t[0] + "With"](this, i ? [e] : arguments)
                                })
                            }), o = null
                        }).promise()
                    },
                    then: function(t, i, n) {
                        var l = 0;

                        function c(o, r, a, s) {
                            return function() {
                                function e() {
                                    var e, t;
                                    if (!(o < l)) {
                                        if ((e = a.apply(i, n)) === r.promise()) throw new TypeError("Thenable self-resolution");
                                        t = e && ("object" == typeof e || "function" == typeof e) && e.then, w(t) ? s ? t.call(e, c(l, r, z, s), c(l, r, q, s)) : (l++, t.call(e, c(l, r, z, s), c(l, r, q, s), c(l, r, z, r.notifyWith))) : (a !== z && (i = void 0, n = [e]), (s || r.resolveWith)(i, n))
                                    }
                                }
                                var i = this,
                                    n = arguments,
                                    t = s ? e : function() {
                                        try {
                                            e()
                                        } catch (e) {
                                            _.Deferred.exceptionHook && _.Deferred.exceptionHook(e, t.stackTrace), l <= o + 1 && (a !== q && (i = void 0, n = [e]), r.rejectWith(i, n))
                                        }
                                    };
                                o ? t() : (_.Deferred.getStackHook && (t.stackTrace = _.Deferred.getStackHook()), C.setTimeout(t))
                            }
                        }
                        return _.Deferred(function(e) {
                            r[0][3].add(c(0, e, w(n) ? n : z, e.notifyWith)), r[1][3].add(c(0, e, w(t) ? t : z)), r[2][3].add(c(0, e, w(i) ? i : q))
                        }).promise()
                    },
                    promise: function(e) {
                        return null != e ? _.extend(e, a) : a
                    }
                },
                s = {};
            return _.each(r, function(e, t) {
                var i = t[2],
                    n = t[5];
                a[t[1]] = i.add, n && i.add(function() {
                    o = n
                }, r[3 - e][2].disable, r[3 - e][3].disable, r[0][2].lock, r[0][3].lock), i.add(t[3].fire), s[t[0]] = function() {
                    return s[t[0] + "With"](this === s ? void 0 : this, arguments), this
                }, s[t[0] + "With"] = i.fireWith
            }), a.promise(s), e && e.call(s, s), s
        },
        when: function(e) {
            function t(t) {
                return function(e) {
                    o[t] = this, r[t] = 1 < arguments.length ? s.call(arguments) : e, --i || a.resolveWith(o, r)
                }
            }
            var i = arguments.length,
                n = i,
                o = Array(n),
                r = s.call(arguments),
                a = _.Deferred();
            if (i <= 1 && (O(e, a.done(t(n)).resolve, a.reject, !i), "pending" === a.state() || w(r[n] && r[n].then))) return a.then();
            for (; n--;) O(r[n], t(n), a.reject);
            return a.promise()
        }
    });
    var M = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;
    _.Deferred.exceptionHook = function(e, t) {
        C.console && C.console.warn && e && M.test(e.name) && C.console.warn("jQuery.Deferred exception: " + e.message, e.stack, t)
    }, _.readyException = function(e) {
        C.setTimeout(function() {
            throw e
        })
    };
    var F = _.Deferred();

    function B() {
        S.removeEventListener("DOMContentLoaded", B), C.removeEventListener("load", B), _.ready()
    }
    _.fn.ready = function(e) {
        return F.then(e).catch(function(e) {
            _.readyException(e)
        }), this
    }, _.extend({
        isReady: !1,
        readyWait: 1,
        ready: function(e) {
            (!0 === e ? --_.readyWait : _.isReady) || (_.isReady = !0) !== e && 0 < --_.readyWait || F.resolveWith(S, [_])
        }
    }), _.ready.then = F.then, "complete" === S.readyState || "loading" !== S.readyState && !S.documentElement.doScroll ? C.setTimeout(_.ready) : (S.addEventListener("DOMContentLoaded", B), C.addEventListener("load", B));
    var H = function(e, t, i, n, o, r, a) {
            var s = 0,
                l = e.length,
                c = null == i;
            if ("object" === $(i))
                for (s in o = !0, i) H(e, t, s, i[s], !0, r, a);
            else if (void 0 !== n && (o = !0, w(n) || (a = !0), c && (t = a ? (t.call(e, n), null) : (c = t, function(e, t, i) {
                    return c.call(_(e), i)
                })), t))
                for (; s < l; s++) t(e[s], i, a ? n : n.call(e[s], s, t(e[s], i)));
            return o ? e : c ? t.call(e) : l ? t(e[0], i) : r
        },
        R = /^-ms-/,
        W = /-([a-z])/g;

    function U(e, t) {
        return t.toUpperCase()
    }

    function V(e) {
        return e.replace(R, "ms-").replace(W, U)
    }

    function G(e) {
        return 1 === e.nodeType || 9 === e.nodeType || !+e.nodeType
    }

    function Q() {
        this.expando = _.expando + Q.uid++
    }
    Q.uid = 1, Q.prototype = {
        cache: function(e) {
            var t = e[this.expando];
            return t || (t = {}, G(e) && (e.nodeType ? e[this.expando] = t : Object.defineProperty(e, this.expando, {
                value: t,
                configurable: !0
            }))), t
        },
        set: function(e, t, i) {
            var n, o = this.cache(e);
            if ("string" == typeof t) o[V(t)] = i;
            else
                for (n in t) o[V(n)] = t[n];
            return o
        },
        get: function(e, t) {
            return void 0 === t ? this.cache(e) : e[this.expando] && e[this.expando][V(t)]
        },
        access: function(e, t, i) {
            return void 0 === t || t && "string" == typeof t && void 0 === i ? this.get(e, t) : (this.set(e, t, i), void 0 !== i ? i : t)
        },
        remove: function(e, t) {
            var i, n = e[this.expando];
            if (void 0 !== n) {
                if (void 0 !== t) {
                    i = (t = Array.isArray(t) ? t.map(V) : (t = V(t)) in n ? [t] : t.match(N) || []).length;
                    for (; i--;) delete n[t[i]]
                }
                void 0 !== t && !_.isEmptyObject(n) || (e.nodeType ? e[this.expando] = void 0 : delete e[this.expando])
            }
        },
        hasData: function(e) {
            var t = e[this.expando];
            return void 0 !== t && !_.isEmptyObject(t)
        }
    };
    var X = new Q,
        Y = new Q,
        J = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
        Z = /[A-Z]/g;

    function K(e, t, i) {
        var n, o;
        if (void 0 === i && 1 === e.nodeType)
            if (n = "data-" + t.replace(Z, "-$&").toLowerCase(), "string" == typeof(i = e.getAttribute(n))) {
                try {
                    i = "true" === (o = i) || "false" !== o && ("null" === o ? null : o === +o + "" ? +o : J.test(o) ? JSON.parse(o) : o)
                } catch (e) {}
                Y.set(e, t, i)
            } else i = void 0;
        return i
    }

    function ee(e, t) {
        return "none" === (e = t || e).style.display || "" === e.style.display && _.contains(e.ownerDocument, e) && "none" === _.css(e, "display")
    }

    function te(e, t, i, n) {
        var o, r, a = {};
        for (r in t) a[r] = e.style[r], e.style[r] = t[r];
        for (r in o = i.apply(e, n || []), t) e.style[r] = a[r];
        return o
    }
    _.extend({
        hasData: function(e) {
            return Y.hasData(e) || X.hasData(e)
        },
        data: function(e, t, i) {
            return Y.access(e, t, i)
        },
        removeData: function(e, t) {
            Y.remove(e, t)
        },
        _data: function(e, t, i) {
            return X.access(e, t, i)
        },
        _removeData: function(e, t) {
            X.remove(e, t)
        }
    }), _.fn.extend({
        data: function(i, e) {
            var t, n, o, r = this[0],
                a = r && r.attributes;
            if (void 0 !== i) return "object" == typeof i ? this.each(function() {
                Y.set(this, i)
            }) : H(this, function(e) {
                var t;
                if (r && void 0 === e) {
                    if (void 0 !== (t = Y.get(r, i))) return t;
                    if (void 0 !== (t = K(r, i))) return t
                } else this.each(function() {
                    Y.set(this, i, e)
                })
            }, null, e, 1 < arguments.length, null, !0);
            if (this.length && (o = Y.get(r), 1 === r.nodeType && !X.get(r, "hasDataAttrs"))) {
                for (t = a.length; t--;) a[t] && 0 === (n = a[t].name).indexOf("data-") && (n = V(n.slice(5)), K(r, n, o[n]));
                X.set(r, "hasDataAttrs", !0)
            }
            return o
        },
        removeData: function(e) {
            return this.each(function() {
                Y.remove(this, e)
            })
        }
    }), _.extend({
        queue: function(e, t, i) {
            var n;
            if (e) return t = (t || "fx") + "queue", n = X.get(e, t), i && (!n || Array.isArray(i) ? n = X.access(e, t, _.makeArray(i)) : n.push(i)), n || []
        },
        dequeue: function(e, t) {
            t = t || "fx";
            var i = _.queue(e, t),
                n = i.length,
                o = i.shift(),
                r = _._queueHooks(e, t);
            "inprogress" === o && (o = i.shift(), n--), o && ("fx" === t && i.unshift("inprogress"), delete r.stop, o.call(e, function() {
                _.dequeue(e, t)
            }, r)), !n && r && r.empty.fire()
        },
        _queueHooks: function(e, t) {
            var i = t + "queueHooks";
            return X.get(e, i) || X.access(e, i, {
                empty: _.Callbacks("once memory").add(function() {
                    X.remove(e, [t + "queue", i])
                })
            })
        }
    }), _.fn.extend({
        queue: function(t, i) {
            var e = 2;
            return "string" != typeof t && (i = t, t = "fx", e--), arguments.length < e ? _.queue(this[0], t) : void 0 === i ? this : this.each(function() {
                var e = _.queue(this, t, i);
                _._queueHooks(this, t), "fx" === t && "inprogress" !== e[0] && _.dequeue(this, t)
            })
        },
        dequeue: function(e) {
            return this.each(function() {
                _.dequeue(this, e)
            })
        },
        clearQueue: function(e) {
            return this.queue(e || "fx", [])
        },
        promise: function(e, t) {
            function i() {
                --o || r.resolveWith(a, [a])
            }
            var n, o = 1,
                r = _.Deferred(),
                a = this,
                s = this.length;
            for ("string" != typeof e && (t = e, e = void 0), e = e || "fx"; s--;)(n = X.get(a[s], e + "queueHooks")) && n.empty && (o++, n.empty.add(i));
            return i(), r.promise(t)
        }
    });
    var ie = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source,
        ne = new RegExp("^(?:([+-])=|)(" + ie + ")([a-z%]*)$", "i"),
        oe = ["Top", "Right", "Bottom", "Left"];

    function re(e, t, i, n) {
        var o, r, a = 20,
            s = n ? function() {
                return n.cur()
            } : function() {
                return _.css(e, t, "")
            },
            l = s(),
            c = i && i[3] || (_.cssNumber[t] ? "" : "px"),
            d = (_.cssNumber[t] || "px" !== c && +l) && ne.exec(_.css(e, t));
        if (d && d[3] !== c) {
            for (l /= 2, c = c || d[3], d = +l || 1; a--;) _.style(e, t, d + c), (1 - r) * (1 - (r = s() / l || .5)) <= 0 && (a = 0), d /= r;
            d *= 2, _.style(e, t, d + c), i = i || []
        }
        return i && (d = +d || +l || 0, o = i[1] ? d + (i[1] + 1) * i[2] : +i[2], n && (n.unit = c, n.start = d, n.end = o)), o
    }
    var ae = {};

    function se(e, t) {
        for (var i, n, o = [], r = 0, a = e.length; r < a; r++)(n = e[r]).style && (i = n.style.display, t ? ("none" === i && (o[r] = X.get(n, "display") || null, o[r] || (n.style.display = "")), "" === n.style.display && ee(n) && (o[r] = (u = c = l = void 0, c = (s = n).ownerDocument, d = s.nodeName, (u = ae[d]) || (l = c.body.appendChild(c.createElement(d)), u = _.css(l, "display"), l.parentNode.removeChild(l), "none" === u && (u = "block"), ae[d] = u)))) : "none" !== i && (o[r] = "none", X.set(n, "display", i)));
        var s, l, c, d, u;
        for (r = 0; r < a; r++) null != o[r] && (e[r].style.display = o[r]);
        return e
    }
    _.fn.extend({
        show: function() {
            return se(this, !0)
        },
        hide: function() {
            return se(this)
        },
        toggle: function(e) {
            return "boolean" == typeof e ? e ? this.show() : this.hide() : this.each(function() {
                ee(this) ? _(this).show() : _(this).hide()
            })
        }
    });
    var le = /^(?:checkbox|radio)$/i,
        ce = /<([a-z][^\/\0>\x20\t\r\n\f]+)/i,
        de = /^$|^module$|\/(?:java|ecma)script/i,
        ue = {
            option: [1, "<select multiple='multiple'>", "</select>"],
            thead: [1, "<table>", "</table>"],
            col: [2, "<table><colgroup>", "</colgroup></table>"],
            tr: [2, "<table><tbody>", "</tbody></table>"],
            td: [3, "<table><tbody><tr>", "</tr></tbody></table>"],
            _default: [0, "", ""]
        };

    function pe(e, t) {
        var i;
        return i = void 0 !== e.getElementsByTagName ? e.getElementsByTagName(t || "*") : void 0 !== e.querySelectorAll ? e.querySelectorAll(t || "*") : [], void 0 === t || t && T(e, t) ? _.merge([e], i) : i
    }

    function he(e, t) {
        for (var i = 0, n = e.length; i < n; i++) X.set(e[i], "globalEval", !t || X.get(t[i], "globalEval"))
    }
    ue.optgroup = ue.option, ue.tbody = ue.tfoot = ue.colgroup = ue.caption = ue.thead, ue.th = ue.td;
    var fe, me, ge = /<|&#?\w+;/;

    function ye(e, t, i, n, o) {
        for (var r, a, s, l, c, d, u = t.createDocumentFragment(), p = [], h = 0, f = e.length; h < f; h++)
            if ((r = e[h]) || 0 === r)
                if ("object" === $(r)) _.merge(p, r.nodeType ? [r] : r);
                else if (ge.test(r)) {
            for (a = a || u.appendChild(t.createElement("div")), s = (ce.exec(r) || ["", ""])[1].toLowerCase(), l = ue[s] || ue._default, a.innerHTML = l[1] + _.htmlPrefilter(r) + l[2], d = l[0]; d--;) a = a.lastChild;
            _.merge(p, a.childNodes), (a = u.firstChild).textContent = ""
        } else p.push(t.createTextNode(r));
        for (u.textContent = "", h = 0; r = p[h++];)
            if (n && -1 < _.inArray(r, n)) o && o.push(r);
            else if (c = _.contains(r.ownerDocument, r), a = pe(u.appendChild(r), "script"), c && he(a), i)
            for (d = 0; r = a[d++];) de.test(r.type || "") && i.push(r);
        return u
    }
    fe = S.createDocumentFragment().appendChild(S.createElement("div")), (me = S.createElement("input")).setAttribute("type", "radio"), me.setAttribute("checked", "checked"), me.setAttribute("name", "t"), fe.appendChild(me), v.checkClone = fe.cloneNode(!0).cloneNode(!0).lastChild.checked, fe.innerHTML = "<textarea>x</textarea>", v.noCloneChecked = !!fe.cloneNode(!0).lastChild.defaultValue;
    var ve = S.documentElement,
        we = /^key/,
        be = /^(?:mouse|pointer|contextmenu|drag|drop)|click/,
        $e = /^([^.]*)(?:\.(.+)|)/;

    function xe() {
        return !0
    }

    function Ce() {
        return !1
    }

    function Se() {
        try {
            return S.activeElement
        } catch (e) {}
    }

    function _e(e, t, i, n, o, r) {
        var a, s;
        if ("object" == typeof t) {
            for (s in "string" != typeof i && (n = n || i, i = void 0), t) _e(e, s, i, n, t[s], r);
            return e
        }
        if (null == n && null == o ? (o = i, n = i = void 0) : null == o && ("string" == typeof i ? (o = n, n = void 0) : (o = n, n = i, i = void 0)), !1 === o) o = Ce;
        else if (!o) return e;
        return 1 === r && (a = o, (o = function(e) {
            return _().off(e), a.apply(this, arguments)
        }).guid = a.guid || (a.guid = _.guid++)), e.each(function() {
            _.event.add(this, t, o, n, i)
        })
    }
    _.event = {
        global: {},
        add: function(t, e, i, n, o) {
            var r, a, s, l, c, d, u, p, h, f, m, g = X.get(t);
            if (g)
                for (i.handler && (i = (r = i).handler, o = r.selector), o && _.find.matchesSelector(ve, o), i.guid || (i.guid = _.guid++), (l = g.events) || (l = g.events = {}), (a = g.handle) || (a = g.handle = function(e) {
                        return void 0 !== _ && _.event.triggered !== e.type ? _.event.dispatch.apply(t, arguments) : void 0
                    }), c = (e = (e || "").match(N) || [""]).length; c--;) h = m = (s = $e.exec(e[c]) || [])[1], f = (s[2] || "").split(".").sort(), h && (u = _.event.special[h] || {}, h = (o ? u.delegateType : u.bindType) || h, u = _.event.special[h] || {}, d = _.extend({
                    type: h,
                    origType: m,
                    data: n,
                    handler: i,
                    guid: i.guid,
                    selector: o,
                    needsContext: o && _.expr.match.needsContext.test(o),
                    namespace: f.join(".")
                }, r), (p = l[h]) || ((p = l[h] = []).delegateCount = 0, u.setup && !1 !== u.setup.call(t, n, f, a) || t.addEventListener && t.addEventListener(h, a)), u.add && (u.add.call(t, d), d.handler.guid || (d.handler.guid = i.guid)), o ? p.splice(p.delegateCount++, 0, d) : p.push(d), _.event.global[h] = !0)
        },
        remove: function(e, t, i, n, o) {
            var r, a, s, l, c, d, u, p, h, f, m, g = X.hasData(e) && X.get(e);
            if (g && (l = g.events)) {
                for (c = (t = (t || "").match(N) || [""]).length; c--;)
                    if (h = m = (s = $e.exec(t[c]) || [])[1], f = (s[2] || "").split(".").sort(), h) {
                        for (u = _.event.special[h] || {}, p = l[h = (n ? u.delegateType : u.bindType) || h] || [], s = s[2] && new RegExp("(^|\\.)" + f.join("\\.(?:.*\\.|)") + "(\\.|$)"), a = r = p.length; r--;) d = p[r], !o && m !== d.origType || i && i.guid !== d.guid || s && !s.test(d.namespace) || n && n !== d.selector && ("**" !== n || !d.selector) || (p.splice(r, 1), d.selector && p.delegateCount--, u.remove && u.remove.call(e, d));
                        a && !p.length && (u.teardown && !1 !== u.teardown.call(e, f, g.handle) || _.removeEvent(e, h, g.handle), delete l[h])
                    } else
                        for (h in l) _.event.remove(e, h + t[c], i, n, !0);
                _.isEmptyObject(l) && X.remove(e, "handle events")
            }
        },
        dispatch: function(e) {
            var t, i, n, o, r, a, s = _.event.fix(e),
                l = new Array(arguments.length),
                c = (X.get(this, "events") || {})[s.type] || [],
                d = _.event.special[s.type] || {};
            for (l[0] = s, t = 1; t < arguments.length; t++) l[t] = arguments[t];
            if (s.delegateTarget = this, !d.preDispatch || !1 !== d.preDispatch.call(this, s)) {
                for (a = _.event.handlers.call(this, s, c), t = 0;
                    (o = a[t++]) && !s.isPropagationStopped();)
                    for (s.currentTarget = o.elem, i = 0;
                        (r = o.handlers[i++]) && !s.isImmediatePropagationStopped();) s.rnamespace && !s.rnamespace.test(r.namespace) || (s.handleObj = r, s.data = r.data, void 0 !== (n = ((_.event.special[r.origType] || {}).handle || r.handler).apply(o.elem, l)) && !1 === (s.result = n) && (s.preventDefault(), s.stopPropagation()));
                return d.postDispatch && d.postDispatch.call(this, s), s.result
            }
        },
        handlers: function(e, t) {
            var i, n, o, r, a, s = [],
                l = t.delegateCount,
                c = e.target;
            if (l && c.nodeType && !("click" === e.type && 1 <= e.button))
                for (; c !== this; c = c.parentNode || this)
                    if (1 === c.nodeType && ("click" !== e.type || !0 !== c.disabled)) {
                        for (r = [], a = {}, i = 0; i < l; i++) void 0 === a[o = (n = t[i]).selector + " "] && (a[o] = n.needsContext ? -1 < _(o, this).index(c) : _.find(o, this, null, [c]).length), a[o] && r.push(n);
                        r.length && s.push({
                            elem: c,
                            handlers: r
                        })
                    } return c = this, l < t.length && s.push({
                elem: c,
                handlers: t.slice(l)
            }), s
        },
        addProp: function(t, e) {
            Object.defineProperty(_.Event.prototype, t, {
                enumerable: !0,
                configurable: !0,
                get: w(e) ? function() {
                    if (this.originalEvent) return e(this.originalEvent)
                } : function() {
                    if (this.originalEvent) return this.originalEvent[t]
                },
                set: function(e) {
                    Object.defineProperty(this, t, {
                        enumerable: !0,
                        configurable: !0,
                        writable: !0,
                        value: e
                    })
                }
            })
        },
        fix: function(e) {
            return e[_.expando] ? e : new _.Event(e)
        },
        special: {
            load: {
                noBubble: !0
            },
            focus: {
                trigger: function() {
                    if (this !== Se() && this.focus) return this.focus(), !1
                },
                delegateType: "focusin"
            },
            blur: {
                trigger: function() {
                    if (this === Se() && this.blur) return this.blur(), !1
                },
                delegateType: "focusout"
            },
            click: {
                trigger: function() {
                    if ("checkbox" === this.type && this.click && T(this, "input")) return this.click(), !1
                },
                _default: function(e) {
                    return T(e.target, "a")
                }
            },
            beforeunload: {
                postDispatch: function(e) {
                    void 0 !== e.result && e.originalEvent && (e.originalEvent.returnValue = e.result)
                }
            }
        }
    }, _.removeEvent = function(e, t, i) {
        e.removeEventListener && e.removeEventListener(t, i)
    }, _.Event = function(e, t) {
        if (!(this instanceof _.Event)) return new _.Event(e, t);
        e && e.type ? (this.originalEvent = e, this.type = e.type, this.isDefaultPrevented = e.defaultPrevented || void 0 === e.defaultPrevented && !1 === e.returnValue ? xe : Ce, this.target = e.target && 3 === e.target.nodeType ? e.target.parentNode : e.target, this.currentTarget = e.currentTarget, this.relatedTarget = e.relatedTarget) : this.type = e, t && _.extend(this, t), this.timeStamp = e && e.timeStamp || Date.now(), this[_.expando] = !0
    }, _.Event.prototype = {
        constructor: _.Event,
        isDefaultPrevented: Ce,
        isPropagationStopped: Ce,
        isImmediatePropagationStopped: Ce,
        isSimulated: !1,
        preventDefault: function() {
            var e = this.originalEvent;
            this.isDefaultPrevented = xe, e && !this.isSimulated && e.preventDefault()
        },
        stopPropagation: function() {
            var e = this.originalEvent;
            this.isPropagationStopped = xe, e && !this.isSimulated && e.stopPropagation()
        },
        stopImmediatePropagation: function() {
            var e = this.originalEvent;
            this.isImmediatePropagationStopped = xe, e && !this.isSimulated && e.stopImmediatePropagation(), this.stopPropagation()
        }
    }, _.each({
        altKey: !0,
        bubbles: !0,
        cancelable: !0,
        changedTouches: !0,
        ctrlKey: !0,
        detail: !0,
        eventPhase: !0,
        metaKey: !0,
        pageX: !0,
        pageY: !0,
        shiftKey: !0,
        view: !0,
        char: !0,
        charCode: !0,
        key: !0,
        keyCode: !0,
        button: !0,
        buttons: !0,
        clientX: !0,
        clientY: !0,
        offsetX: !0,
        offsetY: !0,
        pointerId: !0,
        pointerType: !0,
        screenX: !0,
        screenY: !0,
        targetTouches: !0,
        toElement: !0,
        touches: !0,
        which: function(e) {
            var t = e.button;
            return null == e.which && we.test(e.type) ? null != e.charCode ? e.charCode : e.keyCode : !e.which && void 0 !== t && be.test(e.type) ? 1 & t ? 1 : 2 & t ? 3 : 4 & t ? 2 : 0 : e.which
        }
    }, _.event.addProp), _.each({
        mouseenter: "mouseover",
        mouseleave: "mouseout",
        pointerenter: "pointerover",
        pointerleave: "pointerout"
    }, function(e, o) {
        _.event.special[e] = {
            delegateType: o,
            bindType: o,
            handle: function(e) {
                var t, i = e.relatedTarget,
                    n = e.handleObj;
                return i && (i === this || _.contains(this, i)) || (e.type = n.origType, t = n.handler.apply(this, arguments), e.type = o), t
            }
        }
    }), _.fn.extend({
        on: function(e, t, i, n) {
            return _e(this, e, t, i, n)
        },
        one: function(e, t, i, n) {
            return _e(this, e, t, i, n, 1)
        },
        off: function(e, t, i) {
            var n, o;
            if (e && e.preventDefault && e.handleObj) return n = e.handleObj, _(e.delegateTarget).off(n.namespace ? n.origType + "." + n.namespace : n.origType, n.selector, n.handler), this;
            if ("object" != typeof e) return !1 !== t && "function" != typeof t || (i = t, t = void 0), !1 === i && (i = Ce), this.each(function() {
                _.event.remove(this, e, i, t)
            });
            for (o in e) this.off(o, t, e[o]);
            return this
        }
    });
    var ke = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([a-z][^\/\0>\x20\t\r\n\f]*)[^>]*)\/>/gi,
        Te = /<script|<style|<link/i,
        Ee = /checked\s*(?:[^=]|=\s*.checked.)/i,
        je = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;

    function Ae(e, t) {
        return T(e, "table") && T(11 !== t.nodeType ? t : t.firstChild, "tr") && _(e).children("tbody")[0] || e
    }

    function De(e) {
        return e.type = (null !== e.getAttribute("type")) + "/" + e.type, e
    }

    function Pe(e) {
        return "true/" === (e.type || "").slice(0, 5) ? e.type = e.type.slice(5) : e.removeAttribute("type"), e
    }

    function Ie(e, t) {
        var i, n, o, r, a, s, l, c;
        if (1 === t.nodeType) {
            if (X.hasData(e) && (r = X.access(e), a = X.set(t, r), c = r.events))
                for (o in delete a.handle, a.events = {}, c)
                    for (i = 0, n = c[o].length; i < n; i++) _.event.add(t, o, c[o][i]);
            Y.hasData(e) && (s = Y.access(e), l = _.extend({}, s), Y.set(t, l))
        }
    }

    function Le(i, n, o, r) {
        n = g.apply([], n);
        var e, t, a, s, l, c, d = 0,
            u = i.length,
            p = u - 1,
            h = n[0],
            f = w(h);
        if (f || 1 < u && "string" == typeof h && !v.checkClone && Ee.test(h)) return i.each(function(e) {
            var t = i.eq(e);
            f && (n[0] = h.call(this, e, t.html())), Le(t, n, o, r)
        });
        if (u && (t = (e = ye(n, i[0].ownerDocument, !1, i, r)).firstChild, 1 === e.childNodes.length && (e = t), t || r)) {
            for (s = (a = _.map(pe(e, "script"), De)).length; d < u; d++) l = e, d !== p && (l = _.clone(l, !0, !0), s && _.merge(a, pe(l, "script"))), o.call(i[d], l, d);
            if (s)
                for (c = a[a.length - 1].ownerDocument, _.map(a, Pe), d = 0; d < s; d++) l = a[d], de.test(l.type || "") && !X.access(l, "globalEval") && _.contains(c, l) && (l.src && "module" !== (l.type || "").toLowerCase() ? _._evalUrl && _._evalUrl(l.src) : b(l.textContent.replace(je, ""), c, l))
        }
        return i
    }

    function Ne(e, t, i) {
        for (var n, o = t ? _.filter(t, e) : e, r = 0; null != (n = o[r]); r++) i || 1 !== n.nodeType || _.cleanData(pe(n)), n.parentNode && (i && _.contains(n.ownerDocument, n) && he(pe(n, "script")), n.parentNode.removeChild(n));
        return e
    }
    _.extend({
        htmlPrefilter: function(e) {
            return e.replace(ke, "<$1></$2>")
        },
        clone: function(e, t, i) {
            var n, o, r, a, s, l, c, d = e.cloneNode(!0),
                u = _.contains(e.ownerDocument, e);
            if (!(v.noCloneChecked || 1 !== e.nodeType && 11 !== e.nodeType || _.isXMLDoc(e)))
                for (a = pe(d), n = 0, o = (r = pe(e)).length; n < o; n++) s = r[n], "input" === (c = (l = a[n]).nodeName.toLowerCase()) && le.test(s.type) ? l.checked = s.checked : "input" !== c && "textarea" !== c || (l.defaultValue = s.defaultValue);
            if (t)
                if (i)
                    for (r = r || pe(e), a = a || pe(d), n = 0, o = r.length; n < o; n++) Ie(r[n], a[n]);
                else Ie(e, d);
            return 0 < (a = pe(d, "script")).length && he(a, !u && pe(e, "script")), d
        },
        cleanData: function(e) {
            for (var t, i, n, o = _.event.special, r = 0; void 0 !== (i = e[r]); r++)
                if (G(i)) {
                    if (t = i[X.expando]) {
                        if (t.events)
                            for (n in t.events) o[n] ? _.event.remove(i, n) : _.removeEvent(i, n, t.handle);
                        i[X.expando] = void 0
                    }
                    i[Y.expando] && (i[Y.expando] = void 0)
                }
        }
    }), _.fn.extend({
        detach: function(e) {
            return Ne(this, e, !0)
        },
        remove: function(e) {
            return Ne(this, e)
        },
        text: function(e) {
            return H(this, function(e) {
                return void 0 === e ? _.text(this) : this.empty().each(function() {
                    1 !== this.nodeType && 11 !== this.nodeType && 9 !== this.nodeType || (this.textContent = e)
                })
            }, null, e, arguments.length)
        },
        append: function() {
            return Le(this, arguments, function(e) {
                1 !== this.nodeType && 11 !== this.nodeType && 9 !== this.nodeType || Ae(this, e).appendChild(e)
            })
        },
        prepend: function() {
            return Le(this, arguments, function(e) {
                if (1 === this.nodeType || 11 === this.nodeType || 9 === this.nodeType) {
                    var t = Ae(this, e);
                    t.insertBefore(e, t.firstChild)
                }
            })
        },
        before: function() {
            return Le(this, arguments, function(e) {
                this.parentNode && this.parentNode.insertBefore(e, this)
            })
        },
        after: function() {
            return Le(this, arguments, function(e) {
                this.parentNode && this.parentNode.insertBefore(e, this.nextSibling)
            })
        },
        empty: function() {
            for (var e, t = 0; null != (e = this[t]); t++) 1 === e.nodeType && (_.cleanData(pe(e, !1)), e.textContent = "");
            return this
        },
        clone: function(e, t) {
            return e = null != e && e, t = null == t ? e : t, this.map(function() {
                return _.clone(this, e, t)
            })
        },
        html: function(e) {
            return H(this, function(e) {
                var t = this[0] || {},
                    i = 0,
                    n = this.length;
                if (void 0 === e && 1 === t.nodeType) return t.innerHTML;
                if ("string" == typeof e && !Te.test(e) && !ue[(ce.exec(e) || ["", ""])[1].toLowerCase()]) {
                    e = _.htmlPrefilter(e);
                    try {
                        for (; i < n; i++) 1 === (t = this[i] || {}).nodeType && (_.cleanData(pe(t, !1)), t.innerHTML = e);
                        t = 0
                    } catch (e) {}
                }
                t && this.empty().append(e)
            }, null, e, arguments.length)
        },
        replaceWith: function() {
            var i = [];
            return Le(this, arguments, function(e) {
                var t = this.parentNode;
                _.inArray(this, i) < 0 && (_.cleanData(pe(this)), t && t.replaceChild(e, this))
            }, i)
        }
    }), _.each({
        appendTo: "append",
        prependTo: "prepend",
        insertBefore: "before",
        insertAfter: "after",
        replaceAll: "replaceWith"
    }, function(e, a) {
        _.fn[e] = function(e) {
            for (var t, i = [], n = _(e), o = n.length - 1, r = 0; r <= o; r++) t = r === o ? this : this.clone(!0), _(n[r])[a](t), l.apply(i, t.get());
            return this.pushStack(i)
        }
    });
    var ze, qe, Oe, Me, Fe, Be, He, Re = new RegExp("^(" + ie + ")(?!px)[a-z%]+$", "i"),
        We = function(e) {
            var t = e.ownerDocument.defaultView;
            return t && t.opener || (t = C), t.getComputedStyle(e)
        },
        Ue = new RegExp(oe.join("|"), "i");

    function Ve(e, t, i) {
        var n, o, r, a, s = e.style;
        return (i = i || We(e)) && ("" !== (a = i.getPropertyValue(t) || i[t]) || _.contains(e.ownerDocument, e) || (a = _.style(e, t)), !v.pixelBoxStyles() && Re.test(a) && Ue.test(t) && (n = s.width, o = s.minWidth, r = s.maxWidth, s.minWidth = s.maxWidth = s.width = a, a = i.width, s.width = n, s.minWidth = o, s.maxWidth = r)), void 0 !== a ? a + "" : a
    }

    function Ge(e, t) {
        return {
            get: function() {
                if (!e()) return (this.get = t).apply(this, arguments);
                delete this.get
            }
        }
    }

    function Qe() {
        if (He) {
            Be.style.cssText = "position:absolute;left:-11111px;width:60px;margin-top:1px;padding:0;border:0", He.style.cssText = "position:relative;display:block;box-sizing:border-box;overflow:scroll;margin:auto;border:1px;padding:1px;width:60%;top:1%", ve.appendChild(Be).appendChild(He);
            var e = C.getComputedStyle(He);
            ze = "1%" !== e.top, Fe = 12 === Xe(e.marginLeft), He.style.right = "60%", Me = 36 === Xe(e.right), qe = 36 === Xe(e.width), He.style.position = "absolute", Oe = 36 === He.offsetWidth || "absolute", ve.removeChild(Be), He = null
        }
    }

    function Xe(e) {
        return Math.round(parseFloat(e))
    }
    Be = S.createElement("div"), (He = S.createElement("div")).style && (He.style.backgroundClip = "content-box", He.cloneNode(!0).style.backgroundClip = "", v.clearCloneStyle = "content-box" === He.style.backgroundClip, _.extend(v, {
        boxSizingReliable: function() {
            return Qe(), qe
        },
        pixelBoxStyles: function() {
            return Qe(), Me
        },
        pixelPosition: function() {
            return Qe(), ze
        },
        reliableMarginLeft: function() {
            return Qe(), Fe
        },
        scrollboxSize: function() {
            return Qe(), Oe
        }
    }));
    var Ye = /^(none|table(?!-c[ea]).+)/,
        Je = /^--/,
        Ze = {
            position: "absolute",
            visibility: "hidden",
            display: "block"
        },
        Ke = {
            letterSpacing: "0",
            fontWeight: "400"
        },
        et = ["Webkit", "Moz", "ms"],
        tt = S.createElement("div").style;

    function it(e) {
        var t = _.cssProps[e];
        return t || (_.cssProps[e] = function(e) {
            if (e in tt) return e;
            for (var t = e[0].toUpperCase() + e.slice(1), i = et.length; i--;)
                if ((e = et[i] + t) in tt) return e
        }(e) || e)
    }

    function nt(e, t, i) {
        var n = ne.exec(t);
        return n ? Math.max(0, n[2] - (i || 0)) + (n[3] || "px") : t
    }

    function ot(e, t, i, n, o, r) {
        var a = "width" === t ? 1 : 0,
            s = 0,
            l = 0;
        if (i === (n ? "border" : "content")) return 0;
        for (; a < 4; a += 2) "margin" === i && (l += _.css(e, i + oe[a], !0, o)), n ? ("content" === i && (l -= _.css(e, "padding" + oe[a], !0, o)), "margin" !== i && (l -= _.css(e, "border" + oe[a] + "Width", !0, o))) : (l += _.css(e, "padding" + oe[a], !0, o), "padding" !== i ? l += _.css(e, "border" + oe[a] + "Width", !0, o) : s += _.css(e, "border" + oe[a] + "Width", !0, o));
        return !n && 0 <= r && (l += Math.max(0, Math.ceil(e["offset" + t[0].toUpperCase() + t.slice(1)] - r - l - s - .5))), l
    }

    function rt(e, t, i) {
        var n = We(e),
            o = Ve(e, t, n),
            r = "border-box" === _.css(e, "boxSizing", !1, n),
            a = r;
        if (Re.test(o)) {
            if (!i) return o;
            o = "auto"
        }
        return a = a && (v.boxSizingReliable() || o === e.style[t]), "auto" !== o && (parseFloat(o) || "inline" !== _.css(e, "display", !1, n)) || (o = e["offset" + t[0].toUpperCase() + t.slice(1)], a = !0), (o = parseFloat(o) || 0) + ot(e, t, i || (r ? "border" : "content"), a, n, o) + "px"
    }

    function at(e, t, i, n, o) {
        return new at.prototype.init(e, t, i, n, o)
    }
    _.extend({
        cssHooks: {
            opacity: {
                get: function(e, t) {
                    if (t) {
                        var i = Ve(e, "opacity");
                        return "" === i ? "1" : i
                    }
                }
            }
        },
        cssNumber: {
            animationIterationCount: !0,
            columnCount: !0,
            fillOpacity: !0,
            flexGrow: !0,
            flexShrink: !0,
            fontWeight: !0,
            lineHeight: !0,
            opacity: !0,
            order: !0,
            orphans: !0,
            widows: !0,
            zIndex: !0,
            zoom: !0
        },
        cssProps: {},
        style: function(e, t, i, n) {
            if (e && 3 !== e.nodeType && 8 !== e.nodeType && e.style) {
                var o, r, a, s = V(t),
                    l = Je.test(t),
                    c = e.style;
                if (l || (t = it(s)), a = _.cssHooks[t] || _.cssHooks[s], void 0 === i) return a && "get" in a && void 0 !== (o = a.get(e, !1, n)) ? o : c[t];
                "string" == (r = typeof i) && (o = ne.exec(i)) && o[1] && (i = re(e, t, o), r = "number"), null != i && i == i && ("number" === r && (i += o && o[3] || (_.cssNumber[s] ? "" : "px")), v.clearCloneStyle || "" !== i || 0 !== t.indexOf("background") || (c[t] = "inherit"), a && "set" in a && void 0 === (i = a.set(e, i, n)) || (l ? c.setProperty(t, i) : c[t] = i))
            }
        },
        css: function(e, t, i, n) {
            var o, r, a, s = V(t);
            return Je.test(t) || (t = it(s)), (a = _.cssHooks[t] || _.cssHooks[s]) && "get" in a && (o = a.get(e, !0, i)), void 0 === o && (o = Ve(e, t, n)), "normal" === o && t in Ke && (o = Ke[t]), "" === i || i ? (r = parseFloat(o), !0 === i || isFinite(r) ? r || 0 : o) : o
        }
    }), _.each(["height", "width"], function(e, s) {
        _.cssHooks[s] = {
            get: function(e, t, i) {
                if (t) return !Ye.test(_.css(e, "display")) || e.getClientRects().length && e.getBoundingClientRect().width ? rt(e, s, i) : te(e, Ze, function() {
                    return rt(e, s, i)
                })
            },
            set: function(e, t, i) {
                var n, o = We(e),
                    r = "border-box" === _.css(e, "boxSizing", !1, o),
                    a = i && ot(e, s, i, r, o);
                return r && v.scrollboxSize() === o.position && (a -= Math.ceil(e["offset" + s[0].toUpperCase() + s.slice(1)] - parseFloat(o[s]) - ot(e, s, "border", !1, o) - .5)), a && (n = ne.exec(t)) && "px" !== (n[3] || "px") && (e.style[s] = t, t = _.css(e, s)), nt(0, t, a)
            }
        }
    }), _.cssHooks.marginLeft = Ge(v.reliableMarginLeft, function(e, t) {
        if (t) return (parseFloat(Ve(e, "marginLeft")) || e.getBoundingClientRect().left - te(e, {
            marginLeft: 0
        }, function() {
            return e.getBoundingClientRect().left
        })) + "px"
    }), _.each({
        margin: "",
        padding: "",
        border: "Width"
    }, function(o, r) {
        _.cssHooks[o + r] = {
            expand: function(e) {
                for (var t = 0, i = {}, n = "string" == typeof e ? e.split(" ") : [e]; t < 4; t++) i[o + oe[t] + r] = n[t] || n[t - 2] || n[0];
                return i
            }
        }, "margin" !== o && (_.cssHooks[o + r].set = nt)
    }), _.fn.extend({
        css: function(e, t) {
            return H(this, function(e, t, i) {
                var n, o, r = {},
                    a = 0;
                if (Array.isArray(t)) {
                    for (n = We(e), o = t.length; a < o; a++) r[t[a]] = _.css(e, t[a], !1, n);
                    return r
                }
                return void 0 !== i ? _.style(e, t, i) : _.css(e, t)
            }, e, t, 1 < arguments.length)
        }
    }), ((_.Tween = at).prototype = {
        constructor: at,
        init: function(e, t, i, n, o, r) {
            this.elem = e, this.prop = i, this.easing = o || _.easing._default, this.options = t, this.start = this.now = this.cur(), this.end = n, this.unit = r || (_.cssNumber[i] ? "" : "px")
        },
        cur: function() {
            var e = at.propHooks[this.prop];
            return e && e.get ? e.get(this) : at.propHooks._default.get(this)
        },
        run: function(e) {
            var t, i = at.propHooks[this.prop];
            return this.options.duration ? this.pos = t = _.easing[this.easing](e, this.options.duration * e, 0, 1, this.options.duration) : this.pos = t = e, this.now = (this.end - this.start) * t + this.start, this.options.step && this.options.step.call(this.elem, this.now, this), i && i.set ? i.set(this) : at.propHooks._default.set(this), this
        }
    }).init.prototype = at.prototype, (at.propHooks = {
        _default: {
            get: function(e) {
                var t;
                return 1 !== e.elem.nodeType || null != e.elem[e.prop] && null == e.elem.style[e.prop] ? e.elem[e.prop] : (t = _.css(e.elem, e.prop, "")) && "auto" !== t ? t : 0
            },
            set: function(e) {
                _.fx.step[e.prop] ? _.fx.step[e.prop](e) : 1 !== e.elem.nodeType || null == e.elem.style[_.cssProps[e.prop]] && !_.cssHooks[e.prop] ? e.elem[e.prop] = e.now : _.style(e.elem, e.prop, e.now + e.unit)
            }
        }
    }).scrollTop = at.propHooks.scrollLeft = {
        set: function(e) {
            e.elem.nodeType && e.elem.parentNode && (e.elem[e.prop] = e.now)
        }
    }, _.easing = {
        linear: function(e) {
            return e
        },
        swing: function(e) {
            return .5 - Math.cos(e * Math.PI) / 2
        },
        _default: "swing"
    }, _.fx = at.prototype.init, _.fx.step = {};
    var st, lt, ct, dt, ut = /^(?:toggle|show|hide)$/,
        pt = /queueHooks$/;

    function ht() {
        lt && (!1 === S.hidden && C.requestAnimationFrame ? C.requestAnimationFrame(ht) : C.setTimeout(ht, _.fx.interval), _.fx.tick())
    }

    function ft() {
        return C.setTimeout(function() {
            st = void 0
        }), st = Date.now()
    }

    function mt(e, t) {
        var i, n = 0,
            o = {
                height: e
            };
        for (t = t ? 1 : 0; n < 4; n += 2 - t) o["margin" + (i = oe[n])] = o["padding" + i] = e;
        return t && (o.opacity = o.width = e), o
    }

    function gt(e, t, i) {
        for (var n, o = (yt.tweeners[t] || []).concat(yt.tweeners["*"]), r = 0, a = o.length; r < a; r++)
            if (n = o[r].call(i, t, e)) return n
    }

    function yt(r, e, t) {
        var i, a, n = 0,
            o = yt.prefilters.length,
            s = _.Deferred().always(function() {
                delete l.elem
            }),
            l = function() {
                if (a) return !1;
                for (var e = st || ft(), t = Math.max(0, c.startTime + c.duration - e), i = 1 - (t / c.duration || 0), n = 0, o = c.tweens.length; n < o; n++) c.tweens[n].run(i);
                return s.notifyWith(r, [c, i, t]), i < 1 && o ? t : (o || s.notifyWith(r, [c, 1, 0]), s.resolveWith(r, [c]), !1)
            },
            c = s.promise({
                elem: r,
                props: _.extend({}, e),
                opts: _.extend(!0, {
                    specialEasing: {},
                    easing: _.easing._default
                }, t),
                originalProperties: e,
                originalOptions: t,
                startTime: st || ft(),
                duration: t.duration,
                tweens: [],
                createTween: function(e, t) {
                    var i = _.Tween(r, c.opts, e, t, c.opts.specialEasing[e] || c.opts.easing);
                    return c.tweens.push(i), i
                },
                stop: function(e) {
                    var t = 0,
                        i = e ? c.tweens.length : 0;
                    if (a) return this;
                    for (a = !0; t < i; t++) c.tweens[t].run(1);
                    return e ? (s.notifyWith(r, [c, 1, 0]), s.resolveWith(r, [c, e])) : s.rejectWith(r, [c, e]), this
                }
            }),
            d = c.props;
        for (function(e, t) {
                var i, n, o, r, a;
                for (i in e)
                    if (o = t[n = V(i)], r = e[i], Array.isArray(r) && (o = r[1], r = e[i] = r[0]), i !== n && (e[n] = r, delete e[i]), (a = _.cssHooks[n]) && "expand" in a)
                        for (i in r = a.expand(r), delete e[n], r) i in e || (e[i] = r[i], t[i] = o);
                    else t[n] = o
            }(d, c.opts.specialEasing); n < o; n++)
            if (i = yt.prefilters[n].call(c, r, d, c.opts)) return w(i.stop) && (_._queueHooks(c.elem, c.opts.queue).stop = i.stop.bind(i)), i;
        return _.map(d, gt, c), w(c.opts.start) && c.opts.start.call(r, c), c.progress(c.opts.progress).done(c.opts.done, c.opts.complete).fail(c.opts.fail).always(c.opts.always), _.fx.timer(_.extend(l, {
            elem: r,
            anim: c,
            queue: c.opts.queue
        })), c
    }
    _.Animation = _.extend(yt, {
        tweeners: {
            "*": [function(e, t) {
                var i = this.createTween(e, t);
                return re(i.elem, e, ne.exec(t), i), i
            }]
        },
        tweener: function(e, t) {
            for (var i, n = 0, o = (e = w(e) ? (t = e, ["*"]) : e.match(N)).length; n < o; n++) i = e[n], yt.tweeners[i] = yt.tweeners[i] || [], yt.tweeners[i].unshift(t)
        },
        prefilters: [function(e, t, i) {
            var n, o, r, a, s, l, c, d, u = "width" in t || "height" in t,
                p = this,
                h = {},
                f = e.style,
                m = e.nodeType && ee(e),
                g = X.get(e, "fxshow");
            for (n in i.queue || (null == (a = _._queueHooks(e, "fx")).unqueued && (a.unqueued = 0, s = a.empty.fire, a.empty.fire = function() {
                    a.unqueued || s()
                }), a.unqueued++, p.always(function() {
                    p.always(function() {
                        a.unqueued--, _.queue(e, "fx").length || a.empty.fire()
                    })
                })), t)
                if (o = t[n], ut.test(o)) {
                    if (delete t[n], r = r || "toggle" === o, o === (m ? "hide" : "show")) {
                        if ("show" !== o || !g || void 0 === g[n]) continue;
                        m = !0
                    }
                    h[n] = g && g[n] || _.style(e, n)
                } if ((l = !_.isEmptyObject(t)) || !_.isEmptyObject(h))
                for (n in u && 1 === e.nodeType && (i.overflow = [f.overflow, f.overflowX, f.overflowY], null == (c = g && g.display) && (c = X.get(e, "display")), "none" === (d = _.css(e, "display")) && (c ? d = c : (se([e], !0), c = e.style.display || c, d = _.css(e, "display"), se([e]))), ("inline" === d || "inline-block" === d && null != c) && "none" === _.css(e, "float") && (l || (p.done(function() {
                        f.display = c
                    }), null == c && (d = f.display, c = "none" === d ? "" : d)), f.display = "inline-block")), i.overflow && (f.overflow = "hidden", p.always(function() {
                        f.overflow = i.overflow[0], f.overflowX = i.overflow[1], f.overflowY = i.overflow[2]
                    })), l = !1, h) l || (g ? "hidden" in g && (m = g.hidden) : g = X.access(e, "fxshow", {
                    display: c
                }), r && (g.hidden = !m), m && se([e], !0), p.done(function() {
                    for (n in m || se([e]), X.remove(e, "fxshow"), h) _.style(e, n, h[n])
                })), l = gt(m ? g[n] : 0, n, p), n in g || (g[n] = l.start, m && (l.end = l.start, l.start = 0))
        }],
        prefilter: function(e, t) {
            t ? yt.prefilters.unshift(e) : yt.prefilters.push(e)
        }
    }), _.speed = function(e, t, i) {
        var n = e && "object" == typeof e ? _.extend({}, e) : {
            complete: i || !i && t || w(e) && e,
            duration: e,
            easing: i && t || t && !w(t) && t
        };
        return _.fx.off ? n.duration = 0 : "number" != typeof n.duration && (n.duration in _.fx.speeds ? n.duration = _.fx.speeds[n.duration] : n.duration = _.fx.speeds._default), null != n.queue && !0 !== n.queue || (n.queue = "fx"), n.old = n.complete, n.complete = function() {
            w(n.old) && n.old.call(this), n.queue && _.dequeue(this, n.queue)
        }, n
    }, _.fn.extend({
        fadeTo: function(e, t, i, n) {
            return this.filter(ee).css("opacity", 0).show().end().animate({
                opacity: t
            }, e, i, n)
        },
        animate: function(t, e, i, n) {
            function o() {
                var e = yt(this, _.extend({}, t), a);
                (r || X.get(this, "finish")) && e.stop(!0)
            }
            var r = _.isEmptyObject(t),
                a = _.speed(e, i, n);
            return o.finish = o, r || !1 === a.queue ? this.each(o) : this.queue(a.queue, o)
        },
        stop: function(o, e, r) {
            function a(e) {
                var t = e.stop;
                delete e.stop, t(r)
            }
            return "string" != typeof o && (r = e, e = o, o = void 0), e && !1 !== o && this.queue(o || "fx", []), this.each(function() {
                var e = !0,
                    t = null != o && o + "queueHooks",
                    i = _.timers,
                    n = X.get(this);
                if (t) n[t] && n[t].stop && a(n[t]);
                else
                    for (t in n) n[t] && n[t].stop && pt.test(t) && a(n[t]);
                for (t = i.length; t--;) i[t].elem !== this || null != o && i[t].queue !== o || (i[t].anim.stop(r), e = !1, i.splice(t, 1));
                !e && r || _.dequeue(this, o)
            })
        },
        finish: function(a) {
            return !1 !== a && (a = a || "fx"), this.each(function() {
                var e, t = X.get(this),
                    i = t[a + "queue"],
                    n = t[a + "queueHooks"],
                    o = _.timers,
                    r = i ? i.length : 0;
                for (t.finish = !0, _.queue(this, a, []), n && n.stop && n.stop.call(this, !0), e = o.length; e--;) o[e].elem === this && o[e].queue === a && (o[e].anim.stop(!0), o.splice(e, 1));
                for (e = 0; e < r; e++) i[e] && i[e].finish && i[e].finish.call(this);
                delete t.finish
            })
        }
    }), _.each(["toggle", "show", "hide"], function(e, n) {
        var o = _.fn[n];
        _.fn[n] = function(e, t, i) {
            return null == e || "boolean" == typeof e ? o.apply(this, arguments) : this.animate(mt(n, !0), e, t, i)
        }
    }), _.each({
        slideDown: mt("show"),
        slideUp: mt("hide"),
        slideToggle: mt("toggle"),
        fadeIn: {
            opacity: "show"
        },
        fadeOut: {
            opacity: "hide"
        },
        fadeToggle: {
            opacity: "toggle"
        }
    }, function(e, n) {
        _.fn[e] = function(e, t, i) {
            return this.animate(n, e, t, i)
        }
    }), _.timers = [], _.fx.tick = function() {
        var e, t = 0,
            i = _.timers;
        for (st = Date.now(); t < i.length; t++)(e = i[t])() || i[t] !== e || i.splice(t--, 1);
        i.length || _.fx.stop(), st = void 0
    }, _.fx.timer = function(e) {
        _.timers.push(e), _.fx.start()
    }, _.fx.interval = 13, _.fx.start = function() {
        lt || (lt = !0, ht())
    }, _.fx.stop = function() {
        lt = null
    }, _.fx.speeds = {
        slow: 600,
        fast: 200,
        _default: 400
    }, _.fn.delay = function(n, e) {
        return n = _.fx && _.fx.speeds[n] || n, e = e || "fx", this.queue(e, function(e, t) {
            var i = C.setTimeout(e, n);
            t.stop = function() {
                C.clearTimeout(i)
            }
        })
    }, ct = S.createElement("input"), dt = S.createElement("select").appendChild(S.createElement("option")), ct.type = "checkbox", v.checkOn = "" !== ct.value, v.optSelected = dt.selected, (ct = S.createElement("input")).value = "t", ct.type = "radio", v.radioValue = "t" === ct.value;
    var vt, wt = _.expr.attrHandle;
    _.fn.extend({
        attr: function(e, t) {
            return H(this, _.attr, e, t, 1 < arguments.length)
        },
        removeAttr: function(e) {
            return this.each(function() {
                _.removeAttr(this, e)
            })
        }
    }), _.extend({
        attr: function(e, t, i) {
            var n, o, r = e.nodeType;
            if (3 !== r && 8 !== r && 2 !== r) return void 0 === e.getAttribute ? _.prop(e, t, i) : (1 === r && _.isXMLDoc(e) || (o = _.attrHooks[t.toLowerCase()] || (_.expr.match.bool.test(t) ? vt : void 0)), void 0 !== i ? null === i ? void _.removeAttr(e, t) : o && "set" in o && void 0 !== (n = o.set(e, i, t)) ? n : (e.setAttribute(t, i + ""), i) : o && "get" in o && null !== (n = o.get(e, t)) ? n : null == (n = _.find.attr(e, t)) ? void 0 : n)
        },
        attrHooks: {
            type: {
                set: function(e, t) {
                    if (!v.radioValue && "radio" === t && T(e, "input")) {
                        var i = e.value;
                        return e.setAttribute("type", t), i && (e.value = i), t
                    }
                }
            }
        },
        removeAttr: function(e, t) {
            var i, n = 0,
                o = t && t.match(N);
            if (o && 1 === e.nodeType)
                for (; i = o[n++];) e.removeAttribute(i)
        }
    }), vt = {
        set: function(e, t, i) {
            return !1 === t ? _.removeAttr(e, i) : e.setAttribute(i, i), i
        }
    }, _.each(_.expr.match.bool.source.match(/\w+/g), function(e, t) {
        var a = wt[t] || _.find.attr;
        wt[t] = function(e, t, i) {
            var n, o, r = t.toLowerCase();
            return i || (o = wt[r], wt[r] = n, n = null != a(e, t, i) ? r : null, wt[r] = o), n
        }
    });
    var bt = /^(?:input|select|textarea|button)$/i,
        $t = /^(?:a|area)$/i;

    function xt(e) {
        return (e.match(N) || []).join(" ")
    }

    function Ct(e) {
        return e.getAttribute && e.getAttribute("class") || ""
    }

    function St(e) {
        return Array.isArray(e) ? e : "string" == typeof e && e.match(N) || []
    }
    _.fn.extend({
        prop: function(e, t) {
            return H(this, _.prop, e, t, 1 < arguments.length)
        },
        removeProp: function(e) {
            return this.each(function() {
                delete this[_.propFix[e] || e]
            })
        }
    }), _.extend({
        prop: function(e, t, i) {
            var n, o, r = e.nodeType;
            if (3 !== r && 8 !== r && 2 !== r) return 1 === r && _.isXMLDoc(e) || (t = _.propFix[t] || t, o = _.propHooks[t]), void 0 !== i ? o && "set" in o && void 0 !== (n = o.set(e, i, t)) ? n : e[t] = i : o && "get" in o && null !== (n = o.get(e, t)) ? n : e[t]
        },
        propHooks: {
            tabIndex: {
                get: function(e) {
                    var t = _.find.attr(e, "tabindex");
                    return t ? parseInt(t, 10) : bt.test(e.nodeName) || $t.test(e.nodeName) && e.href ? 0 : -1
                }
            }
        },
        propFix: {
            for: "htmlFor",
            class: "className"
        }
    }), v.optSelected || (_.propHooks.selected = {
        get: function(e) {
            var t = e.parentNode;
            return t && t.parentNode && t.parentNode.selectedIndex, null
        },
        set: function(e) {
            var t = e.parentNode;
            t && (t.selectedIndex, t.parentNode && t.parentNode.selectedIndex)
        }
    }), _.each(["tabIndex", "readOnly", "maxLength", "cellSpacing", "cellPadding", "rowSpan", "colSpan", "useMap", "frameBorder", "contentEditable"], function() {
        _.propFix[this.toLowerCase()] = this
    }), _.fn.extend({
        addClass: function(t) {
            var e, i, n, o, r, a, s, l = 0;
            if (w(t)) return this.each(function(e) {
                _(this).addClass(t.call(this, e, Ct(this)))
            });
            if ((e = St(t)).length)
                for (; i = this[l++];)
                    if (o = Ct(i), n = 1 === i.nodeType && " " + xt(o) + " ") {
                        for (a = 0; r = e[a++];) n.indexOf(" " + r + " ") < 0 && (n += r + " ");
                        o !== (s = xt(n)) && i.setAttribute("class", s)
                    } return this
        },
        removeClass: function(t) {
            var e, i, n, o, r, a, s, l = 0;
            if (w(t)) return this.each(function(e) {
                _(this).removeClass(t.call(this, e, Ct(this)))
            });
            if (!arguments.length) return this.attr("class", "");
            if ((e = St(t)).length)
                for (; i = this[l++];)
                    if (o = Ct(i), n = 1 === i.nodeType && " " + xt(o) + " ") {
                        for (a = 0; r = e[a++];)
                            for (; - 1 < n.indexOf(" " + r + " ");) n = n.replace(" " + r + " ", " ");
                        o !== (s = xt(n)) && i.setAttribute("class", s)
                    } return this
        },
        toggleClass: function(o, t) {
            var r = typeof o,
                a = "string" == r || Array.isArray(o);
            return "boolean" == typeof t && a ? t ? this.addClass(o) : this.removeClass(o) : w(o) ? this.each(function(e) {
                _(this).toggleClass(o.call(this, e, Ct(this), t), t)
            }) : this.each(function() {
                var e, t, i, n;
                if (a)
                    for (t = 0, i = _(this), n = St(o); e = n[t++];) i.hasClass(e) ? i.removeClass(e) : i.addClass(e);
                else void 0 !== o && "boolean" != r || ((e = Ct(this)) && X.set(this, "__className__", e), this.setAttribute && this.setAttribute("class", e || !1 === o ? "" : X.get(this, "__className__") || ""))
            })
        },
        hasClass: function(e) {
            var t, i, n = 0;
            for (t = " " + e + " "; i = this[n++];)
                if (1 === i.nodeType && -1 < (" " + xt(Ct(i)) + " ").indexOf(t)) return !0;
            return !1
        }
    });
    var _t = /\r/g;

    function kt(e) {
        e.stopPropagation()
    }
    _.fn.extend({
        val: function(i) {
            var n, e, o, t = this[0];
            return arguments.length ? (o = w(i), this.each(function(e) {
                var t;
                1 === this.nodeType && (null == (t = o ? i.call(this, e, _(this).val()) : i) ? t = "" : "number" == typeof t ? t += "" : Array.isArray(t) && (t = _.map(t, function(e) {
                    return null == e ? "" : e + ""
                })), (n = _.valHooks[this.type] || _.valHooks[this.nodeName.toLowerCase()]) && "set" in n && void 0 !== n.set(this, t, "value") || (this.value = t))
            })) : t ? (n = _.valHooks[t.type] || _.valHooks[t.nodeName.toLowerCase()]) && "get" in n && void 0 !== (e = n.get(t, "value")) ? e : "string" == typeof(e = t.value) ? e.replace(_t, "") : null == e ? "" : e : void 0
        }
    }), _.extend({
        valHooks: {
            option: {
                get: function(e) {
                    var t = _.find.attr(e, "value");
                    return null != t ? t : xt(_.text(e))
                }
            },
            select: {
                get: function(e) {
                    var t, i, n, o = e.options,
                        r = e.selectedIndex,
                        a = "select-one" === e.type,
                        s = a ? null : [],
                        l = a ? r + 1 : o.length;
                    for (n = r < 0 ? l : a ? r : 0; n < l; n++)
                        if (((i = o[n]).selected || n === r) && !i.disabled && (!i.parentNode.disabled || !T(i.parentNode, "optgroup"))) {
                            if (t = _(i).val(), a) return t;
                            s.push(t)
                        } return s
                },
                set: function(e, t) {
                    for (var i, n, o = e.options, r = _.makeArray(t), a = o.length; a--;)((n = o[a]).selected = -1 < _.inArray(_.valHooks.option.get(n), r)) && (i = !0);
                    return i || (e.selectedIndex = -1), r
                }
            }
        }
    }), _.each(["radio", "checkbox"], function() {
        _.valHooks[this] = {
            set: function(e, t) {
                if (Array.isArray(t)) return e.checked = -1 < _.inArray(_(e).val(), t)
            }
        }, v.checkOn || (_.valHooks[this].get = function(e) {
            return null === e.getAttribute("value") ? "on" : e.value
        })
    }), v.focusin = "onfocusin" in C;
    var Tt = /^(?:focusinfocus|focusoutblur)$/;
    _.extend(_.event, {
        trigger: function(e, t, i, n) {
            var o, r, a, s, l, c, d, u, p = [i || S],
                h = y.call(e, "type") ? e.type : e,
                f = y.call(e, "namespace") ? e.namespace.split(".") : [];
            if (r = u = a = i = i || S, 3 !== i.nodeType && 8 !== i.nodeType && !Tt.test(h + _.event.triggered) && (-1 < h.indexOf(".") && (h = (f = h.split(".")).shift(), f.sort()), l = h.indexOf(":") < 0 && "on" + h, (e = e[_.expando] ? e : new _.Event(h, "object" == typeof e && e)).isTrigger = n ? 2 : 3, e.namespace = f.join("."), e.rnamespace = e.namespace ? new RegExp("(^|\\.)" + f.join("\\.(?:.*\\.|)") + "(\\.|$)") : null, e.result = void 0, e.target || (e.target = i), t = null == t ? [e] : _.makeArray(t, [e]), d = _.event.special[h] || {}, n || !d.trigger || !1 !== d.trigger.apply(i, t))) {
                if (!n && !d.noBubble && !m(i)) {
                    for (s = d.delegateType || h, Tt.test(s + h) || (r = r.parentNode); r; r = r.parentNode) p.push(r), a = r;
                    a === (i.ownerDocument || S) && p.push(a.defaultView || a.parentWindow || C)
                }
                for (o = 0;
                    (r = p[o++]) && !e.isPropagationStopped();) u = r, e.type = 1 < o ? s : d.bindType || h, (c = (X.get(r, "events") || {})[e.type] && X.get(r, "handle")) && c.apply(r, t), (c = l && r[l]) && c.apply && G(r) && (e.result = c.apply(r, t), !1 === e.result && e.preventDefault());
                return e.type = h, n || e.isDefaultPrevented() || d._default && !1 !== d._default.apply(p.pop(), t) || !G(i) || l && w(i[h]) && !m(i) && ((a = i[l]) && (i[l] = null), _.event.triggered = h, e.isPropagationStopped() && u.addEventListener(h, kt), i[h](), e.isPropagationStopped() && u.removeEventListener(h, kt), _.event.triggered = void 0, a && (i[l] = a)), e.result
            }
        },
        simulate: function(e, t, i) {
            var n = _.extend(new _.Event, i, {
                type: e,
                isSimulated: !0
            });
            _.event.trigger(n, null, t)
        }
    }), _.fn.extend({
        trigger: function(e, t) {
            return this.each(function() {
                _.event.trigger(e, t, this)
            })
        },
        triggerHandler: function(e, t) {
            var i = this[0];
            if (i) return _.event.trigger(e, t, i, !0)
        }
    }), v.focusin || _.each({
        focus: "focusin",
        blur: "focusout"
    }, function(i, n) {
        function o(e) {
            _.event.simulate(n, e.target, _.event.fix(e))
        }
        _.event.special[n] = {
            setup: function() {
                var e = this.ownerDocument || this,
                    t = X.access(e, n);
                t || e.addEventListener(i, o, !0), X.access(e, n, (t || 0) + 1)
            },
            teardown: function() {
                var e = this.ownerDocument || this,
                    t = X.access(e, n) - 1;
                t ? X.access(e, n, t) : (e.removeEventListener(i, o, !0), X.remove(e, n))
            }
        }
    });
    var Et = C.location,
        jt = Date.now(),
        At = /\?/;
    _.parseXML = function(e) {
        var t;
        if (!e || "string" != typeof e) return null;
        try {
            t = (new C.DOMParser).parseFromString(e, "text/xml")
        } catch (e) {
            t = void 0
        }
        return t && !t.getElementsByTagName("parsererror").length || _.error("Invalid XML: " + e), t
    };
    var Dt = /\[\]$/,
        Pt = /\r?\n/g,
        It = /^(?:submit|button|image|reset|file)$/i,
        Lt = /^(?:input|select|textarea|keygen)/i;

    function Nt(i, e, n, o) {
        var t;
        if (Array.isArray(e)) _.each(e, function(e, t) {
            n || Dt.test(i) ? o(i, t) : Nt(i + "[" + ("object" == typeof t && null != t ? e : "") + "]", t, n, o)
        });
        else if (n || "object" !== $(e)) o(i, e);
        else
            for (t in e) Nt(i + "[" + t + "]", e[t], n, o)
    }
    _.param = function(e, t) {
        function i(e, t) {
            var i = w(t) ? t() : t;
            o[o.length] = encodeURIComponent(e) + "=" + encodeURIComponent(null == i ? "" : i)
        }
        var n, o = [];
        if (Array.isArray(e) || e.jquery && !_.isPlainObject(e)) _.each(e, function() {
            i(this.name, this.value)
        });
        else
            for (n in e) Nt(n, e[n], t, i);
        return o.join("&")
    }, _.fn.extend({
        serialize: function() {
            return _.param(this.serializeArray())
        },
        serializeArray: function() {
            return this.map(function() {
                var e = _.prop(this, "elements");
                return e ? _.makeArray(e) : this
            }).filter(function() {
                var e = this.type;
                return this.name && !_(this).is(":disabled") && Lt.test(this.nodeName) && !It.test(e) && (this.checked || !le.test(e))
            }).map(function(e, t) {
                var i = _(this).val();
                return null == i ? null : Array.isArray(i) ? _.map(i, function(e) {
                    return {
                        name: t.name,
                        value: e.replace(Pt, "\r\n")
                    }
                }) : {
                    name: t.name,
                    value: i.replace(Pt, "\r\n")
                }
            }).get()
        }
    });
    var zt = /%20/g,
        qt = /#.*$/,
        Ot = /([?&])_=[^&]*/,
        Mt = /^(.*?):[ \t]*([^\r\n]*)$/gm,
        Ft = /^(?:GET|HEAD)$/,
        Bt = /^\/\//,
        Ht = {},
        Rt = {},
        Wt = "*/".concat("*"),
        Ut = S.createElement("a");

    function Vt(r) {
        return function(e, t) {
            "string" != typeof e && (t = e, e = "*");
            var i, n = 0,
                o = e.toLowerCase().match(N) || [];
            if (w(t))
                for (; i = o[n++];) "+" === i[0] ? (i = i.slice(1) || "*", (r[i] = r[i] || []).unshift(t)) : (r[i] = r[i] || []).push(t)
        }
    }

    function Gt(t, o, r, a) {
        var s = {},
            l = t === Rt;

        function c(e) {
            var n;
            return s[e] = !0, _.each(t[e] || [], function(e, t) {
                var i = t(o, r, a);
                return "string" != typeof i || l || s[i] ? l ? !(n = i) : void 0 : (o.dataTypes.unshift(i), c(i), !1)
            }), n
        }
        return c(o.dataTypes[0]) || !s["*"] && c("*")
    }

    function Qt(e, t) {
        var i, n, o = _.ajaxSettings.flatOptions || {};
        for (i in t) void 0 !== t[i] && ((o[i] ? e : n = n || {})[i] = t[i]);
        return n && _.extend(!0, e, n), e
    }
    Ut.href = Et.href, _.extend({
        active: 0,
        lastModified: {},
        etag: {},
        ajaxSettings: {
            url: Et.href,
            type: "GET",
            isLocal: /^(?:about|app|app-storage|.+-extension|file|res|widget):$/.test(Et.protocol),
            global: !0,
            processData: !0,
            async: !0,
            contentType: "application/x-www-form-urlencoded; charset=UTF-8",
            accepts: {
                "*": Wt,
                text: "text/plain",
                html: "text/html",
                xml: "application/xml, text/xml",
                json: "application/json, text/javascript"
            },
            contents: {
                xml: /\bxml\b/,
                html: /\bhtml/,
                json: /\bjson\b/
            },
            responseFields: {
                xml: "responseXML",
                text: "responseText",
                json: "responseJSON"
            },
            converters: {
                "* text": String,
                "text html": !0,
                "text json": JSON.parse,
                "text xml": _.parseXML
            },
            flatOptions: {
                url: !0,
                context: !0
            }
        },
        ajaxSetup: function(e, t) {
            return t ? Qt(Qt(e, _.ajaxSettings), t) : Qt(_.ajaxSettings, e)
        },
        ajaxPrefilter: Vt(Ht),
        ajaxTransport: Vt(Rt),
        ajax: function(e, t) {
            "object" == typeof e && (t = e, e = void 0), t = t || {};
            var d, u, p, i, h, n, f, m, o, r, g = _.ajaxSetup({}, t),
                y = g.context || g,
                v = g.context && (y.nodeType || y.jquery) ? _(y) : _.event,
                w = _.Deferred(),
                b = _.Callbacks("once memory"),
                $ = g.statusCode || {},
                a = {},
                s = {},
                l = "canceled",
                x = {
                    readyState: 0,
                    getResponseHeader: function(e) {
                        var t;
                        if (f) {
                            if (!i)
                                for (i = {}; t = Mt.exec(p);) i[t[1].toLowerCase()] = t[2];
                            t = i[e.toLowerCase()]
                        }
                        return null == t ? null : t
                    },
                    getAllResponseHeaders: function() {
                        return f ? p : null
                    },
                    setRequestHeader: function(e, t) {
                        return null == f && (e = s[e.toLowerCase()] = s[e.toLowerCase()] || e, a[e] = t), this
                    },
                    overrideMimeType: function(e) {
                        return null == f && (g.mimeType = e), this
                    },
                    statusCode: function(e) {
                        var t;
                        if (e)
                            if (f) x.always(e[x.status]);
                            else
                                for (t in e) $[t] = [$[t], e[t]];
                        return this
                    },
                    abort: function(e) {
                        var t = e || l;
                        return d && d.abort(t), c(0, t), this
                    }
                };
            if (w.promise(x), g.url = ((e || g.url || Et.href) + "").replace(Bt, Et.protocol + "//"), g.type = t.method || t.type || g.method || g.type, g.dataTypes = (g.dataType || "*").toLowerCase().match(N) || [""], null == g.crossDomain) {
                n = S.createElement("a");
                try {
                    n.href = g.url, n.href = n.href, g.crossDomain = Ut.protocol + "//" + Ut.host != n.protocol + "//" + n.host
                } catch (e) {
                    g.crossDomain = !0
                }
            }
            if (g.data && g.processData && "string" != typeof g.data && (g.data = _.param(g.data, g.traditional)), Gt(Ht, g, t, x), f) return x;
            for (o in (m = _.event && g.global) && 0 == _.active++ && _.event.trigger("ajaxStart"), g.type = g.type.toUpperCase(), g.hasContent = !Ft.test(g.type), u = g.url.replace(qt, ""), g.hasContent ? g.data && g.processData && 0 === (g.contentType || "").indexOf("application/x-www-form-urlencoded") && (g.data = g.data.replace(zt, "+")) : (r = g.url.slice(u.length), g.data && (g.processData || "string" == typeof g.data) && (u += (At.test(u) ? "&" : "?") + g.data, delete g.data), !1 === g.cache && (u = u.replace(Ot, "$1"), r = (At.test(u) ? "&" : "?") + "_=" + jt++ + r), g.url = u + r), g.ifModified && (_.lastModified[u] && x.setRequestHeader("If-Modified-Since", _.lastModified[u]), _.etag[u] && x.setRequestHeader("If-None-Match", _.etag[u])), (g.data && g.hasContent && !1 !== g.contentType || t.contentType) && x.setRequestHeader("Content-Type", g.contentType), x.setRequestHeader("Accept", g.dataTypes[0] && g.accepts[g.dataTypes[0]] ? g.accepts[g.dataTypes[0]] + ("*" !== g.dataTypes[0] ? ", " + Wt + "; q=0.01" : "") : g.accepts["*"]), g.headers) x.setRequestHeader(o, g.headers[o]);
            if (g.beforeSend && (!1 === g.beforeSend.call(y, x, g) || f)) return x.abort();
            if (l = "abort", b.add(g.complete), x.done(g.success), x.fail(g.error), d = Gt(Rt, g, t, x)) {
                if (x.readyState = 1, m && v.trigger("ajaxSend", [x, g]), f) return x;
                g.async && 0 < g.timeout && (h = C.setTimeout(function() {
                    x.abort("timeout")
                }, g.timeout));
                try {
                    f = !1, d.send(a, c)
                } catch (e) {
                    if (f) throw e;
                    c(-1, e)
                }
            } else c(-1, "No Transport");

            function c(e, t, i, n) {
                var o, r, a, s, l, c = t;
                f || (f = !0, h && C.clearTimeout(h), d = void 0, p = n || "", x.readyState = 0 < e ? 4 : 0, o = 200 <= e && e < 300 || 304 === e, i && (s = function(e, t, i) {
                    for (var n, o, r, a, s = e.contents, l = e.dataTypes;
                        "*" === l[0];) l.shift(), void 0 === n && (n = e.mimeType || t.getResponseHeader("Content-Type"));
                    if (n)
                        for (o in s)
                            if (s[o] && s[o].test(n)) {
                                l.unshift(o);
                                break
                            } if (l[0] in i) r = l[0];
                    else {
                        for (o in i) {
                            if (!l[0] || e.converters[o + " " + l[0]]) {
                                r = o;
                                break
                            }
                            a = a || o
                        }
                        r = r || a
                    }
                    if (r) return r !== l[0] && l.unshift(r), i[r]
                }(g, x, i)), s = function(e, t, i, n) {
                    var o, r, a, s, l, c = {},
                        d = e.dataTypes.slice();
                    if (d[1])
                        for (a in e.converters) c[a.toLowerCase()] = e.converters[a];
                    for (r = d.shift(); r;)
                        if (e.responseFields[r] && (i[e.responseFields[r]] = t), !l && n && e.dataFilter && (t = e.dataFilter(t, e.dataType)), l = r, r = d.shift())
                            if ("*" === r) r = l;
                            else if ("*" !== l && l !== r) {
                        if (!(a = c[l + " " + r] || c["* " + r]))
                            for (o in c)
                                if ((s = o.split(" "))[1] === r && (a = c[l + " " + s[0]] || c["* " + s[0]])) {
                                    !0 === a ? a = c[o] : !0 !== c[o] && (r = s[0], d.unshift(s[1]));
                                    break
                                } if (!0 !== a)
                            if (a && e.throws) t = a(t);
                            else try {
                                t = a(t)
                            } catch (e) {
                                return {
                                    state: "parsererror",
                                    error: a ? e : "No conversion from " + l + " to " + r
                                }
                            }
                    }
                    return {
                        state: "success",
                        data: t
                    }
                }(g, s, x, o), o ? (g.ifModified && ((l = x.getResponseHeader("Last-Modified")) && (_.lastModified[u] = l), (l = x.getResponseHeader("etag")) && (_.etag[u] = l)), 204 === e || "HEAD" === g.type ? c = "nocontent" : 304 === e ? c = "notmodified" : (c = s.state, r = s.data, o = !(a = s.error))) : (a = c, !e && c || (c = "error", e < 0 && (e = 0))), x.status = e, x.statusText = (t || c) + "", o ? w.resolveWith(y, [r, c, x]) : w.rejectWith(y, [x, c, a]), x.statusCode($), $ = void 0, m && v.trigger(o ? "ajaxSuccess" : "ajaxError", [x, g, o ? r : a]), b.fireWith(y, [x, c]), m && (v.trigger("ajaxComplete", [x, g]), --_.active || _.event.trigger("ajaxStop")))
            }
            return x
        },
        getJSON: function(e, t, i) {
            return _.get(e, t, i, "json")
        },
        getScript: function(e, t) {
            return _.get(e, void 0, t, "script")
        }
    }), _.each(["get", "post"], function(e, o) {
        _[o] = function(e, t, i, n) {
            return w(t) && (n = n || i, i = t, t = void 0), _.ajax(_.extend({
                url: e,
                type: o,
                dataType: n,
                data: t,
                success: i
            }, _.isPlainObject(e) && e))
        }
    }), _._evalUrl = function(e) {
        return _.ajax({
            url: e,
            type: "GET",
            dataType: "script",
            cache: !0,
            async: !1,
            global: !1,
            throws: !0
        })
    }, _.fn.extend({
        wrapAll: function(e) {
            var t;
            return this[0] && (w(e) && (e = e.call(this[0])), t = _(e, this[0].ownerDocument).eq(0).clone(!0), this[0].parentNode && t.insertBefore(this[0]), t.map(function() {
                for (var e = this; e.firstElementChild;) e = e.firstElementChild;
                return e
            }).append(this)), this
        },
        wrapInner: function(i) {
            return w(i) ? this.each(function(e) {
                _(this).wrapInner(i.call(this, e))
            }) : this.each(function() {
                var e = _(this),
                    t = e.contents();
                t.length ? t.wrapAll(i) : e.append(i)
            })
        },
        wrap: function(t) {
            var i = w(t);
            return this.each(function(e) {
                _(this).wrapAll(i ? t.call(this, e) : t)
            })
        },
        unwrap: function(e) {
            return this.parent(e).not("body").each(function() {
                _(this).replaceWith(this.childNodes)
            }), this
        }
    }), _.expr.pseudos.hidden = function(e) {
        return !_.expr.pseudos.visible(e)
    }, _.expr.pseudos.visible = function(e) {
        return !!(e.offsetWidth || e.offsetHeight || e.getClientRects().length)
    }, _.ajaxSettings.xhr = function() {
        try {
            return new C.XMLHttpRequest
        } catch (e) {}
    };
    var Xt = {
            0: 200,
            1223: 204
        },
        Yt = _.ajaxSettings.xhr();
    v.cors = !!Yt && "withCredentials" in Yt, v.ajax = Yt = !!Yt, _.ajaxTransport(function(o) {
        var r, a;
        if (v.cors || Yt && !o.crossDomain) return {
            send: function(e, t) {
                var i, n = o.xhr();
                if (n.open(o.type, o.url, o.async, o.username, o.password), o.xhrFields)
                    for (i in o.xhrFields) n[i] = o.xhrFields[i];
                for (i in o.mimeType && n.overrideMimeType && n.overrideMimeType(o.mimeType), o.crossDomain || e["X-Requested-With"] || (e["X-Requested-With"] = "XMLHttpRequest"), e) n.setRequestHeader(i, e[i]);
                r = function(e) {
                    return function() {
                        r && (r = a = n.onload = n.onerror = n.onabort = n.ontimeout = n.onreadystatechange = null, "abort" === e ? n.abort() : "error" === e ? "number" != typeof n.status ? t(0, "error") : t(n.status, n.statusText) : t(Xt[n.status] || n.status, n.statusText, "text" !== (n.responseType || "text") || "string" != typeof n.responseText ? {
                            binary: n.response
                        } : {
                            text: n.responseText
                        }, n.getAllResponseHeaders()))
                    }
                }, n.onload = r(), a = n.onerror = n.ontimeout = r("error"), void 0 !== n.onabort ? n.onabort = a : n.onreadystatechange = function() {
                    4 === n.readyState && C.setTimeout(function() {
                        r && a()
                    })
                }, r = r("abort");
                try {
                    n.send(o.hasContent && o.data || null)
                } catch (e) {
                    if (r) throw e
                }
            },
            abort: function() {
                r && r()
            }
        }
    }), _.ajaxPrefilter(function(e) {
        e.crossDomain && (e.contents.script = !1)
    }), _.ajaxSetup({
        accepts: {
            script: "text/javascript, application/javascript, application/ecmascript, application/x-ecmascript"
        },
        contents: {
            script: /\b(?:java|ecma)script\b/
        },
        converters: {
            "text script": function(e) {
                return _.globalEval(e), e
            }
        }
    }), _.ajaxPrefilter("script", function(e) {
        void 0 === e.cache && (e.cache = !1), e.crossDomain && (e.type = "GET")
    }), _.ajaxTransport("script", function(i) {
        var n, o;
        if (i.crossDomain) return {
            send: function(e, t) {
                n = _("<script>").prop({
                    charset: i.scriptCharset,
                    src: i.url
                }).on("load error", o = function(e) {
                    n.remove(), o = null, e && t("error" === e.type ? 404 : 200, e.type)
                }), S.head.appendChild(n[0])
            },
            abort: function() {
                o && o()
            }
        }
    });
    var Jt, Zt = [],
        Kt = /(=)\?(?=&|$)|\?\?/;
    _.ajaxSetup({
        jsonp: "callback",
        jsonpCallback: function() {
            var e = Zt.pop() || _.expando + "_" + jt++;
            return this[e] = !0, e
        }
    }), _.ajaxPrefilter("json jsonp", function(e, t, i) {
        var n, o, r, a = !1 !== e.jsonp && (Kt.test(e.url) ? "url" : "string" == typeof e.data && 0 === (e.contentType || "").indexOf("application/x-www-form-urlencoded") && Kt.test(e.data) && "data");
        if (a || "jsonp" === e.dataTypes[0]) return n = e.jsonpCallback = w(e.jsonpCallback) ? e.jsonpCallback() : e.jsonpCallback, a ? e[a] = e[a].replace(Kt, "$1" + n) : !1 !== e.jsonp && (e.url += (At.test(e.url) ? "&" : "?") + e.jsonp + "=" + n), e.converters["script json"] = function() {
            return r || _.error(n + " was not called"), r[0]
        }, e.dataTypes[0] = "json", o = C[n], C[n] = function() {
            r = arguments
        }, i.always(function() {
            void 0 === o ? _(C).removeProp(n) : C[n] = o, e[n] && (e.jsonpCallback = t.jsonpCallback, Zt.push(n)), r && w(o) && o(r[0]), r = o = void 0
        }), "script"
    }), v.createHTMLDocument = ((Jt = S.implementation.createHTMLDocument("").body).innerHTML = "<form></form><form></form>", 2 === Jt.childNodes.length), _.parseHTML = function(e, t, i) {
        return "string" != typeof e ? [] : ("boolean" == typeof t && (i = t, t = !1), t || (v.createHTMLDocument ? ((n = (t = S.implementation.createHTMLDocument("")).createElement("base")).href = S.location.href, t.head.appendChild(n)) : t = S), r = !i && [], (o = E.exec(e)) ? [t.createElement(o[1])] : (o = ye([e], t, r), r && r.length && _(r).remove(), _.merge([], o.childNodes)));
        var n, o, r
    }, _.fn.load = function(e, t, i) {
        var n, o, r, a = this,
            s = e.indexOf(" ");
        return -1 < s && (n = xt(e.slice(s)), e = e.slice(0, s)), w(t) ? (i = t, t = void 0) : t && "object" == typeof t && (o = "POST"), 0 < a.length && _.ajax({
            url: e,
            type: o || "GET",
            dataType: "html",
            data: t
        }).done(function(e) {
            r = arguments, a.html(n ? _("<div>").append(_.parseHTML(e)).find(n) : e)
        }).always(i && function(e, t) {
            a.each(function() {
                i.apply(this, r || [e.responseText, t, e])
            })
        }), this
    }, _.each(["ajaxStart", "ajaxStop", "ajaxComplete", "ajaxError", "ajaxSuccess", "ajaxSend"], function(e, t) {
        _.fn[t] = function(e) {
            return this.on(t, e)
        }
    }), _.expr.pseudos.animated = function(t) {
        return _.grep(_.timers, function(e) {
            return t === e.elem
        }).length
    }, _.offset = {
        setOffset: function(e, t, i) {
            var n, o, r, a, s, l, c = _.css(e, "position"),
                d = _(e),
                u = {};
            "static" === c && (e.style.position = "relative"), s = d.offset(), r = _.css(e, "top"), l = _.css(e, "left"), o = ("absolute" === c || "fixed" === c) && -1 < (r + l).indexOf("auto") ? (a = (n = d.position()).top, n.left) : (a = parseFloat(r) || 0, parseFloat(l) || 0), w(t) && (t = t.call(e, i, _.extend({}, s))), null != t.top && (u.top = t.top - s.top + a), null != t.left && (u.left = t.left - s.left + o), "using" in t ? t.using.call(e, u) : d.css(u)
        }
    }, _.fn.extend({
        offset: function(t) {
            if (arguments.length) return void 0 === t ? this : this.each(function(e) {
                _.offset.setOffset(this, t, e)
            });
            var e, i, n = this[0];
            return n ? n.getClientRects().length ? (e = n.getBoundingClientRect(), i = n.ownerDocument.defaultView, {
                top: e.top + i.pageYOffset,
                left: e.left + i.pageXOffset
            }) : {
                top: 0,
                left: 0
            } : void 0
        },
        position: function() {
            if (this[0]) {
                var e, t, i, n = this[0],
                    o = {
                        top: 0,
                        left: 0
                    };
                if ("fixed" === _.css(n, "position")) t = n.getBoundingClientRect();
                else {
                    for (t = this.offset(), i = n.ownerDocument, e = n.offsetParent || i.documentElement; e && (e === i.body || e === i.documentElement) && "static" === _.css(e, "position");) e = e.parentNode;
                    e && e !== n && 1 === e.nodeType && ((o = _(e).offset()).top += _.css(e, "borderTopWidth", !0), o.left += _.css(e, "borderLeftWidth", !0))
                }
                return {
                    top: t.top - o.top - _.css(n, "marginTop", !0),
                    left: t.left - o.left - _.css(n, "marginLeft", !0)
                }
            }
        },
        offsetParent: function() {
            return this.map(function() {
                for (var e = this.offsetParent; e && "static" === _.css(e, "position");) e = e.offsetParent;
                return e || ve
            })
        }
    }), _.each({
        scrollLeft: "pageXOffset",
        scrollTop: "pageYOffset"
    }, function(t, o) {
        var r = "pageYOffset" === o;
        _.fn[t] = function(e) {
            return H(this, function(e, t, i) {
                var n;
                if (m(e) ? n = e : 9 === e.nodeType && (n = e.defaultView), void 0 === i) return n ? n[o] : e[t];
                n ? n.scrollTo(r ? n.pageXOffset : i, r ? i : n.pageYOffset) : e[t] = i
            }, t, e, arguments.length)
        }
    }), _.each(["top", "left"], function(e, i) {
        _.cssHooks[i] = Ge(v.pixelPosition, function(e, t) {
            if (t) return t = Ve(e, i), Re.test(t) ? _(e).position()[i] + "px" : t
        })
    }), _.each({
        Height: "height",
        Width: "width"
    }, function(a, s) {
        _.each({
            padding: "inner" + a,
            content: s,
            "": "outer" + a
        }, function(n, r) {
            _.fn[r] = function(e, t) {
                var i = arguments.length && (n || "boolean" != typeof e),
                    o = n || (!0 === e || !0 === t ? "margin" : "border");
                return H(this, function(e, t, i) {
                    var n;
                    return m(e) ? 0 === r.indexOf("outer") ? e["inner" + a] : e.document.documentElement["client" + a] : 9 === e.nodeType ? (n = e.documentElement, Math.max(e.body["scroll" + a], n["scroll" + a], e.body["offset" + a], n["offset" + a], n["client" + a])) : void 0 === i ? _.css(e, t, o) : _.style(e, t, i, o)
                }, s, i ? e : void 0, i)
            }
        })
    }), _.each("blur focus focusin focusout resize scroll click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup contextmenu".split(" "), function(e, i) {
        _.fn[i] = function(e, t) {
            return 0 < arguments.length ? this.on(i, null, e, t) : this.trigger(i)
        }
    }), _.fn.extend({
        hover: function(e, t) {
            return this.mouseenter(e).mouseleave(t || e)
        }
    }), _.fn.extend({
        bind: function(e, t, i) {
            return this.on(e, null, t, i)
        },
        unbind: function(e, t) {
            return this.off(e, null, t)
        },
        delegate: function(e, t, i, n) {
            return this.on(t, e, i, n)
        },
        undelegate: function(e, t, i) {
            return 1 === arguments.length ? this.off(e, "**") : this.off(t, e || "**", i)
        }
    }), _.proxy = function(e, t) {
        var i, n, o;
        if ("string" == typeof t && (i = e[t], t = e, e = i), w(e)) return n = s.call(arguments, 2), (o = function() {
            return e.apply(t || this, n.concat(s.call(arguments)))
        }).guid = e.guid = e.guid || _.guid++, o
    }, _.holdReady = function(e) {
        e ? _.readyWait++ : _.ready(!0)
    }, _.isArray = Array.isArray, _.parseJSON = JSON.parse, _.nodeName = T, _.isFunction = w, _.isWindow = m, _.camelCase = V, _.type = $, _.now = Date.now, _.isNumeric = function(e) {
        var t = _.type(e);
        return ("number" === t || "string" === t) && !isNaN(e - parseFloat(e))
    }, "function" == typeof define && define.amd && define("jquery", [], function() {
        return _
    });
    var ei = C.jQuery,
        ti = C.$;
    return _.noConflict = function(e) {
        return C.$ === _ && (C.$ = ti), e && C.jQuery === _ && (C.jQuery = ei), _
    }, e || (C.jQuery = C.$ = _), _
});
var usePageDots = !1,
    imageFunctions = {
        zoom: function(e, t, i) {
            $(e).data("zoom") && $(e + " img").wrap('<span style="display:inline-block"></span>').css("display", "block").parent().zoom({
                touch: t,
                magnify: i || 1
            })
        },
        linkGalleryAndCarousel: function(t, i) {
            i.find(".gallery-cell:nth-child(1)").addClass("is-nav-selected"), i.on("click", ".gallery-cell", function() {
                var e = $(this).index();
                i.find(".is-nav-selected").removeClass("is-nav-selected"), $(this).addClass("is-nav-selected"), t.flickity("select", e)
            }), t.on("select.flickity", function() {
                var e = $(this).data("flickity");
                e && (i.find(".is-nav-selected").removeClass("is-nav-selected"), i.find(".gallery-cell:nth-child(" + (e.selectedIndex + 1) + ")").addClass("is-nav-selected"))
            })
        },
        fullWidth: function(e, s) {
            $(e).each(function() {
                var e = $(this),
                    t = e.attr("alt"),
                    i = e.attr("src");
                if (0 <= t.indexOf("[")) {
                    e.remove();
                    var n = t.match(/\[(.*?)\]/gi);
                    t = t.replace(/\[(.*?)\]/gi, "");
                    var o = $.map(n, function(e, t) {
                            return e.replace(/[\[\]']+/g, "")
                        }),
                        r = ['<div class="position-' + (o.length ? o : "center") + ' caption js-caption">', '<div class="caption-content caption-background-false align-' + (o.length ? o : "center") + '">', '<p class="headline">' + t + "</p>", "</div>", "</div>"].join("");
                    e.attr({
                        alt: t,
                        class: "lazyload blur-up",
                        src: i,
                        dataSizes: "auto"
                    });
                    var a = '<div class="banner">' + e.prop("outerHTML") + r + "</div>";
                    $(s).append(a)
                }
            })
        },
        showSecondaryImage: function() {
            798 < $(window).width() && ($("body").on("mouseenter", ".swap-true", function() {
                $(this).toggleClass("toggle-images")
            }), $("body").on("mouseleave", ".swap-true", function() {
                $(this).toggleClass("toggle-images")
            }))
        }
    },
    recentlyViewed = {
        init: function() {
            var e, t, i, n, o;
            if ($(".js-product_section[data-rv-handle]").length ? (e = $(".js-product_section").data("rv-handle").toString(), t = Cookies.get("recentlyViewed"), i = recentlyViewed.getCookieProducts(t, e)) : $(".recently-viewed__section").length ? (t = Cookies.get("recentlyViewed"), i = recentlyViewed.getCookieProducts(t, e)) : $(".collection-template-section .js-sidebar-recently-viewed").length && (t = Cookies.get("recentlyViewed"), i = recentlyViewed.getCookieProducts(t, e)), i && (o = unescape(i).split(",")), e ? (-1 !== !$.inArray(e, o) && (n = [], o.unshift(e), $.each(o, function(e, t) {
                    -1 === $.inArray(t, n) && n.push(t)
                })), recentlyViewed.setCookieProducts(n)) : n = o, $(".recently-viewed__section").length) {
                var r = ".recently-viewed__section";
                recentlyViewed.getProductInformation(r, n, e)
            } else $(".js-recently-viewed .rv-main").length && (r = ".js-recently-viewed", recentlyViewed.getProductInformation(r, n, e));
            $(".sidebar .js-sidebar-recently-viewed").length && (r = ".sidebar .js-sidebar-recently-viewed", e ? recentlyViewed.getProductInformation(r, n, e) : recentlyViewed.getProductInformation(r, n), $(".js-sidebar-recently-viewed.hidden").parents(".sidebar-block").hide())
        },
        getCookieProducts: function(e, t) {
            return !e && t && Cookies.set("recentlyViewed", t, {
                expires: 30,
                path: "/"
            }), Cookies.get("recentlyViewed")
        },
        setCookieProducts: function(e) {
            Cookies.set("recentlyViewed", escape(e.join(",")), {
                expires: 30,
                path: "/"
            })
        },
        getProductInformation: function(n, t, e) {
            e && t.splice($.inArray(e, t), 1);
            var o = $(n).data("visible-products");
            o && t && (t = t.slice(0, o)), $.each(t, function(i, e) {
                e && ($(n).removeClass("hidden"), $(n).parents(".sidebar-block").show(), $.ajax({
                    type: "GET",
                    url: "/products/" + e + "?view=rv",
                    success: function(e) {
                        var t = $(e).find(".js-recently-viewed-product");
                        $(n).find(" .rv-box-" + i).append(t)
                    },
                    error: function(e, t, i) {
                        console.log(e), console.log(t), console.log(i)
                    },
                    dataType: "html"
                })), $(n).find(".rv-main").hasClass("js-rv-slider") ? (t.length <= o ? $(".js-rv-slider .gallery-cell").eq(t.length).nextAll().addBack().remove() : $(".js-rv-slider .gallery-cell").eq(o).nextAll().addBack().remove(), recentlyViewed.createSlider(n, o)) : $(n).find(".rv-main").hasClass("js-rv-grid") && (t.length <= o ? $(".js-rv-grid .thumbnail").eq(t.length).nextAll().addBack().remove() : $(".js-rv-grid .thumbnail").eq(o).nextAll().addBack().remove())
            })
        },
        createSlider: function(e, t) {
            var i, n, o, r, a, s = $(".js-rv-slider").data("products-per-slide"),
                l = $(".js-rv-slider").data("products-limit"),
                c = t,
                d = $(".js-rv-slider").find(".gallery-cell");
            i = "2" == s && s < c && s < l || "4" == s && s < c && s < l || "6" == s && s < c && s < l ? "left" : "center", r = o = n = s < c && s < l, "2" == s && s < c || "4" == s && s < c || "6" == s && s < c ? a = 0 : "3" == s && c ? a = 1 : "5" == s && c ? a = 2 : "7" == s && c && (a = 3), $(window).width() <= 798 && (i = "center", a = 1, r = o = n = !(d.length <= 2) && (3 < c && 3 < l), $(".js-rv-slider").parents(".even-num-slides").removeClass("even-num-slides")), $(".js-rv-slider").flickity({
                lazyLoad: 2,
                imagesLoaded: !0,
                draggable: n,
                prevNextButtons: o,
                wrapAround: r,
                cellAlign: i,
                pageDots: usePageDots,
                contain: !0,
                freeScroll: !0,
                arrowShape: arrowSize,
                initialIndex: a
            }), $(".js-rv-slider").addClass("slider-initialized")
        }
    },
    featuredCollectionSection = {
        init: function() {
            $(".js-product-slider .products-slider").each(function(e, t) {
                var i, n, o, r, a, s = $(this).data("products-per-slide"),
                    l = $(this).data("products-limit"),
                    c = $(this).data("products-available");
                i = "2" == s && s < c && s < l || "4" == s && s < c && s < l || "6" == s && s < c && s < l ? "left" : "center", r = o = n = s < c && s < l, "2" == s && s < c || "4" == s && s < c || "6" == s && s < c ? a = 0 : "3" == s && c ? a = 1 : "5" == s && c ? a = 2 : "7" == s && c && (a = 3), $(window).width() <= 798 && (i = "center", r = o = n = !0, a = 1, $(this).parents(".even-num-slides").removeClass("even-num-slides")), $(this).flickity({
                    lazyLoad: 2,
                    imagesLoaded: !0,
                    draggable: n,
                    prevNextButtons: o,
                    wrapAround: r,
                    cellAlign: i,
                    pageDots: usePageDots,
                    contain: !0,
                    freeScroll: !0,
                    arrowShape: arrowSize,
                    initialIndex: a
                }), $(this).addClass("slider-initialized")
            })
        },
        unload: function(e) {
            var t = e.find(".js-product-slider");
            t.hasClass("flickity-enabled") && t.flickity("destroy")
        }
    },
    featuredPromotions = {
        init: function() {
            (798 < $(window).width() || 0 == $(window).width()) && ($(".feature-overlay").hover(function() {
                $(this).find(".feature-details").slideDown("100", function() {
                    $(this).addClass("reveal-details")
                })
            }, function() {
                $(this).find(".feature-details").removeClass("reveal-details"), $(this).find(".feature-details").slideUp("100")
            }), $(".js-featured-promotions").each(function(e, t) {
                var i = $(this),
                    n = $(this).data("promo-animation");
                i.waypoint(function() {
                    $(this.element).find(".feature-section").addClass("animated " + n)
                }, {
                    offset: "80%"
                })
            }))
        }
    },
    slideshow = {
        init: function() {
            $(".js-homepage-slideshow").each(function(e, t) {
                var i = $(this),
                    n = {
                        slideshowSpeed: 1e3 * i.data("slideshow-speed"),
                        slideshowTextAnimation: i.data("slideshow-text-animation"),
                        adaptiveHeight: i.data("adaptive-height")
                    };
                if (!i.hasClass("flickity-enabled")) {
                    var o = 1 !== i.find(".gallery-cell").length;
                    if (i.flickity({
                            adaptiveHeight: n.adaptiveHeight,
                            wrapAround: !0,
                            cellAlign: "left",
                            imagesLoaded: !0,
                            prevNextButtons: o,
                            draggable: o,
                            pageDots: usePageDots,
                            autoPlay: n.slideshowSpeed,
                            arrowShape: arrowSize
                        }), "" != n.slideshowTextAnimation) {
                        var r = i.data("flickity");
                        setTimeout(function() {
                            i.find(".gallery-cell:nth-child(1) .caption-content").addClass("animated " + n.slideshowTextAnimation)
                        }, 400), i.on("select.flickity", function() {
                            if (i.is(":visible")) {
                                var e = r.selectedIndex + 1;
                                setTimeout(function() {
                                    i.find(".caption-content").removeClass("animated " + n.slideshowTextAnimation), i.find(".gallery-cell:nth-child(" + e + ") .caption-content").addClass("animated " + n.slideshowTextAnimation)
                                }, 400)
                            }
                        })
                    }
                }
                1 < i.find(".gallery-cell").length ? i.addClass("multi-image") : i.addClass("single-image"), i.find(".gallery-cell").each(function() {
                    var e = 0;
                    $(this).find(".action_button").each(function() {
                        $button = $(this), $(this).width() > e && (e = $(this).width())
                    }), $(this).find(".action_button").width(e)
                })
            })
        },
        unload: function(e) {
            e.find(".js-homepage-slideshow").flickity("destroy")
        }
    },
    testimonial = {
        init: function() {
            $(".js-testimonial").each(function(e, t) {
                var i = $(this),
                    n = {
                        slideshowSpeed: 1e3 * i.data("slideshow-speed"),
                        slideshowTextAnimation: i.data("slideshow-text-animation")
                    };
                if (0 < $(".testimonial-image").length && $(".testimonial-block").each(function() {
                        if (0 == $(this).find(".testimonial-image").length) {
                            var e = $(this).closest(".testimonial-block");
                            $(e).addClass("set-testimonial-height")
                        }
                    }), !i.hasClass("flickity-enabled")) {
                    var o = 1 !== i.find(".gallery-cell").length;
                    if (i.flickity({
                            wrapAround: !0,
                            cellAlign: "left",
                            imagesLoaded: !0,
                            prevNextButtons: o,
                            draggable: o,
                            pageDots: usePageDots,
                            autoPlay: n.slideshowSpeed,
                            arrowShape: arrowSize
                        }), "" != n.slideshowTextAnimation) {
                        var r = i.data("flickity");
                        setTimeout(function() {
                            i.find(".gallery-cell:nth-child(1) .caption-content").addClass("animated " + n.slideshowTextAnimation)
                        }, 400), i.on("select.flickity", function() {
                            if (i.is(":visible")) {
                                var e = r.selectedIndex + 1;
                                setTimeout(function() {
                                    i.find(".caption-content").removeClass("animated " + n.slideshowTextAnimation), i.find(".gallery-cell:nth-child(" + e + ") .caption-content").addClass("animated " + n.slideshowTextAnimation)
                                }, 400)
                            }
                        })
                    }
                }
                1 < i.find(".gallery-cell").length ? i.addClass("multi-image") : i.addClass("single-image"), i.find(".gallery-cell").each(function() {
                    var e = 0;
                    $(this).find(".action_button").each(function() {
                        $button = $(this), $(this).width() > e && (e = $(this).width())
                    }), $(this).find(".action_button").width(e)
                })
            })
        },
        unload: function(e) {
            e.find(".js-testimonial").flickity("destroy")
        }
    },
    gallery = {
        init: function() {
            $(".gallery-horizontal").find(".gallery-image-wrapper").each(function() {
                var e, t, i = $(this),
                    n = $(this).find("img");
                $("<img />").attr("src", $(n).attr("src")).on("load", function() {
                    e = this.width, t = this.height, $(i).css("flex-basis", 200 * e / t), $(i).css("flex-grow", 200 * e / t), $(i).find("i").css("padding-bottom", t / e * 100 + "%")
                })
            }), lightboxGallery.init()
        }
    },
    supports_video = function() {
        return !!document.createElement("video").canPlayType
    },
    videoSection = {
        init: function() {
            var i, n;
            $(".homepage-video").each(function(e, t) {
                $(".homepage-video").length && supports_video() && (i = $(this), n = videoSection.getVideoSettings(i), is_touch_device() && $(window).width() <= 798 && !1 === n.posterImage || $(window).width() <= 798 && !1 === n.posterImage ? videoSection.appendFrame(i, n) : n.autoPlayVideo && 798 < $(window).width() ? videoSection.appendFrame(i, n) : !1 === n.autoPlayVideo && !1 === n.posterImage ? videoSection.appendFrame(i, n) : (i.find(".homepage-video__placeholder").show(), i.find(".placeholder-svg--video").show()))
            }), $("body").on("click", ".video__play-button", function(e) {
                i = $(this).parents(".video-section").find(".homepage-video"), $(this).fadeOut(), n = videoSection.getVideoSettings(i), i.find(".mediaWrapper").length < 1 && i.find("video").length < 1 && videoSection.appendFrame(i, n)
            }), $("body").on("click", "[data-play-video]", function(e) {
                i = $(this).parents(".video-section").find(".homepage-video"), $(this).fadeOut(), n = videoSection.getVideoSettings(i), i.find(".mediaWrapper").length < 1 && i.find("video").length < 1 && videoSection.appendFrame(i, n)
            })
        },
        getVideoSettings: function(e) {
            return {
                container: e.find(".homepage-video"),
                header: e.find(".homepage-video--media"),
                posterImage: e.data("poster-image"),
                videoText: e.find(".homepage-video--media .caption"),
                videoTrigger: e.find("[data-play-video]"),
                autoPlayVideo: e.data("autoplay"),
                displayTextOverVideo: e.data("display-text-over-video"),
                autoloop: e.data("autoloop"),
                id: e.attr("data-video-src"),
                aspectRatio: e.attr("data-aspect-ratio").split(":"),
                provider: e.attr("data-provider").toLowerCase(),
                videoMP4: e.attr("data-video-mp4"),
                videoOGV: e.attr("data-video-ogv")
            }
        },
        createFrame: function(e) {
            var t, i, n, o = "";
            return "youtube" === e.provider ? (t = e.autoloop ? "1&iv_load_policy=3&playlist=" + e.id : 0, n = !1 === e.posterImage && !1 === e.autoPlayVideo ? 0 : 1, i = '<iframe src="//www.youtube.com/embed/' + e.id + "?&autoplay=" + n + "&loop=" + t + '&rel=0&hd=1&showinfo=0&color=white&controls=0" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen ></iframe>') : "vimeo" === e.provider ? (n = !1 === e.posterImage && !1 === e.autoPlayVideo ? 0 : 1, t = e.autoloop ? 1 : 0, i = '<iframe src="//player.vimeo.com/video/' + e.id + "?loop=" + t + "&amp;title=0&amp;byline=0&amp;portrait=0&amp;color=3d96d2&autoplay=" + n + '" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen ></iframe>') : "html5" === e.provider && (!1 !== e.posterImage && (o = ' poster="https://' + e.posterImage), n = !1 === e.posterImage && !1 === e.autoPlayVideo && 0 === is_touch_device() ? " " : (e.autoPlayVideo && !1 !== e.posterImage && (o = ' poster="https://' + e.posterImage), " autoplay "), e.autoloop && (t = ' loop="loop" '), i = "<video " + n + t + o + ' id="video" onclick="this.paused?this.play():this.pause();" ><source src="' + e.videoMP4 + '" type="video/mp4"><source src="' + e.videoOGV + '" type="video/ogg" ></video>'), i
        },
        appendFrame: function(e, t) {
            if (!1 === t.displayTextOverVideo && t.videoText.fadeOut(), e.find(".video__play-button").fadeOut(), e.append(videoSection.createFrame(t)), "html5" != t.provider) {
                var i = t.aspectRatio[1] / t.aspectRatio[0] * 100 + "%";
                e.find("iframe").mediaWrapper({
                    intrinsic: !1,
                    baseWidth: t.aspectRatio[0],
                    baseHeight: t.aspectRatio[1]
                }), e.css({
                    height: 0,
                    paddingBottom: i
                })
            } else e.find(".homepage-video__image").hide()
        },
        unload: function(e) {
            e.find("[data-play-video]").off("click")
        }
    },
    cart = {
        init: function() {
            $("#cart_form .tos_agree").length && $("body").on("click", "#cart_form input[type='submit']", function() {
                if (!$(this).parents("form").find(".tos_agree").is(":checked")) return 0 == $("p.warning").length && $(this).before('<p class="warning animated bounceIn">You must agree with the terms and conditions to checkout.</p>'), !1;
                $(this).submit()
            }), $("body").hasClass("cart") && $(".product_form form").on("submit", function() {
                setTimeout(function() {
                    document.location.href = "/cart"
                }, 500)
            })
        }
    };
selectCallback = function(n, e) {
    var t = $(".product-" + e.product.id),
        i = $(".notify-form-" + e.product.id),
        o = $(".product_form", t),
        r = o.data("variant-inventory"),
        a = $(".notify_form__inputs"),
        s = a.data("url"),
        l = "Please notify me when " + n.title + " becomes available - " + s;
    if (a.hasClass("customer--true")) var c = '<input type="hidden" class="notify_email" name="contact[email]" id="contact[email]" value="" />';
    else c = '<input required type="email" class="notify_email" name="contact[email]" id="contact[email]" placeholder="Enter your email address..." value="" />';
    var d = c + '<input type="hidden" name="challenge" value="false" /><input type="hidden" name="contact[body]" class="notify_form_message" data-body="' + l + '" value="' + l + '" /><input class="action_button" type="submit" value="Send" style="margin-bottom:0px" />';
    if (n && n.featured_image && t.is(":visible") && $(".product_gallery", t).each(function() {
            var e = $(this),
                t = Flickity.data(this);
            if (e.is(":visible") && null != t) {
                var i = $('[data-image-id="' + n.featured_image.id + '"]').data("index");
                t.select(i, !1, !0)
            }
        }), n) {
        r && r.forEach(function(e) {
            e.id === n.id && (n.inventory_quantity = e.inventory_quantity, n.inventory_management = e.inventory_management, n.inventory_policy = e.inventory_policy)
        }), $(".sku span", t).text(n.sku);
        for (var u = 0, p = n.options.length; u < p; u++) {
            var h = o.find('.swatch[data-option-index="' + escape(u) + '"] :radio[value="' + n.options[u].replace(/\"/g, '\\"') + '"]');
            h.length && (h.get(0).checked = !0)
        }
    }
    if (n && 1 == n.available) n.price < n.compare_at_price ? ($(".was_price", t).html('<span class="money">' + Shopify.formatMoney(n.compare_at_price, o.data("money-format")) + "</span>"), $(".savings", t).html("Save " + parseInt(100 * (n.compare_at_price - n.price) / n.compare_at_price) + '% (<span class="money">' + Shopify.formatMoney(n.compare_at_price - n.price, o.data("money-format")) + "</span>)"), $(".current_price", t).parent().addClass("sale")) : ($(".was_price", t).html(""), $(".savings", t).html(""), $(".current_price", t).parent().removeClass("sale")), n.inventory_management && 0 < n.inventory_quantity || ($(".items_left", t).text(""), $(".quantity", t).removeAttr("max")), $(".sold_out", t).text(""), 0 < n.price ? $(".current_price", t).html('<span class="money">' + Shopify.formatMoney(n.price, o.data("money-format")) + "</span>") : $(".current_price", t).html("Free"), $(".add_to_cart", t).removeClass("disabled").removeAttr("disabled").find("span").text($(".add_to_cart", t).data("label")), $("#product-form-" + e.product.id).hasClass("has-sticky-atc-bar") && window.screen.availWidth <= 798 && ($(".add_to_cart", t).find("span").text("Add"), $(".add_to_cart", t).find("span").addClass("icon-bag")), $(".shopify-payment-button", t).show(), i.hide(), a.empty();
    else {
        var f = n ? "Sold Out" : "Unavailable";
        $(".was_price", t).text(""), $(".savings", t).text(""), $(".current_price", t).text(""), $(".items_left", t).text(""), $(".quantity", t).removeAttr("max"), $(".sold_out", t).text(f), $(".add_to_cart", t).addClass("disabled").attr("disabled", "disabled").find("span").text(f), $(".shopify-payment-button", t).hide(), i.hide(), a.empty(), n && !n.available && (i.fadeIn(), a.empty(), a.append(d))
    }
};
var productPage = {
        init: function() {
            var e = !0,
                t = !0,
                i = $(".product_gallery").data("autoplay");
            setTimeout(function() {
                imageFunctions.linkGalleryAndCarousel($(".js-product-page-gallery .product_gallery"), $(".js-product-page-gallery .product_gallery_nav"))
            }, 1e3), $(".js-full-width-product-images").length && imageFunctions.fullWidth(".product-template .product .description img", ".js-full-width-product-images"), $(".product_gallery").hasClass("single-image") && (t = e = !1), is_touch_device() && $(".product_gallery").hasClass("popup-enabled--false") ? (imageFunctions.zoom(".product_gallery"), e = !0) : 0 == is_touch_device() && imageFunctions.zoom(".product_gallery", !1), $(".product_gallery").flickity({
                adaptiveHeight: !0,
                wrapAround: "true",
                cellAlign: "left",
                draggable: e,
                contain: !0,
                imagesLoaded: !0,
                lazyLoad: 2,
                pageDots: !1,
                prevNextButtons: t,
                autoPlay: !!i && 6e3,
                selectedAttraction: .1,
                friction: 1,
                arrowShape: arrowSize
            });
            var n = !0,
                o = !1,
                r = !1;
            7 <= $(".product_gallery_nav .gallery-cell").length && (r = !(o = !(n = !1))), $(".product_gallery_nav.product_gallery_nav--bottom-slider").flickity({
                asNavFor: ".product_gallery",
                adaptiveHeight: !1,
                wrapAround: r,
                contain: !0,
                cellAlign: "left",
                draggable: !0,
                groupCells: n,
                prevNextButtons: o,
                pageDots: !1,
                lazyLoad: 2,
                selectedAttraction: .01,
                friction: .15,
                arrowShape: arrowSize
            }), $(".js-product_section .product_form_options").each(function() {
                new Shopify.OptionSelectors($(this).data("select-id"), {
                    product: $(this).data("product"),
                    onVariantSelected: selectCallback,
                    enableHistoryState: $(this).data("enable-state")
                })
            }), $(".notify_form .contact-form").each(function() {
                var t = $(this);
                t.on("submit", function(e) {
                    "true" !== $('input[name="challenge"]', t).val() && ($.ajax({
                        type: t.attr("method"),
                        url: t.attr("action"),
                        data: t.serialize(),
                        success: function(e) {
                            t.fadeOut("slow", function() {
                                t.prev(".message").html("Thanks! We will notify you when this product becomes available!")
                            })
                        },
                        error: function(e) {
                            $('input[name="challenge"]', t).val("true"), t.submit()
                        }
                    }), e.preventDefault())
                })
            }), $("body").on("change", ".swatch :radio", function() {
                var e = $(this).closest(".swatch").attr("data-option-index"),
                    t = $(this).val(),
                    i = $(this).closest(".product_form");
                if (i.siblings(".notify_form").length) var n = i.siblings(".notify_form");
                else n = $(".js-notify-form");
                var o = i.find(".swatch_options input:checked").eq(0).val(),
                    r = i.find(".swatch_options input:checked").eq(1).val() || "",
                    a = i.find(".swatch_options input:checked").eq(2).val() || "";
                if (o && r && a) var s = o + " / " + r + " / " + a;
                else s = o && r ? o + " / " + r : o;
                n.find(".notify_form_message").attr("value", n.find(".notify_form_message").data("body") + " - " + s), $(this).closest("form").find(".single-option-selector").eq(e).val(t).trigger("change")
            }), lightboxGallery.init()
        },
        productSwatches: function() {
            if ($(".js-product_section").length) {
                var e = $(".js-product_section").find(".product_form");
                e.addClass("is-visible"), e.each(function() {
                    var e = $(this).data("product"),
                        t = ".product-" + $(this).data("product-id") + " .js-product_section";
                    1 < $(this).find(".swatch_options .swatch").length && Shopify.linkOptionSelectors(e, t)
                })
            }
            1 < $(".js-product_section").length && $("body").on("click", ".swatch-element", function() {
                var e = $(this).data("value");
                $(this).siblings('input[value="' + e.replace(/\"/g, '\\"') + '"]').prop("checked", !0).trigger("change");
                var t = $(this).parents(".product_form").data("product"),
                    i = ".product-" + $(this).parents(".product_form").data("product-id") + " .js-product_section";
                1 < $(this).parents(".product_form").find(".swatch_options .swatch").length && Shopify.linkOptionSelectors(t, i)
            })
        },
        relatedProducts: function() {
            $(".js-related-products-slider .products-slider").each(function(e, t) {
                var i, n, o, r, a, s = $(this).data("products-per-slide"),
                    l = $(this).data("products-limit"),
                    c = $(this).data("products-available");
                i = "2" == s && s < c && s < l || "4" == s && s < c && s < l || "6" == s && s < c && s < l ? "left" : "center", r = o = n = s < c && s < l, "2" == s && s < c || "4" == s && s < c || "6" == s && s < c ? a = 0 : "3" == s && c ? a = 1 : "5" == s && c ? a = 2 : "7" == s && c && (a = 3), $(window).width() <= 798 && (i = "center", r = o = n = !0, a = 1, $(this).parents(".even-num-slides").removeClass("even-num-slides")), $(this).flickity({
                    lazyLoad: 2,
                    imagesLoaded: !0,
                    draggable: n,
                    cellAlign: i,
                    prevNextButtons: o,
                    wrapAround: r,
                    pageDots: usePageDots,
                    contain: !0,
                    freeScroll: !0,
                    arrowShape: arrowSize,
                    initialIndex: a
                })
            })
        },
        initializeQuantityBox: function() {
            $("body").on("click", ".js-change-quantity", function() {
                var e = $(this),
                    t = $(this).siblings("input"),
                    i = parseInt(t.val()),
                    n = 1e29,
                    o = t.attr("min") || 0;
                return null != t.attr("max") && (n = t.attr("max")), isNaN(i) || i < o ? (t.val(o), !1) : n < i ? (t.val(n), !1) : ("plus" == e.data("func") ? i < n && t.val(i + 1) : (o < i && t.val(i - 1), e.parents(".cart_item").length && i - 1 == 0 && e.closest(".cart_item").addClass("animated fadeOutUp")), void t.trigger("change"))
            })
        },
        unload: function(e) {
            e.find(".products-slider").flickity("destroy")
        }
    },
    newsletter_popup = {
        init: function() {
            Cookies.get("popup"), newsletter_popup.open()
        },
        open: function() {
            798 < $(window).width() && setTimeout(function() {
                $("[data-remodal-id=newsletter]").remodal().open()
            }, 0)
        }
    },
    header = {
        init: function() {
            function n() {
                $("body").removeClass("is-active").removeClass("blocked-scroll"), $(".dropdown_link").toggleClass("active_link"), $(".cart_container").removeClass("active_link")
            }
            // By inscoder HG - Cart drawer close icon
            $(document).on('click', '#mob-close-cart', function(){
                n();
            });
            $(".dropdown_link--vertical").length && ($(".dropdown_link--vertical, .vertical-menu_submenu").on("mouseover", function(e) {
                $(this).parents(".main_nav").find('[data-dropdown="' + $(this).data("dropdown-rel") + '"]'), $(this).attr("data-click-count"), $(".active_link").removeClass("active_link"), $(this).hasClass("active_link") || ($(this).children("a").addClass("active_link"), $(".is-absolute").parent().removeClass("feature_image"))
            }), is_touch_device() && $(".vertical-menu .sublink a, .vertical-menu_submenu .sublink a").on("touchstart click", function(o) {
                o.stopPropagation();
                var e = $(this);

                function t(e) {
                    var t = $(e).parents(".main_nav").find('[data-dropdown="' + $(this).data("dropdown-rel") + '"]'),
                        i = $(e).next(".vertical-menu_submenu"),
                        n = $(e).attr("data-click-count");
                    if ($(".dropdown_link--vertical").not(e).attr("data-click-count", 0), $(".dropdown_link--vertical").attr("data-no-instant", !0), $(".dropdown_container").hide(), t.show(), $(".vertical-menu_submenu").removeClass("is-visible"), i.addClass("is-visible"), "touchstart" == o.type && (n++, $(e).attr("data-click-count", n), n < 2)) return o.preventDefault(), o.stopPropagation(), !1
                }
                "touchstart" == o.type ? (clicked = !0, $(this).attr("data-click-count") < 1 && (t(e), o.preventDefault())) : "click" != o.type || clicked ? clicked = !1 : $(this).attr("data-click-count") < 1 && (t(e), o.preventDefault())
            })), $(".promo_banner").length && "dismiss" != Cookies.get("promo_banner") && ($("body").addClass("promo_banner-show"), $(".promo_banner").on("click", ".promo_banner-close", function() {
                $("body").removeClass("promo_banner-show"), Cookies.set("promo_banner", "dismiss", {
                    expires: 30
                })
            })), $(".vertical-menu_submenu, .vertical-menu_sub-submenu").each(function() {
                $(this).is(":off-right") && $(this).addClass("vertical-menu--align-right")
            }), $("html").on("click", function(e) {
                !$(e.target).closest(".cart_container").length && $(".cart_content").is(":visible") && n(), !$(e.target).closest(".dropdown_container").length && $(".dropdown").is(":visible") && ($("body").removeClass("is-active"), $(".dropdown_link").removeClass("active_link"), $(".dropdown_container").hide(), $(".mobile_nav").find("div").removeClass("open"))
            }), 798 < $(window).width() ? ($(".header").hasClass("header-fixed--true") ? ($("body").on("click", '.banner a[href^="#"]', function(e) {
                e.preventDefault();
                var t = $(this).attr("href"),
                    i = $(".main_nav_wrapper.sticky_nav").outerHeight();
                $("html, body").animate({
                    scrollTop: $(t).offset().top - i
                }, 2e3)
            }), $(".main_nav_wrapper").hasClass("sticky_nav") || new Headhesive(".main_nav_wrapper", {
                offset: 700,
                throttle: 300,
                classes: {
                    clone: "sticky_nav",
                    stick: "sticky_nav--stick",
                    unstick: "sticky_nav--unstick"
                },
                onInit: function() {
                    $(".sticky_nav .secondary_logo").css("display", "none"), $(".sticky_nav .primary_logo").css("display", "block"), $(".sticky_nav .icon-search").css("display", "block"), $(".sticky_nav .search_container").css("display", "none"), $(".sticky_nav .nav:last").prepend($(".header .cart_container").clone()), $(".sticky_nav").height(), $(".sticky_nav .mini_cart").css("height", $(".sticky_nav").height() + 5), $(".sticky_nav .cart_content").css("top", $(".sticky_nav").height())
                },
                onUnstick: function() {
                    $(".cart_container").removeClass("active_link")
                }
            })) : ($(".header-fixed--true").removeClass("header-fixed--true"), 1 < $(".main_nav_wrapper").length && $(".main_nav_wrapper").first().remove()), $("img.primary_logo:visible") ? $(".logo img", $(".feature_image .header")).attr("src", $(".logo img").data("src-home")) : $(".logo img").attr("src", $(".logo img").data("src"))) : $("#header").hasClass("mobile_nav-fixed--true") ? ($("body").addClass("mobile_nav-fixed--true"), $("body").on("click", '.banner a[href^="#"]', function(e) {
                e.preventDefault();
                var t = $(this).attr("href"),
                    i = $("#header").outerHeight();
                $("html, body").animate({
                    scrollTop: $(t).offset().top - i
                }, 2e3)
            })) : $("body").addClass("mobile_nav-fixed--false"), is_touch_device() || $(window).width() <= 798 ? ($(".dropdown_link").attr("data-no-instant", !0), $("body").on("click", ".dropdown_link", function(e) {
                if ($(".nav a").removeClass("active_link"), $("#header").is(":visible")) {
                    var t = $(this).parents("#header").find('[data-dropdown="' + $(this).data("dropdown-rel") + '"]');
                    $(this).hasClass("mini_cart") || $(".cart_container").removeClass("active_link")
                } else {
                    if ($(this).hasClass("icon-search")) return window.location = $(this).attr("href"), !1;
                    t = $(this).parents(".main_nav").find('[data-dropdown="' + $(this).data("dropdown-rel") + '"]')
                }
                if (t.is(":visible") || void 0 === t.attr("class") ? (t.hide(), $("body").removeClass("is-active")) : ($(".dropdown_container").hide(), $(this).hasClass("cart_container") || $(".is-absolute").parent().removeClass("feature_image"), t.show(), $("body").addClass("is-active"), $(".mobile_nav").find("div").removeClass("open")), t.is(":visible")) return e.stopPropagation(), !1
            }), $("body").on("click", ".mobile_nav", function() {
                $(this).find("div").toggleClass("open")
            }), $(".mini_cart").on("click", function(e) {
                // added by inscoder HG - cart drawer dynamic height
                var elementCartDrawer = document.getElementById('cart_content_height');
                resizeElementHeight(elementCartDrawer);
                // end
                var t, i = $(this).parent();
                i.hasClass("active_link") ? (n(), $("body").removeClass("blocked-scroll")) : (t = i, $("body").addClass("blocked-scroll"), $(".mobile_nav div").removeClass("open"), $(".dropdown_link").removeClass("active_link"), t.addClass("active_link"), $("body").addClass("blocked-scroll")), (is_touch_device() || $(window).width() <= 798) && e.preventDefault()
            }), $(".cart_content__continue-shopping").on("click", function(e) {
                n()
            })) : ($(".nav a, .logo a").not(".cart_content a").on("mouseenter", function() {
                $(this).hasClass("active_link") || ($(".dropdown_container").hide(), $(".active_link").removeClass("active_link"), $(".is-absolute").parent().addClass("feature_image"))
            }), $(".main_nav, .top_bar, .cart_container").on("mouseleave", function() {
                798 < $(window).width() && $(".dropdown_container").hide(),
                $(".is-absolute").parent().addClass("feature_image");
                if(!$('.drawer_block input').is(':focus')) {$(".active_link").removeClass("active_link")};
            }), $(".dropdown_link, .dropdown_link--vertical").attr("data-click-count", 0), $(".dropdown_link").on("mouseover touchstart", function(e) {
                798 < $(window).width() && $(".dropdown_container").hide();
                var t = $(this).parents(".main_nav").find('[data-dropdown="' + $(this).data("dropdown-rel") + '"]'),
                    i = $(this).attr("data-click-count");
                if ($(".active_link").removeClass("active_link"), $(this).hasClass("active_link") || (t.show(), $(this).hasClass("mini_cart") ? $(this).parent(".cart_container").addClass("active_link") : (798 < $(window).width() && $(this).addClass("active_link"), $(".is-absolute").parent().removeClass("feature_image"))), is_touch_device() && ($(".dropdown_link").not(this).attr("data-click-count", 0), $(".dropdown_link").attr("data-no-instant", !0), "touchstart" == e.type && (i++, $(this).attr("data-click-count", i), i < 2))) return e.preventDefault(), e.stopPropagation(), !1
            }))
        },
        removeDataAttributes: function(e) {
            if ($(e).length) {
                var t, i = $(e),
                    n = [],
                    o = i.get(0).attributes,
                    r = o.length;
                for (t = 0; t < r; t++) "data-" === o[t].name.substring(0, 5) && n.push(o[t].name);
                $.each(n, function(e, t) {
                    i.removeAttr(t)
                })
            }
        },
        loadMegaMenu: function() {
            $(".sticky_nav .mega-menu").remove(), $(".header .mega-menu").remove(), $(".mega-menu-container .mega-menu").clone().appendTo(".sticky_nav .main_nav"), header.removeDataAttributes(".sticky_nav .mega-menu.dropdown_container .dropdown_column"), $(".mega-menu-container .mega-menu").each(function(e) {
                var t = $(this).data("dropdown");
                $('[data-dropdown-rel="' + t + '"]').find("span").remove(), $('[data-dropdown-rel="' + t + '"]').not(".icon-search").append(' <span class="icon-down-arrow"></span>').addClass("mega-menu-parent").addClass("dropdown_link").removeClass("top_link"), $('[data-dropdown="' + t + '"]').each(function(e) {
                    $(this).hasClass("mega-menu") || $(this).remove()
                }), $(this).clone().appendTo(".header .main_nav")
            }), $(".dropdown_link--vertical").length && ($(".dropdown_link--vertical.mega-menu-parent + .vertical-menu_submenu").remove(), $(".dropdown_link--vertical:not(.mega-menu-parent)").each(function(e) {
                var t = $(this).data("dropdown-rel");
                $('[data-dropdown="' + t + '"]').remove()
            })), $(".mega-menu-parent").on("mouseenter", function() {
                $(this).hasClass("active_link") || ($(".dropdown_container").hide(), $(this).parents(".main_nav").find('[data-dropdown="' + $(this).data("dropdown-rel") + '"]').toggle(), $(this).addClass("active_link"), $(".is-absolute").parent().removeClass("feature_image"))
            }), header.removeDataAttributes(".header .mega-menu.dropdown_container .dropdown_column"), (is_touch_device() || $(window).width() <= 798) && $(".dropdown_link").attr("data-no-instant", !0), header.loadMobileMegaMenu()
        },
        loadMobileMegaMenu: function() {
            $(".mega-menu-container .mobile-mega-menu").each(function(e) {
                $('[data-mobile-dropdown-rel="' + $(this).data("mobile-dropdown") + '"]').find("span").remove(), $('[data-mobile-dropdown-rel="' + $(this).data("mobile-dropdown") + '"] > a').append(' <span class="right icon-down-arrow"></span>').attr("data-no-instant", "true"), $('[data-mobile-dropdown-rel="' + $(this).data("mobile-dropdown") + '"]').addClass("mobile-mega-menu-parent sublink"), $('[data-mobile-dropdown-rel="' + $(this).data("mobile-dropdown") + '"]').append(this), $('[data-mobile-dropdown-rel="' + $(this).data("mobile-dropdown") + '"] > ul').each(function(e) {
                    $(this).hasClass("mobile-mega-menu") || $(this).remove()
                })
            })
        },
        unloadMegaMenu: function() {
            $(".header .mega-menu").remove(), $(".mega-menu-container .mega-menu").each(function(e) {
                $(this).data("dropdown"), $('.mega-menu-parent[data-dropdown-rel="' + $(this).data("dropdown") + '"]').find(".icon-down-arrow").remove()
            })
        },
        unload: function() {
            $("body").off("click", ".mobile_nav"), $("body").off("click", ".dropdown_link"), $("html").off("click"), $(".mini_cart").off("click"), $(".cart_content__continue-shopping").off("click"), $("body").off("click", '.banner a[href^="#"]')
        }
    },
    enableLoadMoreSearch = function() {
        $("body").on("click", ".js-load-more a", function(e) {
            return enableInfiniteSearchScroll(), e.stopPropagation(), !1
        })
    },
    enableInfiniteSearchScroll = function() {
        $(".search-matrix").length && new Waypoint.Infinite({
            element: $(".search-matrix")[0],
            items: ".search-matrix",
            more: ".load-more__btn",
            loadingClass: "loading-in-progress",
            onBeforePageLoad: function() {
                $(".js-load-more").hide()
            },
            onAfterPageLoad: function(e) {
                $(".search-matrix > .search-matrix .thumbnail").unwrap(".search-matrix")
            }
        })
    },
    mapFunction = {
        init: function() {
            if ($(".maps").hasClass("js-api-map")) {
                var i = [];
                $(".map").each(function(e, t) {
                    i.push(this), i[e].sectionid = $(this).data("id"), i[e].address = $(this).data("address"), i[e].directions = $(this).data("directions-address"), i[e].zoom = $(this).data("zoom"), i[e].mapstyle = $(this).data("style"), i[e].showpin = $(this).data("pin"), i[e].apikey = $(this).data("api-key")
                }), $.each(i, function(e, t) {
                    $.ajaxSetup({
                        cache: !0
                    }), $.getScript("https://maps.googleapis.com/maps/api/js?key=" + i[e].apikey).then(function() {
                        mapFunction.findLocation(i[e]), $.ajaxSetup({
                            cache: !1
                        })
                    })
                })
            }
        },
        findLocation: function(i) {
            var n, o;
            (new google.maps.Geocoder).geocode({
                address: i.address
            }, function(e, t) {
                t == google.maps.GeocoderStatus.OK ? (n = e[0].geometry.location.lat(), o = e[0].geometry.location.lng(), mapFunction.initMap(n, o, i)) : console.log("Error:" + t)
            })
        },
        initMap: function(e, t, i) {
            var n, o = {
                lat: e,
                lng: t
            };
            n = "aubergine" == i.mapstyle ? [{
                elementType: "geometry",
                stylers: [{
                    color: "#1d2c4d"
                }]
            }, {
                elementType: "labels.text.fill",
                stylers: [{
                    color: "#8ec3b9"
                }]
            }, {
                elementType: "labels.text.stroke",
                stylers: [{
                    color: "#1a3646"
                }]
            }, {
                featureType: "administrative.country",
                elementType: "geometry.stroke",
                stylers: [{
                    color: "#4b6878"
                }]
            }, {
                featureType: "administrative.land_parcel",
                elementType: "labels.text.fill",
                stylers: [{
                    color: "#64779e"
                }]
            }, {
                featureType: "administrative.province",
                elementType: "geometry.stroke",
                stylers: [{
                    color: "#4b6878"
                }]
            }, {
                featureType: "landscape.man_made",
                elementType: "geometry.stroke",
                stylers: [{
                    color: "#334e87"
                }]
            }, {
                featureType: "landscape.natural",
                elementType: "geometry",
                stylers: [{
                    color: "#023e58"
                }]
            }, {
                featureType: "poi",
                elementType: "geometry",
                stylers: [{
                    color: "#283d6a"
                }]
            }, {
                featureType: "poi",
                elementType: "labels.text.fill",
                stylers: [{
                    color: "#6f9ba5"
                }]
            }, {
                featureType: "poi",
                elementType: "labels.text.stroke",
                stylers: [{
                    color: "#1d2c4d"
                }]
            }, {
                featureType: "poi.park",
                elementType: "geometry.fill",
                stylers: [{
                    color: "#023e58"
                }]
            }, {
                featureType: "poi.park",
                elementType: "labels.text.fill",
                stylers: [{
                    color: "#3C7680"
                }]
            }, {
                featureType: "road",
                elementType: "geometry",
                stylers: [{
                    color: "#304a7d"
                }]
            }, {
                featureType: "road",
                elementType: "labels.text.fill",
                stylers: [{
                    color: "#98a5be"
                }]
            }, {
                featureType: "road",
                elementType: "labels.text.stroke",
                stylers: [{
                    color: "#1d2c4d"
                }]
            }, {
                featureType: "road.highway",
                elementType: "geometry",
                stylers: [{
                    color: "#2c6675"
                }]
            }, {
                featureType: "road.highway",
                elementType: "geometry.stroke",
                stylers: [{
                    color: "#255763"
                }]
            }, {
                featureType: "road.highway",
                elementType: "labels.text.fill",
                stylers: [{
                    color: "#b0d5ce"
                }]
            }, {
                featureType: "road.highway",
                elementType: "labels.text.stroke",
                stylers: [{
                    color: "#023e58"
                }]
            }, {
                featureType: "transit",
                elementType: "labels.text.fill",
                stylers: [{
                    color: "#98a5be"
                }]
            }, {
                featureType: "transit",
                elementType: "labels.text.stroke",
                stylers: [{
                    color: "#1d2c4d"
                }]
            }, {
                featureType: "transit.line",
                elementType: "geometry.fill",
                stylers: [{
                    color: "#283d6a"
                }]
            }, {
                featureType: "transit.station",
                elementType: "geometry",
                stylers: [{
                    color: "#3a4762"
                }]
            }, {
                featureType: "water",
                elementType: "geometry",
                stylers: [{
                    color: "#0e1626"
                }]
            }, {
                featureType: "water",
                elementType: "labels.text.fill",
                stylers: [{
                    color: "#4e6d70"
                }]
            }] : "retro" == i.mapstyle ? [{
                elementType: "geometry",
                stylers: [{
                    color: "#ebe3cd"
                }]
            }, {
                elementType: "labels.text.fill",
                stylers: [{
                    color: "#523735"
                }]
            }, {
                elementType: "labels.text.stroke",
                stylers: [{
                    color: "#f5f1e6"
                }]
            }, {
                featureType: "administrative",
                elementType: "geometry.stroke",
                stylers: [{
                    color: "#c9b2a6"
                }]
            }, {
                featureType: "administrative.land_parcel",
                elementType: "geometry.stroke",
                stylers: [{
                    color: "#dcd2be"
                }]
            }, {
                featureType: "administrative.land_parcel",
                elementType: "labels.text.fill",
                stylers: [{
                    color: "#ae9e90"
                }]
            }, {
                featureType: "landscape.natural",
                elementType: "geometry",
                stylers: [{
                    color: "#dfd2ae"
                }]
            }, {
                featureType: "poi",
                elementType: "geometry",
                stylers: [{
                    color: "#dfd2ae"
                }]
            }, {
                featureType: "poi",
                elementType: "labels.text.fill",
                stylers: [{
                    color: "#93817c"
                }]
            }, {
                featureType: "poi.park",
                elementType: "geometry.fill",
                stylers: [{
                    color: "#a5b076"
                }]
            }, {
                featureType: "poi.park",
                elementType: "labels.text.fill",
                stylers: [{
                    color: "#447530"
                }]
            }, {
                featureType: "road",
                elementType: "geometry",
                stylers: [{
                    color: "#f5f1e6"
                }]
            }, {
                featureType: "road.arterial",
                elementType: "geometry",
                stylers: [{
                    color: "#fdfcf8"
                }]
            }, {
                featureType: "road.highway",
                elementType: "geometry",
                stylers: [{
                    color: "#f8c967"
                }]
            }, {
                featureType: "road.highway",
                elementType: "geometry.stroke",
                stylers: [{
                    color: "#e9bc62"
                }]
            }, {
                featureType: "road.highway.controlled_access",
                elementType: "geometry",
                stylers: [{
                    color: "#e98d58"
                }]
            }, {
                featureType: "road.highway.controlled_access",
                elementType: "geometry.stroke",
                stylers: [{
                    color: "#db8555"
                }]
            }, {
                featureType: "road.local",
                elementType: "labels.text.fill",
                stylers: [{
                    color: "#806b63"
                }]
            }, {
                featureType: "transit.line",
                elementType: "geometry",
                stylers: [{
                    color: "#dfd2ae"
                }]
            }, {
                featureType: "transit.line",
                elementType: "labels.text.fill",
                stylers: [{
                    color: "#8f7d77"
                }]
            }, {
                featureType: "transit.line",
                elementType: "labels.text.stroke",
                stylers: [{
                    color: "#ebe3cd"
                }]
            }, {
                featureType: "transit.station",
                elementType: "geometry",
                stylers: [{
                    color: "#dfd2ae"
                }]
            }, {
                featureType: "water",
                elementType: "geometry.fill",
                stylers: [{
                    color: "#b9d3c2"
                }]
            }, {
                featureType: "water",
                elementType: "labels.text.fill",
                stylers: [{
                    color: "#92998d"
                }]
            }] : "silver" == i.mapstyle ? [{
                elementType: "geometry",
                stylers: [{
                    color: "#f5f5f5"
                }]
            }, {
                elementType: "labels.icon",
                stylers: [{
                    visibility: "off"
                }]
            }, {
                elementType: "labels.text.fill",
                stylers: [{
                    color: "#616161"
                }]
            }, {
                elementType: "labels.text.stroke",
                stylers: [{
                    color: "#f5f5f5"
                }]
            }, {
                featureType: "administrative.land_parcel",
                elementType: "labels.text.fill",
                stylers: [{
                    color: "#bdbdbd"
                }]
            }, {
                featureType: "poi",
                elementType: "geometry",
                stylers: [{
                    color: "#eeeeee"
                }]
            }, {
                featureType: "poi",
                elementType: "labels.text.fill",
                stylers: [{
                    color: "#757575"
                }]
            }, {
                featureType: "poi.park",
                elementType: "geometry",
                stylers: [{
                    color: "#e5e5e5"
                }]
            }, {
                featureType: "poi.park",
                elementType: "labels.text.fill",
                stylers: [{
                    color: "#9e9e9e"
                }]
            }, {
                featureType: "road",
                elementType: "geometry",
                stylers: [{
                    color: "#ffffff"
                }]
            }, {
                featureType: "road.arterial",
                elementType: "labels.text.fill",
                stylers: [{
                    color: "#757575"
                }]
            }, {
                featureType: "road.highway",
                elementType: "geometry",
                stylers: [{
                    color: "#dadada"
                }]
            }, {
                featureType: "road.highway",
                elementType: "labels.text.fill",
                stylers: [{
                    color: "#616161"
                }]
            }, {
                featureType: "road.local",
                elementType: "labels.text.fill",
                stylers: [{
                    color: "#9e9e9e"
                }]
            }, {
                featureType: "transit.line",
                elementType: "geometry",
                stylers: [{
                    color: "#e5e5e5"
                }]
            }, {
                featureType: "transit.station",
                elementType: "geometry",
                stylers: [{
                    color: "#eeeeee"
                }]
            }, {
                featureType: "water",
                elementType: "geometry",
                stylers: [{
                    color: "#c9c9c9"
                }]
            }, {
                featureType: "water",
                elementType: "labels.text.fill",
                stylers: [{
                    color: "#9e9e9e"
                }]
            }] : "night" == i.mapstyle ? [{
                elementType: "geometry",
                stylers: [{
                    color: "#242f3e"
                }]
            }, {
                elementType: "labels.text.fill",
                stylers: [{
                    color: "#746855"
                }]
            }, {
                elementType: "labels.text.stroke",
                stylers: [{
                    color: "#242f3e"
                }]
            }, {
                featureType: "administrative.locality",
                elementType: "labels.text.fill",
                stylers: [{
                    color: "#d59563"
                }]
            }, {
                featureType: "poi",
                elementType: "labels.text.fill",
                stylers: [{
                    color: "#d59563"
                }]
            }, {
                featureType: "poi.park",
                elementType: "geometry",
                stylers: [{
                    color: "#263c3f"
                }]
            }, {
                featureType: "poi.park",
                elementType: "labels.text.fill",
                stylers: [{
                    color: "#6b9a76"
                }]
            }, {
                featureType: "road",
                elementType: "geometry",
                stylers: [{
                    color: "#38414e"
                }]
            }, {
                featureType: "road",
                elementType: "geometry.stroke",
                stylers: [{
                    color: "#212a37"
                }]
            }, {
                featureType: "road",
                elementType: "labels.text.fill",
                stylers: [{
                    color: "#9ca5b3"
                }]
            }, {
                featureType: "road.highway",
                elementType: "geometry",
                stylers: [{
                    color: "#746855"
                }]
            }, {
                featureType: "road.highway",
                elementType: "geometry.stroke",
                stylers: [{
                    color: "#1f2835"
                }]
            }, {
                featureType: "road.highway",
                elementType: "labels.text.fill",
                stylers: [{
                    color: "#f3d19c"
                }]
            }, {
                featureType: "transit",
                elementType: "geometry",
                stylers: [{
                    color: "#2f3948"
                }]
            }, {
                featureType: "transit.station",
                elementType: "labels.text.fill",
                stylers: [{
                    color: "#d59563"
                }]
            }, {
                featureType: "water",
                elementType: "geometry",
                stylers: [{
                    color: "#17263c"
                }]
            }, {
                featureType: "water",
                elementType: "labels.text.fill",
                stylers: [{
                    color: "#515c6d"
                }]
            }, {
                featureType: "water",
                elementType: "labels.text.stroke",
                stylers: [{
                    color: "#17263c"
                }]
            }] : [], $(".js-map-link").attr("href", "https://www.google.com/maps/place/" + i.directions + "/@" + e + "," + t);
            var r = {
                    zoom: i.zoom,
                    center: o,
                    styles: n,
                    disableDefaultUI: !1
                },
                a = new google.maps.Map(document.getElementById(i.sectionid), r);
            1 == i.showpin && new google.maps.Marker({
                position: o,
                map: a
            })
        }
    },
    enableLoadMoreProducts = function() {
        $("body").on("click", ".js-load-more a", function(e) {
            return enableInfiniteScroll(), e.stopPropagation(), !1
        })
    },
    enableInfiniteScroll = function() {
        $(".collection-matrix").length && new Waypoint.Infinite({
            element: $(".collection-matrix")[0],
            items: ".collection-matrix",
            more: ".load-more__btn",
            loadingClass: "loading-in-progress",
            onBeforePageLoad: function() {
                $(".js-load-more").hide()
            },
            onAfterPageLoad: function(e) {
                $(".collection-matrix > .collection-matrix .thumbnail").unwrap(".collection-matrix")
            }
        })
    };
if (Shopify.queryParams = {}, location.search.length)
    for (var aKeyValue, i = 0, aCouples = location.search.substr(1).split("&"); i < aCouples.length; i++) aKeyValue = aCouples[i].split("="), 1 < aKeyValue.length && (Shopify.queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]));
var quickFilter = {
    init: function() {
        var i = [],
            e = "",
            n = "",
            t = ($.url("hostname"), $.url("1") ? "/" + $.url("1") + "/" : ""),
            o = $.url("2") ? $.url("2") + "/" : "",
            r = ($.url("3"), t + o);
        e = $("#sort-by").length ? $("#sort-by").val() : url("?sort_by"), $("#tag_filter").length && $("#tag_filter").data("default-collection") != $("#tag_filter").val() && (urlTag = $("#tag_filter").val().substr($("#tag_filter").val().lastIndexOf("/") + 1), "all" != urlTag && (-1 < $.inArray(urlTag, i) || i.unshift(urlTag))), $("[data-option-filter] input:checked").each(function() {
            i.push($(this).val())
        }), i = $.makeArray(i), $.each(i, function(e, t) {
            e != i.length - 1 ? n += i[e] + "+" : n += i[e]
        }), Shopify.queryParams.sort_by = e, e = "?" + $.param(Shopify.queryParams), quickFilter.processUrl(r, n, e)
    },
    updateView: function(a) {
        $.ajax({
            type: "GET",
            url: a,
            beforeSend: function() {
                $(".collection-matrix").addClass("fadeOut animated loading-in-progress filter-loading"), Waypoint.destroyAll()
            },
            success: function(e) {
                $(".collection-matrix").removeClass("loading-in-progress"), $(".collection-matrix").removeClass("filter-loading");
                var t = $(e).find(".breadcrumb_text").html();
                $(".breadcrumb_text").html(t);
                var i = $(e).find(".paginate").html();
                $(".paginate").html(i);
                var n = $(e).find(".sidebar").html();
                $(".sidebar").html(n);
                var o = $(e).find(".paginate").html();
                $(".paginate").empty(), $(".paginate").html(o);
                var r = $(e).find(".collection-matrix");
                $(".collection-matrix").remove(), r.insertBefore($(".load-more__icon")), window.history && window.history.pushState && window.history.pushState("", "", a), $(".sidebar__collection-filter").length && collectionSidebarFilter.init(), enableInfiniteScroll()
            },
            error: function(e, t, i) {
                console.log(e), console.log(t), console.log(i), location.replace(location.protocol + "//" + location.host + a)
            },
            dataType: "html"
        })
    },
    processUrl: function(e, t, i) {
        var n;
        n = e + t + (i = i.replace(/\page=(\w+)&/, "")), quickFilter.updateView(n)
    }
};
$("#sort-by").val($("#sort-by").data("default-sort")), $("body").on("change", "#tag_filter, #sort-by", function() {
    quickFilter.init()
}), $("body").on("change", "#blog_filter", function() {
    var e = $(this).val();
    window.location = e
}), $("input, select, textarea").on("focus blur", function(e) {
    $("meta[name=viewport]").attr("content", "width=device-width,initial-scale=1,maximum-scale=" + ("blur" == e.type ? 10 : 1))
});
var searchAutocomplete = {
        init: function() {
            var s = null,
                l = $("body").data("shop-url") + "/search?q=";
            $(".search_form, .search__form, .header_search_form").on("submit", function(e) {
                var t = $(this).find('input[name="q"]').val(),
                    i = encodeURI(t);
                e.preventDefault(), window.location.href = null == i ? "/search" : l + i + "*"
            }), $("form.search_form, form.search, form.header_search_form").each(function() {
                var r = $(this).find('input[name="q"]');
                $('<div class="search__results-wrapper"><ul class="search__results"></ul></div>').appendTo($(this)), r.attr("autocomplete", "off").bind("keyup change", function() {
                    "" == r.val() && ($(".search__results").hide(), $(".search__results").empty());
                    var e = $(this).val(),
                        t = encodeURI(e),
                        n = $(this).closest("form"),
                        o = l + t,
                        a = n.find(".search__results");
                    3 <= e.length && (null != s && s.abort(), s = $.getJSON(o + "*&view=json", function(e) {
                        a.empty(), 0 == e.results_count ? a.hide() : ($.each(e.results, function(e, t) {
                            if (5 <= e) return !1;
                            var n = $("<a></a>").attr("href", t.url);
                            if ("product" == t.object_type) {
                                var o = [];
                                for (i = 0; i < t.collections.length; i++) o.push(t.collections[i].handle);
                                if (-1 != $.inArray("coming-soon", o)) var r = "Coming Soon";
                                else r = 1 == t.available ? t.raw_compare > t.raw_price ? '<span class="was_price">' + t.compare + "</span> " + t.price : t.price_varies && 0 < t.price_min ? "from " + t.price : 0 < t.price || 0 < t.raw_price ? t.price : "Free" : "Sold Out";
                                "NULL" != t.thumbnail && n.append('<div class="thumbnail"><img class="lazyload blur-up" src="' + t.thumbnail + '" /></div>'), n.append('<div class="title">' + t.title + '<br><span class="item-pricing">' + r + "</span></div>")
                            } else "article" == t.object_type ? ("NULL" != t.thumbnail && n.append('<div class="thumbnail"><img class="lazyload blur-up" src="' + t.thumbnail + '" /></div>'), n.append('<div class="title">' + t.title + '<br><span class="item-pricing">' + t.text_content + "</span></div>")) : "page" == t.object_type && n.append('<div class="title">' + t.title + '<br><span class="item-pricing">' + t.text_content + "</span></div>");
                            n.wrap('<li class="item-result result--' + t.object_type + '"></li>'), a.append(n.parent())
                        }), 5 <= e.results_count && a.append('<li class="all-results"><span class="title see-all"><a href="' + o + '*">View all results (' + e.results_count + ")</a></span></li>"), a.fadeIn(200))
                    }))
                })
            }), $(document).on("click", function(e) {
                var t = $("[data-autocomplete-true]");
                t.is(e.target) || 0 !== t.has(e.target).length || $("[data-autocomplete-true]").find(".search__results-wrapper").hide()
            }), $("[data-autocomplete-true] input").on("focus", function() {
                $(".search__results-wrapper").hide(), $(this).parents("[data-autocomplete-true]").find(".search__results-wrapper").show()
            })
        },
        unload: function() {
            $("body").off("focus", "[data-autocomplete-true] input")
        }
    },
    collectionSidebarFilter = {
        init: function() {
            $(".filter-active-tag input:checked").parents(".filter-active-tag").siblings(".filter-all-tags").hide(), $(".toggle-all--true .toggle_list .filter-active-tag input:checked").parents("ul.toggle_list").prev().click(), "types" !== $.url(2) && "vendors" !== $.url(2) || $(".sidebar__collection-filter").remove(), $(".sidebar-block:empty").prev().css("border-bottom", "none")
        },
        clearAllFilters: function() {
            $("[data-option-filter] input").attr("checked", !1), $("[data-option-filter] input").trigger("change")
        },
        clearSelectedFilter: function(e) {
            e.find("[data-option-filter] input").attr("checked", !1), e.find("[data-option-filter] input").trigger("change")
        }
    };
$("body").on("change", "[data-option-filter] input", function() {
    quickFilter.init(), $("html, body").animate({
        scrollTop: $("#pagecontent").offset().top
    }, 500)
}), $("body").on("click", "[data-reset-filters]", function() {
    collectionSidebarFilter.clearAllFilters()
}), $("body").on("click", "[data-clear-filter]", function() {
    var e = $(this).parents(".filter-active-tag");
    collectionSidebarFilter.clearSelectedFilter(e)
});
var faqAccordion = {
        init: function() {
            var t = 0,
                i = $(".faqAccordion > dt > button");
            $(".faqAccordion > dd").attr("aria-hidden", !0), i.attr("aria-expanded", !1), i.on("click activate", function() {
                if (t) return !1;
                t = 1;
                var e = "false" === $(this).attr("aria-expanded");
                return $(this).attr("aria-expanded", e), $(this).parent().next().slideToggle(function() {
                    t = 0
                }), $(this).parent().next().attr("aria-hidden", !e), !1
            }), i.on("keydown", function(t) {
                13 === (t.keyCode || e.which) && $(this).trigger("activate")
            })
        }
    },
    arrowSize = {
        x0: 10,
        x1: 60,
        y1: 50,
        x2: 62,
        y2: 40,
        x3: 22
    },
    lightboxGallery = {
        init: function() {
            if ($(".lightbox img").length) {
                var e = $("a.lightbox"),
                    t = [];
                e.each(function(e) {
                    t.push($(this).attr("rel")), t = t.filter(function(e, t, i) {
                        return i.indexOf(e) === t
                    })
                }), $.each(t, function(e, t) {
                    $(".lightbox[rel=" + t + "]").attr("data-remodal-target", "lightbox-id-" + e);
                    var i = ['<div class="remodal remodal-lightbox js-remodal-lightbox js-lightbox-' + e + '" data-rel="' + t + '" data-remodal-id="lightbox-id-' + e + '" data-remodal-options="hashTracking: false">', '<a data-remodal-action="close" class="remodal-close"></a>', '<div class="lightbox-gallery"></div>', "</div>"].join("");
                    $("body").append(i), $(".lightbox[rel=" + t + "]").each(function(e) {
                        $(this).attr("data-image-id", e), $(this).attr("data-no-instant", "")
                    })
                })
            }
        }
    },
    utils = {
        createAccordion: function(e, t, i) {
            var n = $(e),
                o = $(e).find(t),
                r = $(e).find(i),
                a = e + " " + t;
            if (0 <= e.indexOf(".accordion-tabs")) {
                var s = $.map(o, function(e, t) {
                    return [e, r[t]]
                });
                n.empty(), $.each(s, function(e, t) {
                    n.append(this)
                }), r.removeClass("active"), n.find(".active").next().slideToggle(), t = e + "> a"
            }
            $(e).children("a").each(function(e, t) {
                var i = (t = $(this)).attr("href");
                t.attr("data-tab-value", i), t.removeAttr("href")
            }), $(e).find(t + ".active").next().slideToggle(), $("body").on("click", a, function(e) {
                e.preventDefault(), $(this).toggleClass("active"), $(this).next().slideToggle()
            })
        },
        mobileAccordion: function(e, t, i) {
            $container = $(e), $tab = $(e).find(t), $content = $(e).find(i), $(t + ".active").next().slideToggle(), $("body").on("click", t, function(e) {
                e.preventDefault(), $(this).toggleClass("active"), $(this).next().slideToggle()
            })
        },
        mobileParentActiveAccordion: function(e, t, i) {
            $container = $(e), $tab = $(e).find(t), $content = $(e).find(i), $(t + ".active").parent().next().slideToggle(), $("body").on("click", t, function(e) {
                e.preventDefault(), $(this).toggleClass("active"), $(this).parent().next().slideToggle()
            })
        },
        initializeTabs: function() {
            $("ul.tabs > li > a").attr("data-no-instant", !0), $("body").on("click", "ul.tabs > li > a", function(e) {
                e.preventDefault();
                var t = $(this).attr("href");
                "#" == t.charAt(0) && ($("ul.tabs > li > a.active").removeClass("active"), $(this).addClass("active"), $(this).parents("ul.tabs").next().find(t).show().css({
                    display: "block"
                }).addClass("active").siblings().hide().removeClass("active"))
            })
        },
        pageBannerCheck: function() {
            0 < !$(".page_banner").length || $(".header").hasClass("header-background--solid") ? ($(".feature_image").removeClass("feature_image"), $(".header.is-absolute").removeClass("is-absolute"), $(".secondary_logo--true").find(".secondary_logo").css("display", "none"), $(".secondary_logo--true").find(".primary_logo").css("display", "block")) : ($(".header").parent().addClass("feature_image"), $(".header").addClass("is-absolute"), $("header.feature_image").hasClass("secondary_logo--true") && ($(".secondary_logo--true").find(".secondary_logo").css("display", "block"), $(".secondary_logo--true").find(".primary_logo").css("display", "none"))), $(".index-sections").children().first(".under-menu").find(".full-width--true").length ? ($(".header").hasClass("header-background--solid") || ($(".index .header").parent().addClass("feature_image"), $(".index .header").addClass("is-absolute")), $("header.feature_image").hasClass("secondary_logo--true") && ($(".secondary_logo--true").find(".secondary_logo").show(), $(".secondary_logo--true").find(".primary_logo").hide())) : ($(".index .feature_image").removeClass("feature_image"), $(".index .header.is-absolute").removeClass("is-absolute"), $("header.feature_image").hasClass("secondary_logo--true") || ($(".secondary_logo--true").find(".secondary_logo").hide(), $(".secondary_logo--true").find(".primary_logo").show())), $(".detail-sections").children().first().hasClass("under-menu") ? ($(".header").hasClass("header-background--solid") || ($('[class^="page-details"] .header').parent().addClass("feature_image"), $('[class^="page-details"] .header').addClass("is-absolute")), $("header.feature_image").hasClass("secondary_logo--true") && ($(".secondary_logo--true").find(".secondary_logo").show(), $(".secondary_logo--true").find(".primary_logo").hide())) : ($('[class^="page-details"] .feature_image').removeClass("feature_image"), $('[class^="page-details"] .header.is-absolute').removeClass("is-absolute"), $("header.feature_image").hasClass("secondary_logo--true") || ($(".secondary_logo--true").find(".secondary_logo").hide(), $(".secondary_logo--true").find(".primary_logo").show()))
        },
        resizeActionButtons: function() {
            $(".js-caption:visible").each(function() {
                var e = 0;
                $(this).find(".action_button").each(function() {
                    $button = $(this), $(this).width() > e && (e = $(this).width())
                }), $(this).find(".action_button").width(e)
            })
        }
    },
    sliderBlock = {
        select: function(e, t) {
            var i = t.find(".gallery-cell").map(function() {
                    return String($(this).data("block-id"))
                }),
                n = t.find(".js-homepage-slideshow, .js-testimonial"),
                o = (n.data("slideshow-text-animation"), n.data("flickity"));
            n.flickity("pausePlayer");
            for (var r = 0; r < i.length; r++)
                if (i[r] === e) {
                    var a = r;
                    a !== o.selectedIndex && n.flickity("select", parseInt(a), !1, !0)
                }
        },
        deselect: function(e) {
            var t = e.find(".flexslider").data("flexslider");
            t && t.flickity("unpausePlayer")
        }
    };

function htmlEncode(e) {
    return e ? $("<div/>").text(e).html() : ""
}

function is_touch_device() {
    return "ontouchstart" in window || navigator.maxTouchPoints
}

function floatToString(e, t) {
    var i = e.toFixed(t).toString();
    return i.match(/^\.\d+/) ? "0" + i : i
}
if ($(function() {
        var oldFlickityCreate = window.Flickity.prototype._create,
            resizeTimeout;
        window.Flickity.prototype._create = function() {
            var e = this;
            return this.element.addEventListener && this.element.addEventListener("load", function() {
                e.onresize()
            }, !0), (this._create = oldFlickityCreate).apply(this, arguments)
        }, objectFitImages(), header.loadMegaMenu(), header.init(), utils.pageBannerCheck(), slideshow.init(), testimonial.init(), gallery.init(), videoSection.init(), featuredPromotions.init(), featuredCollectionSection.init(), collectionSidebarFilter.init(), cart.init(), mapFunction.init(), productPage.initializeQuantityBox(), productPage.init(), productPage.relatedProducts(), recentlyViewed.init(), window.addEventListener("resize", function(e) {
            resizeTimeout = resizeTimeout || setTimeout(function() {
                resizeTimeout = null, $(window).width() <= 798 && (cart.init(), header.unload(), header.init())
            }, 66)
        }, !1);
        var currentValue = $(".search_form input[name='q']").val();
        0 < $(".search_form input[name='q']").length && $(".search_form input[name='q']").val(currentValue.replace("*", "")), $("body").on("click", ".lightbox", function() {
            currentSlide = $(this).data("image-id")
        });
        var touchStartPos = 0;
        if ($(document).bind("touchstart", function(e) {
                touchStartPos = $(window).scrollTop()
            }).bind("touchend", function(e) {
                var t = touchStartPos - $(window).scrollTop();
                (20 < t || t < -20) && e.preventDefault
            }), $("body").on("opened", ".js-remodal-lightbox", function() {
                var i, n = $(this),
                    e = $(this).data("rel"),
                    o = $(".lightbox[rel=" + e + "]"),
                    r = n.find(".lightbox-gallery"),
                    t = n.find(".lightbox-image"),
                    a = $("body").find(".product_gallery").data("zoom"),
                    s = 1 !== t.length,
                    l = t.length,
                    c = n.find(".lightbox-gallery").hasClass("flickity-enabled");
                n.attr("data-zoom", a), l = !a && 1 !== t.length, c || r.flickity({
                    wrapAround: "true",
                    cellAlign: "center",
                    contain: !0,
                    imagesLoaded: !0,
                    lazyLoad: 2,
                    pageDots: !1,
                    draggable: l,
                    prevNextButtons: s,
                    arrowShape: arrowSize,
                    adaptiveHeight: !0
                }), o.each(function(e) {
                    var t = $(this).attr("href");
                    i = $('<div class="gallery-cell"><img src="' + t + '" class="lightbox-image"></div>'), o.length > r.find(".gallery-cell").length && r.flickity("append", i), r.flickity("select", currentSlide, !1, !0).focus(), n.find(".lightbox-image").css("opacity", "1")
                }), a && imageFunctions.zoom(".js-remodal-lightbox", !0, 1)
            }), $("body").on("click", ".lightbox", function() {
                currentSlide = $(this).data("image-id")
            }), $("body").on("click", ".sidebar .parent-link--false", function(e) {
                e.preventDefault(), $menu = $(this).parent("li"), $menu.find(".menu-toggle").toggleClass("active"), $menu.find("ul").slideToggle()
            }), $("body").on("closed", ".js-remodal-lightbox", function() {
                $(this).find("img").css("opacity", "0")
            }), -1 != window.location.pathname.indexOf("/comments") && $("html,body").animate({
                scrollTop: $("#new-comment").offset().top - 140
            }, "slow"), $("body").on("mouseenter", ".icon-search", function() {
                $(".search-terms").focus()
            }), $("body").on("click", ".icon-search", function() {
                $("input.search-terms").focus()
            }), $("body").on("click", ".search-submit", function() {
                $(this).parent().submit()
            }), 798 < $(window).width() && ($(".animate_right").waypoint(function() {
                $(this.element).addClass("animated fadeInRight")
            }, {
                offset: "70%"
            }), $(".animate_left").waypoint(function() {
                $(this.element).addClass("animated fadeInLeft")
            }, {
                offset: "70%"
            }), $(".animate_up").waypoint(function() {
                $(this.element).addClass("animated fadeInUp")
            }, {
                offset: "70%"
            }), $(".animate_down").waypoint(function() {
                $(this.element).addClass("animated fadeInDown")
            }, {
                offset: "70%"
            })), $(".slider, .flexslider").find("li").unwrap(), $(".slider, .flexslider").flickity({
                pageDots: usePageDots,
                imagesLoaded: !0,
                arrowShape: arrowSize,
                lazyLoad: 2
            }), utils.createAccordion(".toggle-all--true", "h4.toggle", "ul.toggle_list"), utils.createAccordion(".footer_menu", "h6", "ul"), utils.createAccordion(".footer_content", "h6", "div.toggle_content"), utils.createAccordion(".product_section .accordion-tabs", ".tabs li > a", ".tabs-content li"), utils.mobileParentActiveAccordion("#mobile_menu", "li.sublink > a.parent-link--true span", "li.sublink ul"), utils.mobileAccordion("#mobile_menu", "li.sublink > a.parent-link--false", "li.sublink ul"), utils.initializeTabs(), utils.resizeActionButtons(), faqAccordion.init(), $(window).on("resize", function() {
                utils.resizeActionButtons()
            }), $(window).width() <= 798 && utils.createAccordion(".toggle-all--false", "h4.toggle", "ul.toggle_list"), $("body").on("click", ".menu-toggle", function(e) {
                $(this).next("ul").slideToggle(), $(this).toggleClass("active"), $(this).attr("aria-expanded", "true" == $(this).attr("aria-expanded") ? "false" : "true")
            }), $(":not(.product-page .video-section)").find("iframe[src*=youtube], iframe[src*=vimeo]").mediaWrapper({
                intrinsic: !0
            }), 959 <= $(window).width()) {
            var modal_width = "870px";
            (1200 <= $(window).width() || $("html").hasClass("ie")) && (modal_width = "1110px")
        }
        var $contact_form = $(".newsletter .contact-form"),
            globalQuickShopProduct;
        $contact_form.each(function() {
            var t = $(this);
            t.on("submit", function(e) {
                "true" !== $('input[name="challenge"]', t).val() && ($.ajax({
                    type: t.attr("method"),
                    url: t.attr("action"),
                    data: t.serialize(),
                    success: function(e) {
                        t.fadeOut("slow", function() {
                            t.prev(".message").html("Thank you for joining our mailing list!")
                        })
                    },
                    error: function(e) {
                        $('input[name="challenge"]', t).val("true"), t.submit()
                    }
                }), e.preventDefault())
            })
        }), $(".maps").click(function() {
            $(".maps iframe").css("pointer-events", "auto")
        }), enableInfiniteScroll(), enableInfiniteSearchScroll(), $("body").on("change", ".currencies", function(e) {
            $("[data-initial-modal-price]").attr("data-initial-modal-price", "")
        }), $("body").on("change", ".js-quick-shop select", function(e) {
            var t = $('.js-quick-shop select[name="id"]').val();
            t && globalQuickShopProduct && quickShop.updateVariant(t)
        });
        var quickShop = {
            init: function() {
                var s, r, a;
                $("body").on("click", ".js-quick-shop-link", function(e) {
                    e.preventDefault();
                    for (var t = $(this).data("images").trim("||").split("||"), i = [], n = [], o = 0; o < t.length; o += 2) i.push(t[o]), t[o + 1] && n.push(t[o + 1]);
                    s = {
                        handle: $(this).data("handle"),
                        product_id: $(this).data("id"),
                        single_variant: $(this).attr("data-single-variant"),
                        product_in_collection_url: $(this).data("url"),
                        escaped_title: $(this).data("title"),
                        details_text: $(this).data("details-text"),
                        full_description: $(this).data("full-description"),
                        regular_description: $(this).data("regular-description"),
                        image_ids: i.filter(function(e) {
                            return "" !== e
                        }),
                        image_alts: n,
                        collection_handles: $(this).data("collection-handles").trim(",").split(","),
                        money_format: $(this).data("money-format")
                    }, $(".js-gallery-modal").hasClass("flickity-enabled") || $(".js-gallery-modal").flickity({
                        wrapAround: "true",
                        cellAlign: "left",
                        contain: !0,
                        imagesLoaded: !0,
                        lazyLoad: 2,
                        pageDots: !1,
                        prevNextButtons: usePageDots,
                        autoPlay: autoplay,
                        selectedAttraction: .01,
                        friction: .15,
                        arrowShape: arrowSize
                    }), a = $(this).next(".js-forms").find(".notify_form"), r = $(this).next(".js-forms").find(".product_form"), $(".quick-shop .container").attr("class", "container section product-" + s.product_id), $(".quick-shop .container").attr("id", "product-" + s.product_id), $(".quick-shop .container").attr("data-id", s.product_id), quickShop.retrieveProductInfo(s)
                }), $("body").on("opened", ".js-quick-shop", function() {
                    $(".remodal.quick-shop .js-product-form").html(r), $(".remodal.quick-shop .js-notify-form").html(a), $(r).hasClass("product_form_options") && !$(r).hasClass("viewed") && new Shopify.OptionSelectors($(r).data("select-id"), {
                        product: $(r).data("product"),
                        onVariantSelected: selectCallback,
                        enableHistoryState: $(r).data("enable-state")
                    });
                    var e = $(r).data("product");
                    1 < $(r).find(".swatch_options .swatch").length && Shopify.linkOptionSelectors(e, ".js-quick-shop"), utils.initializeTabs(), $('.js-quick-shop select[name="id"]').trigger("change")
                }), $("body").on("closed", ".js-quick-shop", function(e) {
                    var t = $(".js-quick-shop .product_form"),
                        i = $(".js-quick-shop .notify_form");
                    $(".form-holder-" + s.product_id).append(t), $(".form-holder-" + s.product_id).append(i), $(".form-holder-" + s.product_id + " .product_form").addClass("viewed"), $(".form-holder-" + s.product_id + " .notify_form").addClass("viewed");
                    var n = $(".js-current-price .money").text();
                    if ($(".js-quick-shop-link[data-id=" + s.product_id + "]").attr("data-initial-modal-price", n), $(".js-current-price, .js-was-price, .js-savings").empty(), $(".js-product_section").length) {
                        var o = $(".js-product_section").find(".product_form"),
                            r = o.data("product"),
                            a = ".product-" + o.data("product-id") + " .js-product_section";
                        1 < o.find(".swatch_options .swatch").length && Shopify.linkOptionSelectors(r, a)
                    }
                })
            },
            retrieveProductInfo: function(t) {
                $.ajax({
                    dataType: "json",
                    async: !1,
                    cache: !1,
                    url: "/products/" + t.handle + ".js",
                    success: function(e) {
                        e = $.extend({}, e, t), quickShop.populateGallery(e), globalQuickShopProduct = e, quickShop.updateVariant(e.variants[0].id.toString())
                    }
                })
            },
            updateVariant: function(e) {
                if ($(".js-sale-banner, .js-sold-out, .js-current-price, .js-was-price, .js-savings, .js-new-banner, .js-pre-order-banner").empty(), "undefined" != globalQuickShopProduct) {
                    var i = globalQuickShopProduct;
                    $(".modal_price, .js-notify-form").show(), $(".js-product-title").html('<a href="' + i.product_in_collection_url + '" title="' + i.escaped_title + '">' + i.title + "</a>"), $(".js-product-vendor").html('<a href="/collections/vendors?q=' + i.vendor + '">' + i.vendor + "</a>"), $(".js-full-description").html(i.full_description), $(".js-regular-description").html(i.regular_description);
                    var t = '<a href="' + i.product_in_collection_url + '" class="secondary_button" title="' + i.escaped_title + ' Details">' + i.details_text + "</a>";
                    if ($(".js-product-details").html(t), $.each(i.collection_handles, function(e, t) {
                            "new" == this.toString() && $(".js-new-banner").html("New"), "pre-order" == this.toString() && $(".js-pre-order-banner").html("Pre-Order"), "coming-soon" == this.toString() && (i.price = "Coming Soon")
                        }), "true" == i.single_variant) i.compare_at_price > i.price && $(".js-sale-banner").html("Sale"), i.compare_at_price > i.price ? $(".js-current-price").addClass("sale") : $(".js-current-price").removeClass("sale"), 0 == i.available && $(".js-sold-out").html("Sold Out"), 1 == i.available && (i.compare_at_price > i.price && ($(".js-was-price").html('<span class="money">' + Shopify.formatMoney(i.variants[0].compare_at_price, i.money_format) + "</span>"), $(".js-savings").html("Save " + parseInt(100 * (i.variants[0].compare_at_price - i.variants[0].price) / i.variants[0].compare_at_price) + '% (<span class="money">' + Shopify.formatMoney(i.variants[0].compare_at_price - i.variants[0].price, i.money_format) + "</span>)")), "Coming Soon" == i.price ? $(".js-current-price").html("Coming Soon") : i.price ? $(".js-current-price").html('<span class="money">' + Shopify.formatMoney(i.variants[0].price, i.money_format) + "</span>") : $(".js-current-price").html("Free"));
                    else
                        for (var n = 0; n < i.variants.length; n++) e == i.variants[n].id.toString() && (i.variants[n].compare_at_price > i.variants[n].price && $(".js-sale-banner").html("Sale"), i.variants[n].compare_at_price > i.variants[n].price ? $(".js-current-price").addClass("sale") : $(".js-current-price").removeClass("sale"), 0 == i.variants[n].available && $(".js-sold-out").html("Sold Out"), 1 == i.variants[n].available && (i.variants[n].compare_at_price > i.variants[n].price && ($(".js-was-price").html('<span class="money">' + Shopify.formatMoney(i.variants[n].compare_at_price, i.money_format) + "</span>"), $(".js-savings").html("Save " + parseInt(100 * (i.variants[n].compare_at_price - i.variants[n].price) / i.variants[n].compare_at_price) + '% (<span class="money">' + Shopify.formatMoney(i.variants[n].compare_at_price - i.variants[n].price, i.money_format) + "</span>)")), "Coming Soon" == i.variants[n].price ? $(".js-current-price").html("Coming Soon") : i.variants[n].price ? $(".js-current-price").html('<span class="money">' + Shopify.formatMoney(i.variants[n].price, i.money_format) + "</span>") : $(".js-current-price").html("Free")))
                }
                $(".js-quick-shop .text-modal-wrap iframe[src*=youtube], .js-quick-shop .text-modal-wrap iframe[src*=vimeo]").mediaWrapper({
                    intrinsic: !0
                })
            },
            populateGallery: function(l) {
                var c = $(".js-gallery-modal"),
                    o = $(".js-gallery-carousel");

                function e(e) {
                    $.each(l.images, function(e, t) {
                        var i, n = t.replace(/(\.[^.]*)$/, "_grande$1").replace("http:", ""),
                            o = t.replace(/(\.[^.]*)$/, "_1024x1024$1").replace("http:", ""),
                            r = t.replace(/(\.[^.]*)$/, "_2048x2048$1").replace("http:", ""),
                            a = l.image_alts[e];
                        i = 0 <= a.indexOf("youtube") ? '<div class="video-container youtube"><div>' + a + "</div></div>" : 0 <= a.indexOf("vimeo") ? '<div class="video-container vimeo"><div>' + a + "</div></div>" : '<img src="' + n + '" data-src="' + o + '" alt="' + a + '" data-image-id="' + l.image_ids[e].trim() + '" data-index="' + e + '" srcset="' + n + " 600w, " + o + " 1024w, " + r + ' 2048w" sizes="(min-width: 800px) 50vw, 100vw"/>';
                        var s = $('<div class="gallery-cell">' + i + "</div>");
                        c.flickity("append", s)
                    }), c.removeClass("single-image multi-image").addClass(e ? "multi-image" : "single-image")
                }
                $(document).on("closed", ".js-quick-shop", function(e) {
                    c.flickity("remove", $(".js-gallery-modal .gallery-cell")), o.empty()
                }), 1 < l.images.length ? (e(!0), $.each(l.images, function(e, t) {
                    var i = '<img src="' + t.replace(/(\.[^.]*)$/, "_grande$1").replace("http:", "") + '" alt="' + escape(l.image_alts[e]) + '" />',
                        n = $('<div class="gallery-cell">' + i + "</div>");
                    o.append(n)
                }), imageFunctions.linkGalleryAndCarousel(c, o)) : e(!1), imageFunctions.zoom(".js-gallery-modal", !1)
            }
        };

        function ajaxSubmitCart(e) {
            $cart = e, $.ajax({
                url: "/cart/update.js",
                dataType: "json",
                cache: !1,
                type: "post",
                data: $cart.serialize(),
                success: function(e) {
                    refreshCart(e)
                }
            })
        }

        function ajaxUpdateCart(o, r, a) {
            $.ajax({
                url: "/cart/change.js",
                dataType: "json",
                cache: !1,
                type: "post",
                data: {
                    quantity: r,
                    line: o
                },
                success: function(e) {
                    
                    if(e.items_subtotal_price < window.freeProduct.minAmount){
                        var freeItem = false;
                        $.each(e.items, function(k, v) {
                            if(v.id == window.freeProduct.varId){
                                freeItem = true;
                            }
                        });
                        if(freeItem){
                            $.ajax({
                                url: "/cart/change.js",
                                dataType: "json",
                                cache: !1,
                                type: "post",
                                data: {
                                    id: window.freeProduct.varId,
                                    quantity: 0
                                },
                                success: function(e) {
                                    $.ajax({
                                        url: "/cart.js",
                                        dataType: "json",
                                        cache: !1,
                                        success: function(e) {
                                            refreshCart(e);
                                        }
                                    });
                                }
                            });
                        } else{
                            refreshCart(e);                  
                        }
                    } 
                    else if(e.items_subtotal_price >= window.freeProduct.minAmount){
                        var freeItem = false;
                        var freeItemCount = 0;
                        $.each(e.items, function(k, v) {
                            if(v.id == window.freeProduct.varId){
                                freeItem = true;
                                if(v.quantity > 1){
                                    freeItemCount = 1;
                                }
                            }
                        });
                        if(freeItem){
                            if(freeItemCount){
                                $.ajax({
                                    url: "/cart/change.js",
                                    dataType: "json",
                                    cache: !1,
                                    type: "post",
                                    data: {
                                        id: window.freeProduct.varId,
                                        quantity: 1
                                    },
                                    success: function(e) {
                                        $.ajax({
                                            url: "/cart.js",
                                            dataType: "json",
                                            cache: !1,
                                            success: function(e) {
                                                refreshCart(e);
                                            }
                                        });
                                    }
                                });
                            } else {
                                refreshCart(e);
                            }                                        
                        } else{
                            $.ajax({
                                url: "/cart/add.js",
                                dataType: "json",
                                cache: !1,
                                type: "post",
                                data: {
                                    id: window.freeProduct.varId,
                                    quantity: 1
                                },
                                success: function(e) {
                                    $.ajax({
                                        url: "/cart.js",
                                        dataType: "json",
                                        cache: !1,
                                        success: function(e) {
                                            refreshCart(e);
                                        }
                                    });
                                }
                            });
                        }
                    }
                    
                }
            })
        }

        function refreshCart(e) {
            $(".cart_count").empty(), $cartBtn = $(".cart_count");
            var t = $cartBtn.text() || "0",
                n = "",
                i = "",
                o = "";
          	
            $(".cart_content form"), $cartBtn.text(t.replace(/[0-9]+/, e.item_count))
            , $.ajax({
                url: "/pages/cart-drawer",
                type: "get",
                success: function(e) {
                  $(".cart-drawer-content").html(e);
                  $("html").hasClass("remodal-is-locked") && $(".remodal-close").click(), $("#header").is(":visible") ? $("#header .cart_container").addClass("active_link") : $(".sticky_nav--stick").length ? $(".sticky_nav .cart_container").addClass("active_link") : $(".top_bar .cart_container").addClass("active_link"), $(window).width() <= 798 && ($(this).parent().hasClass("active_link"), $("body").addClass("blocked-scroll"));
                  var elementCartDrawerRF = document.getElementById('cart_content_height');
				  resizeElementHeight(elementCartDrawerRF);
                  setTimeout(function(){resizeElementHeight(elementCartDrawerRF);}, 500);
                }
            })
        }
        if ($("body").on("change", "#cart_form input.quantity", function() {
                ajaxUpdateCart($(this).data("line-id"), $(this).val(), $(this).parents("#cart_form"))
            }), $("body").on("change", ".cart_content input.quantity", function() {
                ajaxUpdateCart($(this).data("line-id"), $(this).val(), $(this).parents(".cart_content"))
            }), $("body").on("click", ".upsell-item .upsell_add_to_cart", function(e) {
                e.preventDefault();
                var $addToCartForm = $(this).closest("form"),
                    id = $(this).data("id"),
                    $addToCartBtn = $addToCartForm.find(".add_to_cart");
                return $.ajax({
                    url: "/cart/add.js",
                    dataType: "json",
                    cache: !1,
                    type: "post",
                    data: {
                        id: id
                    },
                    beforeSend: function() {
                        $addToCartBtn.attr("disabled", "disabled").addClass("disabled"), $addToCartBtn.find("span").removeClass("fadeInDown").addClass("animated zoomOut")
                    },
                    success: function(e) {
                        $addToCartBtn.find(".checkmark").addClass("checkmark-active"), window.setTimeout(function() {
                        $addToCartBtn.removeAttr("disabled").removeClass("disabled"), $addToCartBtn.find(".checkmark").removeClass("checkmark-active"), $addToCartBtn.find("span").removeClass("zoomOut").addClass("fadeInDown")
                        }, 1e3), $.ajax({
                            url: "/cart.js",
                            dataType: "json",
                            cache: !1,
                            success: function(e) {
                                
                                if(e.items_subtotal_price >= window.freeProduct.minAmount){
                                    var freeItem = false;
                                    var freeItemCount = 0;
                                    $.each(e.items, function(k, v) {
                                        if(v.id == window.freeProduct.varId){
                                            freeItem = true;
                                            if(v.quantity > 1){
                                                freeItemCount = 1;
                                            }
                                        }
                                    });
                                    if(freeItem){
                                        if(freeItemCount){
                                            $.ajax({
                                                url: "/cart/change.js",
                                                dataType: "json",
                                                cache: !1,
                                                type: "post",
                                                data: {
                                                    id: window.freeProduct.varId,
                                                    quantity: 1
                                                },
                                                success: function(e) {
                                                    $.ajax({
                                                        url: "/cart.js",
                                                        dataType: "json",
                                                        cache: !1,
                                                        success: function(e) {
                                                            refreshCart(e);
                                                        }
                                                    });
                                                }
                                            });
                                        } else {
                                            refreshCart(e);
                                        }                                        
                                    } else{
                                        $.ajax({
                                            url: "/cart/add.js",
                                            dataType: "json",
                                            cache: !1,
                                            type: "post",
                                            data: {
                                                id: window.freeProduct.varId,
                                                quantity: 1
                                            },
                                            success: function(e) {
                                                $.ajax({
                                                    url: "/cart.js",
                                                    dataType: "json",
                                                    cache: !1,
                                                    success: function(e) {
                                                        refreshCart(e);
                                                    }
                                                });
                                            }
                                        });
                                    }                                  
                                }
                                else {
                                    refreshCart(e);
                                }
                                
                            }
                        })
                    },
                    error: function(XMLHttpRequest) {
                        var response = eval("(" + XMLHttpRequest.responseText + ")");
                        response = response.description, $(".warning").remove();
                        var warning = '<p class="warning animated bounceIn">' + response.replace("All 1 ", "All ") + "</p>";
                        $addToCartForm.after(warning), $addToCartBtn.removeAttr("disabled").removeClass("disabled"), $addToCartBtn.find("span").text("Add to Cart").removeClass("zoomOut").addClass("zoomIn")
                    }
                }), !1
            }), $("body").on("submit", ".product_form form", function(e) {
                e.preventDefault();
                var $addToCartForm = $(this),
                    $addToCartBtn = $addToCartForm.find(".add_to_cart");
                return $.ajax({
                    url: "/cart/add.js?a=",
                    dataType: "json",
                    cache: !1,
                    type: "post",
                    data: $addToCartForm.serialize(),
                    beforeSend: function() {
                        $addToCartBtn.attr("disabled", "disabled").addClass("disabled"), $addToCartBtn.find("span").removeClass("fadeInDown").addClass("animated zoomOut")
                    },
                    success: function(e) {
                        $addToCartBtn.find(".checkmark").addClass("checkmark-active"), window.setTimeout(function() {
                        $addToCartBtn.removeAttr("disabled").removeClass("disabled"), $addToCartBtn.find(".checkmark").removeClass("checkmark-active"), $addToCartBtn.find("span").removeClass("zoomOut").addClass("fadeInDown")
                        }, 1e3), $.ajax({
                            url: "/cart.js",
                            dataType: "json",
                            cache: !1,
                            success: function(e) {
                                
                                if(e.items_subtotal_price >= window.freeProduct.minAmount){
                                    var freeItem = false;
                                    var freeItemCount = 0;
                                    $.each(e.items, function(k, v) {
                                        if(v.id == window.freeProduct.varId){
                                            freeItem = true;
                                            if(v.quantity > 1){
                                                freeItemCount = 1;
                                            }
                                        }
                                    });
                                    if(freeItem){
                                        if(freeItemCount){
                                            $.ajax({
                                                url: "/cart/change.js",
                                                dataType: "json",
                                                cache: !1,
                                                type: "post",
                                                data: {
                                                    id: window.freeProduct.varId,
                                                    quantity: 1
                                                },
                                                success: function(e) {
                                                    $.ajax({
                                                        url: "/cart.js",
                                                        dataType: "json",
                                                        cache: !1,
                                                        success: function(e) {
                                                            refreshCart(e);
                                                        }
                                                    });
                                                }
                                            });
                                        } else {
                                            refreshCart(e);
                                        }                                        
                                    } else{
                                        $.ajax({
                                            url: "/cart/add.js",
                                            dataType: "json",
                                            cache: !1,
                                            type: "post",
                                            data: {
                                                id: window.freeProduct.varId,
                                                quantity: 1
                                            },
                                            success: function(e) {
                                                $.ajax({
                                                    url: "/cart.js",
                                                    dataType: "json",
                                                    cache: !1,
                                                    success: function(e) {
                                                        refreshCart(e);
                                                    }
                                                });
                                            }
                                        });
                                    }                                   
                                }
                                else {
                                    refreshCart(e);
                                }
                                
                            }
                        })
                    },
                    error: function(XMLHttpRequest) {
                        var response = eval("(" + XMLHttpRequest.responseText + ")");
                        response = response.description, $(".warning").remove();
                        var warning = '<p class="warning animated bounceIn">' + response.replace("All 1 ", "All ") + "</p>";
                        $addToCartForm.after(warning), $addToCartBtn.removeAttr("disabled").removeClass("disabled"), $addToCartBtn.find("span").text("Add to Cart").removeClass("zoomOut").addClass("zoomIn")
                    }
                }), !1
            }), $(".js-product_section").length) {
            var $productForms = $(".js-product_section").find(".product_form");
            $productForms.addClass("is-visible"), $productForms.each(function() {
                var e = $(this).data("product"),
                    t = ".product-" + $(this).data("product-id") + " .js-product_section";
                1 < $(this).find(".swatch_options .swatch").length && Shopify.linkOptionSelectors(e, t)
            })
        }
        1 < $(".js-product_section").length && $("body").on("click", ".swatch-element", function() {
            var e = $(this).data("value");
            $(this).siblings('input[value="' + e.replace(/\"/g, '\\"') + '"]').prop("checked", !0).trigger("change");
            var t = $(this).parents(".product_form").data("product"),
                i = ".product-" + $(this).parents(".product_form").data("product-id") + " .js-product_section";
            1 < $(this).parents(".product_form").find(".swatch_options .swatch").length && Shopify.linkOptionSelectors(t, i)
        })
    }), Shopify.updateOptionsInSelector = function(e, t) {
        switch (e) {
            case 0:
                var i = "root";
                $(t + " .single-option-selector:eq(0)");
                break;
            case 1:
                i = $(t + " .single-option-selector:eq(0)").val(), $(t + " .single-option-selector:eq(1)");
                break;
            case 2:
                i = $(t + " .single-option-selector:eq(0)").val(), i += " / " + $(t + " .single-option-selector:eq(1)").val(), $(t + " .single-option-selector:eq(2)")
        }
        var n = Shopify.optionsMap[i];
        $(t + ' .swatch[data-option-index="' + e + '"] .swatch-element').each(function() {
            -1 !== $.inArray($(this).attr("data-value"), n) ? $(this).removeClass("soldout").find(":radio").removeAttr("disabled", "disabled").removeAttr("checked") : $(this).addClass("soldout").find(":radio").removeAttr("checked").attr("disabled", "disabled")
        })
    }, Shopify.linkOptionSelectors = function(e, t) {
        Shopify.optionsMap = {};
        for (var i = 0; i < e.variants.length; i++) {
            var n = e.variants[i];
            if (n.available) {
                if (Shopify.optionsMap.root = Shopify.optionsMap.root || [], Shopify.optionsMap.root.push(n.option1), Shopify.optionsMap.root = Shopify.uniq(Shopify.optionsMap.root), 1 < e.options.length) {
                    var o = n.option1;
                    Shopify.optionsMap[o] = Shopify.optionsMap[o] || [], Shopify.optionsMap[o].push(n.option2), Shopify.optionsMap[o] = Shopify.uniq(Shopify.optionsMap[o])
                }
                3 === e.options.length && (o = n.option1 + " / " + n.option2, Shopify.optionsMap[o] = Shopify.optionsMap[o] || [], Shopify.optionsMap[o].push(n.option3), Shopify.optionsMap[o] = Shopify.uniq(Shopify.optionsMap[o]))
            }
        }
        Shopify.updateOptionsInSelector(0, t), 1 < e.options.length && Shopify.updateOptionsInSelector(1, t), 3 === e.options.length && Shopify.updateOptionsInSelector(2, t), $(t + " .single-option-selector:eq(0)").change(function() {
            return Shopify.updateOptionsInSelector(1, t), 3 === e.options.length && Shopify.updateOptionsInSelector(2, t), !0
        }), $(t + " .single-option-selector:eq(1)").change(function() {
            return 3 === e.options.length && Shopify.updateOptionsInSelector(2, t), !0
        })
    }, void 0 === Shopify) var Shopify = {};

function PointerEventsPolyfill(e) {
    if (this.options = {
            selector: "*",
            mouseEvents: ["click", "dblclick", "mousedown", "mouseup"],
            usePolyfillIf: function() {
                return "Microsoft Internet Explorer" == navigator.appName && null != navigator.userAgent.match(/MSIE ([0-9]{1,}[\.0-9]{0,})/) && parseFloat(RegExp.$1) < 11
            }
        }, e) {
        var i = this;
        $.each(e, function(e, t) {
            i.options[e] = t
        })
    }
    this.options.usePolyfillIf() && this.register_mouse_events()
}
Shopify.each = function(e, t) {
        for (var i = 0; i < e.length; i++) t(e[i], i)
    }, Shopify.map = function(e, t) {
        for (var i = [], n = 0; n < e.length; n++) i.push(t(e[n], n));
        return i
    }, Shopify.arrayIncludes = function(e, t) {
        for (var i = 0; i < e.length; i++)
            if (e[i] == t) return !0;
        return !1
    }, Shopify.uniq = function(e) {
        for (var t = [], i = 0; i < e.length; i++) Shopify.arrayIncludes(t, e[i]) || t.push(e[i]);
        return t
    }, Shopify.isDefined = function(e) {
        return void 0 !== e
    }, Shopify.getClass = function(e) {
        return Object.prototype.toString.call(e).slice(8, -1)
    }, Shopify.extend = function(e, t) {
        function i() {}
        i.prototype = t.prototype, e.prototype = new i, (e.prototype.constructor = e).baseConstructor = t, e.superClass = t.prototype
    }, Shopify.locationSearch = function() {
        return window.location.search
    }, Shopify.locationHash = function() {
        return window.location.hash
    }, Shopify.replaceState = function(e) {
        window.history.replaceState({}, document.title, e)
    }, Shopify.urlParam = function(e) {
        var t = RegExp("[?&]" + e + "=([^&#]*)").exec(Shopify.locationSearch());
        return t && decodeURIComponent(t[1].replace(/\+/g, " "))
    }, Shopify.newState = function(e, t) {
        return (Shopify.urlParam(e) ? Shopify.locationSearch().replace(RegExp("(" + e + "=)[^&#]+"), "$1" + t) : "" === Shopify.locationSearch() ? "?" + e + "=" + t : Shopify.locationSearch() + "&" + e + "=" + t) + Shopify.locationHash()
    }, Shopify.setParam = function(e, t) {
        Shopify.replaceState(Shopify.newState(e, t))
    }, Shopify.Product = function(e) {
        Shopify.isDefined(e) && this.update(e)
    }, Shopify.Product.prototype.update = function(e) {
        for (property in e) this[property] = e[property]
    }, Shopify.Product.prototype.optionNames = function() {
        return "Array" == Shopify.getClass(this.options) ? this.options : []
    }, Shopify.Product.prototype.optionValues = function(i) {
        if (!Shopify.isDefined(this.variants)) return null;
        var e = Shopify.map(this.variants, function(e) {
            var t = "option" + (i + 1);
            return null == e[t] ? null : e[t]
        });
        return null == e[0] ? null : Shopify.uniq(e)
    }, Shopify.Product.prototype.getVariant = function(n) {
        var o = null;
        return n.length != this.options.length || Shopify.each(this.variants, function(e) {
            for (var t = !0, i = 0; i < n.length; i++) e["option" + (i + 1)] != n[i] && (t = !1);
            return 1 == t ? void(o = e) : void 0
        }), o
    }, Shopify.Product.prototype.getVariantById = function(e) {
        for (var t = 0; t < this.variants.length; t++) {
            var i = this.variants[t];
            if (e == i.id) return i
        }
        return null
    }, Shopify.money_format = "$", Shopify.formatMoney = function(e, t) {
        function r(e, t) {
            return void 0 === e ? t : e
        }

        function i(e, t, i, n) {
            if (t = r(t, 2), i = r(i, ","), n = r(n, "."), isNaN(e) || null == e) return 0;
            var o = (e = (e / 100).toFixed(t)).split(".");
            return o[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + i) + (o[1] ? n + o[1] : "")
        }
        "string" == typeof e && (e = e.replace(".", ""));
        var n = "",
            o = /\{\{\s*(\w+)\s*\}\}/,
            a = t || this.money_format;
        switch (a.match(o)[1]) {
            case "amount":
                n = i(e, 2);
                break;
            case "amount_no_decimals":
                n = i(e, 0);
                break;
            case "amount_with_comma_separator":
                n = i(e, 2, ".", ",");
                break;
            case "amount_no_decimals_with_comma_separator":
                n = i(e, 0, ".", ",")
        }
        return a.replace(o, n)
    }, Shopify.OptionSelectors = function(e, t) {
        return this.selectorDivClass = "selector-wrapper", this.selectorClass = "single-option-selector", this.variantIdFieldIdSuffix = "-variant-id", this.variantIdField = null, this.historyState = null, this.selectors = [], this.domIdPrefix = e, this.product = new Shopify.Product(t.product), this.onVariantSelected = Shopify.isDefined(t.onVariantSelected) ? t.onVariantSelected : function() {}, this.replaceSelector(e), this.initDropdown(), t.enableHistoryState && (this.historyState = new Shopify.OptionSelectors.HistoryState(this)), !0
    }, Shopify.OptionSelectors.prototype.initDropdown = function() {
        var e = {
            initialLoad: !0
        };
        if (!this.selectVariantFromDropdown(e)) {
            var t = this;
            setTimeout(function() {
                t.selectVariantFromParams(e) || t.fireOnChangeForFirstDropdown.call(t, e)
            })
        }
    }, Shopify.OptionSelectors.prototype.fireOnChangeForFirstDropdown = function(e) {
        this.selectors[0].element.onchange(e)
    }, Shopify.OptionSelectors.prototype.selectVariantFromParamsOrDropdown = function(e) {
        this.selectVariantFromParams(e) || this.selectVariantFromDropdown(e)
    }, Shopify.OptionSelectors.prototype.replaceSelector = function(e) {
        var t = document.getElementById(e),
            i = t.parentNode;
        Shopify.each(this.buildSelectors(), function(e) {
            i.insertBefore(e, t)
        }), t.style.display = "none", this.variantIdField = t
    }, Shopify.OptionSelectors.prototype.selectVariantFromDropdown = function(e) {
        var t = document.getElementById(this.domIdPrefix).querySelector("[selected]");
        if (!(t = t || document.getElementById(this.domIdPrefix).querySelector('[selected="selected"]'))) return !1;
        var i = t.value;
        return this.selectVariant(i, e)
    }, Shopify.OptionSelectors.prototype.selectVariantFromParams = function(e) {
        var t = Shopify.urlParam("variant");
        return this.selectVariant(t, e)
    }, Shopify.OptionSelectors.prototype.selectVariant = function(e, t) {
        var i = this.product.getVariantById(e);
        if (null == i) return !1;
        for (var n = 0; n < this.selectors.length; n++) {
            var o = this.selectors[n].element,
                r = i[o.getAttribute("data-option")];
            null != r && this.optionExistInSelect(o, r) && (o.value = r)
        }
        return "undefined" != typeof jQuery ? jQuery(this.selectors[0].element).trigger("change", t) : this.selectors[0].element.onchange(t), !0
    }, Shopify.OptionSelectors.prototype.optionExistInSelect = function(e, t) {
        for (var i = 0; i < e.options.length; i++)
            if (e.options[i].value == t) return !0
    }, Shopify.OptionSelectors.prototype.insertSelectors = function(e, t) {
        Shopify.isDefined(t) && this.setMessageElement(t), this.domIdPrefix = "product-" + this.product.id + "-variant-selector";
        var i = document.getElementById(e);
        Shopify.each(this.buildSelectors(), function(e) {
            i.appendChild(e)
        })
    }, Shopify.OptionSelectors.prototype.buildSelectors = function() {
        for (var e = 0; e < this.product.optionNames().length; e++) {
            var t = new Shopify.SingleOptionSelector(this, e, this.product.optionNames()[e], this.product.optionValues(e));
            t.element.disabled = !1, this.selectors.push(t)
        }
        var n = this.selectorDivClass,
            o = this.product.optionNames();
        return Shopify.map(this.selectors, function(e) {
            var t = document.createElement("div");
            if (t.setAttribute("class", n), 1 < o.length) {
                var i = document.createElement("label");
                i.htmlFor = e.element.id, i.innerHTML = e.name, t.appendChild(i)
            }
            return t.appendChild(e.element), t
        })
    }, Shopify.OptionSelectors.prototype.selectedValues = function() {
        for (var e = [], t = 0; t < this.selectors.length; t++) {
            var i = this.selectors[t].element.value;
            e.push(i)
        }
        return e
    }, Shopify.OptionSelectors.prototype.updateSelectors = function(e, t) {
        var i = this.selectedValues(),
            n = this.product.getVariant(i);
        n ? (this.variantIdField.disabled = !1, this.variantIdField.value = n.id) : this.variantIdField.disabled = !0, this.onVariantSelected(n, this, t), null != this.historyState && this.historyState.onVariantChange(n, this, t)
    }, Shopify.OptionSelectorsFromDOM = function(e, t) {
        var i = t.optionNames || [],
            n = t.priceFieldExists || !0,
            o = t.delimiter || "/",
            r = this.createProductFromSelector(e, i, n, o);
        t.product = r, Shopify.OptionSelectorsFromDOM.baseConstructor.call(this, e, t)
    }, Shopify.extend(Shopify.OptionSelectorsFromDOM, Shopify.OptionSelectors), Shopify.OptionSelectorsFromDOM.prototype.createProductFromSelector = function(e, a, s, l) {
        Shopify.isDefined(s) || (s = !0), Shopify.isDefined(l) || (l = "/");
        var t = document.getElementById(e),
            i = t.childNodes,
            c = (t.parentNode, a.length),
            d = [];
        Shopify.each(i, function(e, t) {
            if (1 == e.nodeType && "option" == e.tagName.toLowerCase()) {
                var i = e.innerHTML.split(new RegExp("\\s*\\" + l + "\\s*"));
                0 == a.length && (c = i.length - (s ? 1 : 0));
                var n = i.slice(0, c),
                    o = s ? i[c] : "",
                    r = (e.getAttribute("value"), {
                        available: !e.disabled,
                        id: parseFloat(e.value),
                        price: o,
                        option1: n[0],
                        option2: n[1],
                        option3: n[2]
                    });
                d.push(r)
            }
        });
        var n = {
            variants: d
        };
        if (0 == a.length) {
            n.options = [];
            for (var o = 0; o < c; o++) n.options[o] = "option " + (o + 1)
        } else n.options = a;
        return n
    }, Shopify.SingleOptionSelector = function(i, n, e, t) {
        this.multiSelector = i, this.values = t, this.index = n, this.name = e, this.element = document.createElement("select");
        for (var o = 0; o < t.length; o++) {
            var r = document.createElement("option");
            r.value = t[o], r.innerHTML = t[o], this.element.appendChild(r)
        }
        return this.element.setAttribute("class", this.multiSelector.selectorClass), this.element.setAttribute("data-option", "option" + (n + 1)), this.element.id = i.domIdPrefix + "-option-" + n, this.element.onchange = function(e, t) {
            t = t || {}, i.updateSelectors(n, t)
        }, !0
    }, Shopify.Image = {
        preload: function(e, t) {
            for (var i = 0; i < e.length; i++) {
                var n = e[i];
                this.loadImage(this.getSizedImageUrl(n, t))
            }
        },
        loadImage: function(e) {
            (new Image).src = e
        },
        switchImage: function(e, t, i) {
            if (e && t) {
                var n = this.imageSize(t.src),
                    o = this.getSizedImageUrl(e.src, n);
                i ? i(o, e, t) : t.src = o
            }
        },
        imageSize: function(e) {
            var t = e.match(/_(1024x1024|2048x2048|pico|icon|thumb|small|compact|medium|large|grande)\./);
            return null != t ? t[1] : null
        },
        getSizedImageUrl: function(e, t) {
            if (null == t) return e;
            if ("master" == t) return this.removeProtocol(e);
            var i = e.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);
            if (null == i) return null;
            var n = e.split(i[0]),
                o = i[0];
            return this.removeProtocol(n[0] + "_" + t + o)
        },
        removeProtocol: function(e) {
            return e.replace(/http(s)?:/, "")
        }
    }, Shopify.OptionSelectors.HistoryState = function(e) {
        this.browserSupports() && this.register(e)
    }, Shopify.OptionSelectors.HistoryState.prototype.register = function(t) {
        window.addEventListener("popstate", function(e) {
            t.selectVariantFromParamsOrDropdown({
                popStateCall: !0
            })
        })
    }, Shopify.OptionSelectors.HistoryState.prototype.onVariantChange = function(e, t, i) {
        this.browserSupports() && (!e || i.initialLoad || i.popStateCall || Shopify.setParam("variant", e.id))
    }, Shopify.OptionSelectors.HistoryState.prototype.browserSupports = function() {
        return window.history && window.history.replaceState
    },
    function(t) {
        t.extend(t.expr[":"], {
            "off-top": function(e) {
                return t(e).offset().top < t(window).scrollTop()
            },
            "off-right": function(e) {
                return t(e).offset().left + t(e).outerWidth() - t(window).scrollLeft() > t(window).width()
            },
            "off-bottom": function(e) {
                return t(e).offset().top + t(e).outerHeight() - t(window).scrollTop() > t(window).height()
            },
            "off-left": function(e) {
                return t(e).offset().left < t(window).scrollLeft()
            },
            "off-screen": function(e) {
                return t(e).is(":off-top, :off-right, :off-bottom, :off-left")
            }
        })
    }(jQuery),
    function(f) {
        var m = {
            url: !1,
            callback: !1,
            target: !1,
            duration: 120,
            on: "mouseover",
            touch: !0,
            onZoomIn: !1,
            onZoomOut: !1,
            magnify: 1
        };
        f.zoom = function(e, t, n, i) {
            var o, r, a, s, l, c, d, u = f(e),
                p = u.css("position"),
                h = f(t);
            return u.css("position", /(absolute|fixed)/.test(p) ? p : "relative"), u.css("overflow", "hidden"), n.style.width = n.style.height = "", f(n).addClass("zoomImg").css({
                position: "absolute",
                top: 0,
                left: 0,
                opacity: 0,
                width: n.width * i,
                height: n.height * i,
                border: "none",
                maxWidth: "none",
                maxHeight: "none"
            }).appendTo(e), {
                init: function() {
                    r = u.outerWidth(), o = u.outerHeight(), a = t === u[0] ? (s = r, o) : (s = h.outerWidth(), h.outerHeight()), l = (n.width - r) / s, c = (n.height - o) / a, d = h.offset()
                },
                move: function(e) {
                    var t = e.pageX - d.left,
                        i = e.pageY - d.top;
                    i = Math.max(Math.min(i, a), 0), t = Math.max(Math.min(t, s), 0), n.style.left = t * -l + "px", n.style.top = i * -c + "px"
                }
            }
        }, f.fn.zoom = function(h) {
            return this.each(function() {
                var e, t, i, o = f.extend({}, m, h || {}),
                    r = o.target || this,
                    a = this,
                    s = f(a),
                    n = f(r),
                    l = document.createElement("img"),
                    c = f(l),
                    d = "mousemove.zoom",
                    u = !1,
                    p = !1;
                (o.url || ((e = s.find("img"))[0] && (o.url = e.data("src") || e.attr("src")), o.url)) && (t = n.css("position"), i = n.css("overflow"), s.one("zoom.destroy", function() {
                    s.off(".zoom"), n.css("position", t), n.css("overflow", i), c.remove()
                }), l.onload = function() {
                    var t = f.zoom(r, a, l, o.magnify);

                    function i(e) {
                        t.init(), t.move(e), c.stop().fadeTo(f.support.opacity ? o.duration : 0, 1, !!f.isFunction(o.onZoomIn) && o.onZoomIn.call(l))
                    }

                    function n() {
                        c.stop().fadeTo(o.duration, 0, !!f.isFunction(o.onZoomOut) && o.onZoomOut.call(l))
                    }
                    "grab" === o.on ? s.on("mousedown.zoom", function(e) {
                        1 === e.which && (f(document).one("mouseup.zoom", function() {
                            n(), f(document).off(d, t.move)
                        }), i(e), f(document).on(d, t.move), e.preventDefault())
                    }) : "click" === o.on ? s.on("click.zoom", function(e) {
                        return u ? void 0 : (u = !0, i(e), f(document).on(d, t.move), f(document).one("click.zoom", function() {
                            n(), u = !1, f(document).off(d, t.move)
                        }), !1)
                    }) : "toggle" === o.on ? s.on("click.zoom", function(e) {
                        u ? n() : i(e), u = !u
                    }) : "mouseover" === o.on && (t.init(), s.on("mouseenter.zoom", i).on("mouseleave.zoom", n).on(d, t.move)), o.touch && s.on("touchstart.zoom", function(e) {
                        e.preventDefault(), p ? (p = !1, n()) : (p = !0, i(e.originalEvent.touches[0] || e.originalEvent.changedTouches[0]))
                    }).on("touchmove.zoom", function(e) {
                        e.preventDefault(), t.move(e.originalEvent.touches[0] || e.originalEvent.changedTouches[0])
                    }).on("touchend.zoom", function(e) {
                        e.preventDefault(), p && (p = !1, n())
                    }), f.isFunction(o.callback) && o.callback.call(l)
                }, l.src = o.url)
            })
        }, f.fn.zoom.defaults = m
    }(window.jQuery),
    function(t, i) {
        "function" == typeof define && define.amd ? define(["jquery"], function(e) {
            return i(t, e)
        }) : "object" == typeof exports ? i(t, require("jquery")) : i(t, t.jQuery || t.Zepto)
    }(this, function(e, a) {
        "use strict";

        function s(e) {
            if (b && "none" === e.css("animation-name") && "none" === e.css("-webkit-animation-name") && "none" === e.css("-moz-animation-name") && "none" === e.css("-o-animation-name") && "none" === e.css("-ms-animation-name")) return 0;
            var t, i, n, o, r = e.css("animation-duration") || e.css("-webkit-animation-duration") || e.css("-moz-animation-duration") || e.css("-o-animation-duration") || e.css("-ms-animation-duration") || "0s",
                a = e.css("animation-delay") || e.css("-webkit-animation-delay") || e.css("-moz-animation-delay") || e.css("-o-animation-delay") || e.css("-ms-animation-delay") || "0s",
                s = e.css("animation-iteration-count") || e.css("-webkit-animation-iteration-count") || e.css("-moz-animation-iteration-count") || e.css("-o-animation-iteration-count") || e.css("-ms-animation-iteration-count") || "1";
            for (r = r.split(", "), a = a.split(", "), s = s.split(", "), o = 0, i = r.length, t = Number.NEGATIVE_INFINITY; o < i; o++)(n = parseFloat(r[o]) * parseInt(s[o], 10) + parseFloat(a[o])) > t && (t = n);
            return t
        }

        function o() {
            if (a(document.body).height() <= a(window).height()) return 0;
            var e, t, i = document.createElement("div"),
                n = document.createElement("div");
            return i.style.visibility = "hidden", i.style.width = "100px", document.body.appendChild(i), e = i.offsetWidth, i.style.overflow = "scroll", n.style.width = "100%", i.appendChild(n), t = n.offsetWidth, i.parentNode.removeChild(i), e - t
        }

        function n() {
            if (!$) {
                var e, t, i = a("html"),
                    n = c("is-locked");
                i.hasClass(n) && (t = a(document.body), e = parseInt(t.css("padding-right"), 10) - o(), t.css("padding-right", e + "px"), i.removeClass(n))
            }
        }

        function r(e, t, i, n) {
            var o = c("is", t),
                r = [c("is", w.CLOSING), c("is", w.OPENING), c("is", w.CLOSED), c("is", w.OPENED)].join(" ");
            e.$bg.removeClass(r).addClass(o), e.$overlay.removeClass(r).addClass(o), e.$wrapper.removeClass(r).addClass(o), e.$modal.removeClass(r).addClass(o), e.state = t, i || e.$modal.trigger({
                type: t,
                reason: n
            }, [{
                reason: n
            }])
        }

        function i(e, t, i) {
            function n(e) {
                e.target === this && r++
            }

            function o(e) {
                e.target === this && 0 == --r && (a.each(["$bg", "$overlay", "$wrapper", "$modal"], function(e, t) {
                    i[t].off(g + " " + y)
                }), t())
            }
            var r = 0;
            a.each(["$bg", "$overlay", "$wrapper", "$modal"], function(e, t) {
                i[t].on(g, n).on(y, o)
            }), e(), 0 === s(i.$bg) && 0 === s(i.$overlay) && 0 === s(i.$wrapper) && 0 === s(i.$modal) && (a.each(["$bg", "$overlay", "$wrapper", "$modal"], function(e, t) {
                i[t].off(g + " " + y)
            }), t())
        }

        function l(i) {
            i.state !== w.CLOSED && (a.each(["$bg", "$overlay", "$wrapper", "$modal"], function(e, t) {
                i[t].off(g + " " + y)
            }), i.$bg.removeClass(i.settings.modifier), i.$overlay.removeClass(i.settings.modifier).hide(), i.$wrapper.hide(), n(), r(i, w.CLOSED, !0))
        }

        function c() {
            for (var e = m, t = 0; t < arguments.length; ++t) e += "-" + arguments[t];
            return e
        }

        function t() {
            var e, t, i = location.hash.replace("#", "");
            if (i) {
                try {
                    t = a('[data-remodal-id="' + i + '"]')
                } catch (e) {}
                t && t.length && (e = a[f].lookup[t.data(f)]) && e.settings.hashTracking && e.open()
            } else u && u.state === w.OPENED && u.settings.hashTracking && u.close()
        }

        function d(e, t) {
            var i = a(document.body),
                n = this;
            n.settings = a.extend({}, v, t), n.index = a[f].lookup.push(n) - 1, n.state = w.CLOSED, n.$overlay = a("." + c("overlay")), null !== n.settings.appendTo && n.settings.appendTo.length && (i = a(n.settings.appendTo)), n.$overlay.length || (n.$overlay = a("<div>").addClass(c("overlay") + " " + c("is", w.CLOSED)).hide(), i.append(n.$overlay)), n.$bg = a("." + c("bg")).addClass(c("is", w.CLOSED)), n.$modal = e.addClass(m + " " + c("is-initialized") + " " + n.settings.modifier + " " + c("is", w.CLOSED)).attr("tabindex", "-1"), n.$wrapper = a("<div>").addClass(c("wrapper") + " " + n.settings.modifier + " " + c("is", w.CLOSED)).hide().append(n.$modal), i.append(n.$wrapper), n.$wrapper.on("click." + m, '[data-remodal-action="close"]', function(e) {
                e.preventDefault(), n.close()
            }), n.$wrapper.on("click." + m, '[data-remodal-action="cancel"]', function(e) {
                e.preventDefault(), n.$modal.trigger(aT.CANCELLATION), n.settings.closeOnCancel && n.close(aT.CANCELLATION)
            }), n.$wrapper.on("click." + m, '[data-remodal-action="confirm"]', function(e) {
                e.preventDefault(), n.$modal.trigger(aT.CONFIRMATION), n.settings.closeOnConfirm && n.close(aT.CONFIRMATION)
            }), n.$wrapper.on("click." + m, function(e) {
                a(e.target).hasClass(c("wrapper")) && n.settings.closeOnOutsideClick && n.close()
            })
        }
        var u, p, h, f = "remodal",
            m = e.REMODAL_GLOBALS && e.REMODAL_GLOBALS.NAMESPACE || f,
            g = a.map(["animationstart", "webkitAnimationStart", "MSAnimationStart", "oAnimationStart"], function(e) {
                return e + "." + m
            }).join(" "),
            y = a.map(["animationend", "webkitAnimationEnd", "MSAnimationEnd", "oAnimationEnd"], function(e) {
                return e + "." + m
            }).join(" "),
            v = a.extend({
                hashTracking: !0,
                closeOnConfirm: !0,
                closeOnCancel: !0,
                closeOnEscape: !0,
                closeOnOutsideClick: !0,
                modifier: "",
                appendTo: null
            }, e.REMODAL_GLOBALS && e.REMODAL_GLOBALS.DEFAULTS),
            w = {
                CLOSING: "closing",
                CLOSED: "closed",
                OPENING: "opening",
                OPENED: "opened"
            },
            b = void 0 !== (h = document.createElement("div").style).animationName || void 0 !== h.WebkitAnimationName || void 0 !== h.MozAnimationName || void 0 !== h.msAnimationName || void 0 !== h.OAnimationName,
            $ = /iPad|iPhone|iPod/.test(navigator.platform);
        d.prototype.open = function() {
            var e, t = this;
            t.state !== w.OPENING && t.state !== w.CLOSING && ((e = t.$modal.attr("data-remodal-id")) && t.settings.hashTracking && (p = a(window).scrollTop(), location.hash = e), u && u !== t && l(u), u = t, function() {
                if (!$) {
                    var e, t, i = a("html"),
                        n = c("is-locked");
                    i.hasClass(n) || (t = a(document.body), e = parseInt(t.css("padding-right"), 10) + o(), t.css("padding-right", e + "px"), i.addClass(n))
                }
            }(), t.$bg.addClass(t.settings.modifier), t.$overlay.addClass(t.settings.modifier).show(), t.$wrapper.show().scrollTop(0), t.$modal.focus(), i(function() {
                r(t, w.OPENING)
            }, function() {
                r(t, w.OPENED)
            }, t))
        }, d.prototype.close = function(e) {
            var t = this;
            t.state !== w.OPENING && t.state !== w.CLOSING && (t.settings.hashTracking && t.$modal.attr("data-remodal-id") === location.hash.substr(1) && (location.hash = "", a(window).scrollTop(p)), i(function() {
                r(t, w.CLOSING, !1, e)
            }, function() {
                t.$bg.removeClass(t.settings.modifier), t.$overlay.removeClass(t.settings.modifier).hide(), t.$wrapper.hide(), n(), r(t, w.CLOSED, !1, e)
            }, t))
        }, d.prototype.getState = function() {
            return this.state
        }, d.prototype.destroy = function() {
            var e = a[f].lookup;
            l(this), this.$wrapper.remove(), delete e[this.index], 0 === a.grep(e, function(e) {
                return !!e
            }).length && (this.$overlay.remove(), this.$bg.removeClass(c("is", w.CLOSING) + " " + c("is", w.OPENING) + " " + c("is", w.CLOSED) + " " + c("is", w.OPENED)))
        }, a[f] = {
            lookup: []
        }, a.fn[f] = function(i) {
            var n, o;
            return this.each(function(e, t) {
                null == (o = a(t)).data(f) ? (n = new d(o, i), o.data(f, n.index), n.settings.hashTracking && o.attr("data-remodal-id") === location.hash.substr(1) && n.open()) : n = a[f].lookup[o.data(f)]
            }), n
        }, a(document).ready(function() {
            a("body").on("click", "[data-remodal-target]", function(e) {
                e.preventDefault();
                var t = e.currentTarget.getAttribute("data-remodal-target"),
                    i = a('[data-remodal-id="' + t + '"]');
                a[f].lookup[i.data(f)].open()
            }), a("body").find("." + m).each(function(e, t) {
                var i = a(t),
                    r = i.data("remodal-options");
                r ? ("string" == typeof r || r instanceof String) && (r = function() {
                    var e, t, i, n, o = {};
                    for (n = 0, t = (e = r.replace(/\s*:\s*/g, ":").replace(/\s*,\s*/g, ",").split(",")).length; n < t; n++) e[n] = e[n].split(":"), ("string" == typeof(i = e[n][1]) || i instanceof String) && (i = "true" === i || "false" !== i && i), ("string" == typeof i || i instanceof String) && (i = isNaN(i) ? i : +i), o[e[n][0]] = i;
                    return o
                }()) : r = {}, i[f](r)
            }), a("body").on("keydown." + m, function(e) {
                u && u.settings.closeOnEscape && u.state === w.OPENED && 27 === e.keyCode && u.close()
            }), a(window).on("hashchange." + m, t)
        })
    }),
    function(e) {
        var t = !1;
        if ("function" == typeof define && define.amd && (define(e), t = !0), "object" == typeof exports && (module.exports = e(), t = !0), !t) {
            var i = window.Cookies,
                n = window.Cookies = e();
            n.noConflict = function() {
                return window.Cookies = i, n
            }
        }
    }(function() {
        function m() {
            for (var e = 0, t = {}; e < arguments.length; e++) {
                var i = arguments[e];
                for (var n in i) t[n] = i[n]
            }
            return t
        }
        return function e(h) {
            function f(e, t, i) {
                var n;
                if ("undefined" != typeof document) {
                    if (1 < arguments.length) {
                        if ("number" == typeof(i = m({
                                path: "/"
                            }, f.defaults, i)).expires) {
                            var o = new Date;
                            o.setMilliseconds(o.getMilliseconds() + 864e5 * i.expires), i.expires = o
                        }
                        i.expires = i.expires ? i.expires.toUTCString() : "";
                        try {
                            n = JSON.stringify(t), /^[\{\[]/.test(n) && (t = n)
                        } catch (e) {}
                        t = h.write ? h.write(t, e) : encodeURIComponent(String(t)).replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent), e = (e = (e = encodeURIComponent(String(e))).replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent)).replace(/[\(\)]/g, escape);
                        var r = "";
                        for (var a in i) i[a] && (r += "; " + a, !0 !== i[a] && (r += "=" + i[a]));
                        return document.cookie = e + "=" + t + r
                    }
                    e || (n = {});
                    for (var s = document.cookie ? document.cookie.split("; ") : [], l = /(%[0-9A-Z]{2})+/g, c = 0; c < s.length; c++) {
                        var d = s[c].split("="),
                            u = d.slice(1).join("=");
                        '"' === u.charAt(0) && (u = u.slice(1, -1));
                        try {
                            var p = d[0].replace(l, decodeURIComponent);
                            if (u = h.read ? h.read(u, p) : h(u, p) || u.replace(l, decodeURIComponent), this.json) try {
                                u = JSON.parse(u)
                            } catch (e) {}
                            if (e === p) {
                                n = u;
                                break
                            }
                            e || (n[p] = u)
                        } catch (e) {}
                    }
                    return n
                }
            }
            return (f.set = f).get = function(e) {
                return f.call(f, e)
            }, f.getJSON = function() {
                return f.apply({
                    json: !0
                }, [].slice.call(arguments))
            }, f.defaults = {}, f.remove = function(e, t) {
                f(e, "", m(t, {
                    expires: -1
                }))
            }, f.withConverter = e, f
        }(function() {})
    }),
    function() {
        "use strict";

        function t(e) {
            if (!e) throw new Error("No options passed to Waypoint constructor");
            if (!e.element) throw new Error("No element option passed to Waypoint constructor");
            if (!e.handler) throw new Error("No handler option passed to Waypoint constructor");
            this.key = "waypoint-" + i, this.options = t.Adapter.extend({}, t.defaults, e), this.element = this.options.element, this.adapter = new t.Adapter(this.element), this.callback = e.handler, this.axis = this.options.horizontal ? "horizontal" : "vertical", this.enabled = this.options.enabled, this.triggerPoint = null, this.group = t.Group.findOrCreate({
                name: this.options.group,
                axis: this.axis
            }), this.context = t.Context.findOrCreateByElement(this.options.context), t.offsetAliases[this.options.offset] && (this.options.offset = t.offsetAliases[this.options.offset]), this.group.add(this), this.context.add(this), r[this.key] = this, i += 1
        }
        var i = 0,
            r = {};
        t.prototype.queueTrigger = function(e) {
            this.group.queueTrigger(this, e)
        }, t.prototype.trigger = function(e) {
            this.enabled && this.callback && this.callback.apply(this, e)
        }, t.prototype.destroy = function() {
            this.context.remove(this), this.group.remove(this), delete r[this.key]
        }, t.prototype.disable = function() {
            return this.enabled = !1, this
        }, t.prototype.enable = function() {
            return this.context.refresh(), this.enabled = !0, this
        }, t.prototype.next = function() {
            return this.group.next(this)
        }, t.prototype.previous = function() {
            return this.group.previous(this)
        }, t.invokeAll = function(e) {
            var t = [];
            for (var i in r) t.push(r[i]);
            for (var n = 0, o = t.length; n < o; n++) t[n][e]()
        }, t.destroyAll = function() {
            t.invokeAll("destroy")
        }, t.disableAll = function() {
            t.invokeAll("disable")
        }, t.enableAll = function() {
            t.invokeAll("enable")
        }, t.refreshAll = function() {
            t.Context.refreshAll()
        }, t.viewportHeight = function() {
            return window.innerHeight || document.documentElement.clientHeight
        }, t.viewportWidth = function() {
            return document.documentElement.clientWidth
        }, t.adapters = [], t.defaults = {
            context: window,
            continuous: !0,
            enabled: !0,
            group: "default",
            horizontal: !1,
            offset: 0
        }, t.offsetAliases = {
            "bottom-in-view": function() {
                return this.context.innerHeight() - this.adapter.outerHeight()
            },
            "right-in-view": function() {
                return this.context.innerWidth() - this.adapter.outerWidth()
            }
        }, window.Waypoint = t
    }(),
    function() {
        "use strict";

        function t(e) {
            this.element = e, this.Adapter = g.Adapter, this.adapter = new this.Adapter(e), this.key = "waypoint-context-" + i, this.didScroll = !1, this.didResize = !1, this.oldScroll = {
                x: this.adapter.scrollLeft(),
                y: this.adapter.scrollTop()
            }, this.waypoints = {
                vertical: {},
                horizontal: {}
            }, e.waypointContextKey = this.key, n[e.waypointContextKey] = this, i += 1, this.createThrottledScrollHandler(), this.createThrottledResizeHandler()
        }
        var i = 0,
            n = {},
            g = window.Waypoint,
            e = window.onload;
        t.prototype.add = function(e) {
            var t = e.options.horizontal ? "horizontal" : "vertical";
            this.waypoints[t][e.key] = e, this.refresh()
        }, t.prototype.checkEmpty = function() {
            var e = this.Adapter.isEmptyObject(this.waypoints.horizontal),
                t = this.Adapter.isEmptyObject(this.waypoints.vertical);
            e && t && (this.adapter.off(".waypoints"), delete n[this.key])
        }, t.prototype.createThrottledResizeHandler = function() {
            function e() {
                t.handleResize(), t.didResize = !1
            }
            var t = this;
            this.adapter.on("resize.waypoints", function() {
                t.didResize || (t.didResize = !0, g.requestAnimationFrame(e))
            })
        }, t.prototype.createThrottledScrollHandler = function() {
            function e() {
                t.handleScroll(), t.didScroll = !1
            }
            var t = this;
            this.adapter.on("scroll.waypoints", function() {
                t.didScroll && !g.isTouch || (t.didScroll = !0, g.requestAnimationFrame(e))
            })
        }, t.prototype.handleResize = function() {
            g.Context.refreshAll()
        }, t.prototype.handleScroll = function() {
            var e = {},
                t = {
                    horizontal: {
                        newScroll: this.adapter.scrollLeft(),
                        oldScroll: this.oldScroll.x,
                        forward: "right",
                        backward: "left"
                    },
                    vertical: {
                        newScroll: this.adapter.scrollTop(),
                        oldScroll: this.oldScroll.y,
                        forward: "down",
                        backward: "up"
                    }
                };
            for (var i in t) {
                var n = t[i],
                    o = n.newScroll > n.oldScroll ? n.forward : n.backward;
                for (var r in this.waypoints[i]) {
                    var a = this.waypoints[i][r],
                        s = n.oldScroll < a.triggerPoint,
                        l = n.newScroll >= a.triggerPoint;
                    (s && l || !s && !l) && (a.queueTrigger(o), e[a.group.id] = a.group)
                }
            }
            for (var c in e) e[c].flushTriggers();
            this.oldScroll = {
                x: t.horizontal.newScroll,
                y: t.vertical.newScroll
            }
        }, t.prototype.innerHeight = function() {
            return this.element == this.element.window ? g.viewportHeight() : this.adapter.innerHeight()
        }, t.prototype.remove = function(e) {
            delete this.waypoints[e.axis][e.key], this.checkEmpty()
        }, t.prototype.innerWidth = function() {
            return this.element == this.element.window ? g.viewportWidth() : this.adapter.innerWidth()
        }, t.prototype.destroy = function() {
            var e = [];
            for (var t in this.waypoints)
                for (var i in this.waypoints[t]) e.push(this.waypoints[t][i]);
            for (var n = 0, o = e.length; n < o; n++) e[n].destroy()
        }, t.prototype.refresh = function() {
            var e, t = this.element == this.element.window,
                i = t ? void 0 : this.adapter.offset(),
                n = {};
            for (var o in this.handleScroll(), e = {
                    horizontal: {
                        contextOffset: t ? 0 : i.left,
                        contextScroll: t ? 0 : this.oldScroll.x,
                        contextDimension: this.innerWidth(),
                        oldScroll: this.oldScroll.x,
                        forward: "right",
                        backward: "left",
                        offsetProp: "left"
                    },
                    vertical: {
                        contextOffset: t ? 0 : i.top,
                        contextScroll: t ? 0 : this.oldScroll.y,
                        contextDimension: this.innerHeight(),
                        oldScroll: this.oldScroll.y,
                        forward: "down",
                        backward: "up",
                        offsetProp: "top"
                    }
                }) {
                var r = e[o];
                for (var a in this.waypoints[o]) {
                    var s, l, c, d, u = this.waypoints[o][a],
                        p = u.options.offset,
                        h = u.triggerPoint,
                        f = 0,
                        m = null == h;
                    u.element !== u.element.window && (f = u.adapter.offset()[r.offsetProp]), "function" == typeof p ? p = p.apply(u) : "string" == typeof p && (p = parseFloat(p), -1 < u.options.offset.indexOf("%") && (p = Math.ceil(r.contextDimension * p / 100))), s = r.contextScroll - r.contextOffset, u.triggerPoint = f + s - p, l = h < r.oldScroll, c = u.triggerPoint >= r.oldScroll, d = !l && !c, !m && l && c ? (u.queueTrigger(r.backward), n[u.group.id] = u.group) : !m && d ? (u.queueTrigger(r.forward), n[u.group.id] = u.group) : m && r.oldScroll >= u.triggerPoint && (u.queueTrigger(r.forward), n[u.group.id] = u.group)
                }
            }
            return g.requestAnimationFrame(function() {
                for (var e in n) n[e].flushTriggers()
            }), this
        }, t.findOrCreateByElement = function(e) {
            return t.findByElement(e) || new t(e)
        }, t.refreshAll = function() {
            for (var e in n) n[e].refresh()
        }, t.findByElement = function(e) {
            return n[e.waypointContextKey]
        }, window.onload = function() {
            e && e(), t.refreshAll()
        }, g.requestAnimationFrame = function(e) {
            (window.requestAnimationFrame || window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame || function(e) {
                window.setTimeout(e, 1e3 / 60)
            }).call(window, e)
        }, g.Context = t
    }(),
    function() {
        "use strict";

        function a(e, t) {
            return e.triggerPoint - t.triggerPoint
        }

        function s(e, t) {
            return t.triggerPoint - e.triggerPoint
        }

        function t(e) {
            this.name = e.name, this.axis = e.axis, this.id = this.name + "-" + this.axis, this.waypoints = [], this.clearTriggerQueues(), i[this.axis][this.name] = this
        }
        var i = {
                vertical: {},
                horizontal: {}
            },
            n = window.Waypoint;
        t.prototype.add = function(e) {
            this.waypoints.push(e)
        }, t.prototype.clearTriggerQueues = function() {
            this.triggerQueues = {
                up: [],
                down: [],
                left: [],
                right: []
            }
        }, t.prototype.flushTriggers = function() {
            for (var e in this.triggerQueues) {
                var t = this.triggerQueues[e],
                    i = "up" === e || "left" === e;
                t.sort(i ? s : a);
                for (var n = 0, o = t.length; n < o; n += 1) {
                    var r = t[n];
                    !r.options.continuous && n !== t.length - 1 || r.trigger([e])
                }
            }
            this.clearTriggerQueues()
        }, t.prototype.next = function(e) {
            this.waypoints.sort(a);
            var t = n.Adapter.inArray(e, this.waypoints);
            return t === this.waypoints.length - 1 ? null : this.waypoints[t + 1]
        }, t.prototype.previous = function(e) {
            this.waypoints.sort(a);
            var t = n.Adapter.inArray(e, this.waypoints);
            return t ? this.waypoints[t - 1] : null
        }, t.prototype.queueTrigger = function(e, t) {
            this.triggerQueues[t].push(e)
        }, t.prototype.remove = function(e) {
            var t = n.Adapter.inArray(e, this.waypoints); - 1 < t && this.waypoints.splice(t, 1)
        }, t.prototype.first = function() {
            return this.waypoints[0]
        }, t.prototype.last = function() {
            return this.waypoints[this.waypoints.length - 1]
        }, t.findOrCreate = function(e) {
            return i[e.axis][e.name] || new t(e)
        }, n.Group = t
    }(),
    function() {
        "use strict";

        function i(e) {
            this.$element = n(e)
        }
        var n = window.jQuery,
            e = window.Waypoint;
        n.each(["innerHeight", "innerWidth", "off", "offset", "on", "outerHeight", "outerWidth", "scrollLeft", "scrollTop"], function(e, t) {
            i.prototype[t] = function() {
                var e = Array.prototype.slice.call(arguments);
                return this.$element[t].apply(this.$element, e)
            }
        }), n.each(["extend", "inArray", "isEmptyObject"], function(e, t) {
            i[t] = n[t]
        }), e.adapters.push({
            name: "jquery",
            Adapter: i
        }), e.Adapter = i
    }(),
    function() {
        "use strict";

        function e(n) {
            return function() {
                var t = [],
                    i = arguments[0];
                return n.isFunction(arguments[0]) && ((i = n.extend({}, arguments[1])).handler = arguments[0]), this.each(function() {
                    var e = n.extend({}, i, {
                        element: this
                    });
                    "string" == typeof e.context && (e.context = n(this).closest(e.context)[0]), t.push(new o(e))
                }), t
            }
        }
        var o = window.Waypoint;
        window.jQuery && (window.jQuery.fn.waypoint = e(window.jQuery)), window.Zepto && (window.Zepto.fn.waypoint = e(window.Zepto))
    }(),
    function() {
        "use strict";

        function t(e) {
            this.options = o.extend({}, t.defaults, e), this.container = this.options.element, "auto" !== this.options.container && (this.container = this.options.container), this.$container = o(this.container), this.$more = o(this.options.more), this.$more.length && (this.setupHandler(), this.waypoint = new r(this.options))
        }
        var o = window.jQuery,
            r = window.Waypoint;
        t.prototype.setupHandler = function() {
            this.options.handler = o.proxy(function() {
                this.options.onBeforePageLoad(), this.destroy(), this.$container.addClass(this.options.loadingClass), o.get(o(this.options.more).attr("href"), o.proxy(function(e) {
                    var t = o(o.parseHTML(e)),
                        i = t.find(this.options.more),
                        n = t.find(this.options.items);
                    n.length || (n = t.filter(this.options.items)), this.$container.append(n), this.$container.removeClass(this.options.loadingClass), i.length || (i = t.filter(this.options.more)), i.length ? (this.$more.replaceWith(i), this.$more = i, this.waypoint = new r(this.options)) : this.$more.remove(), this.options.onAfterPageLoad(n)
                }, this))
            }, this)
        }, t.prototype.destroy = function() {
            this.waypoint && this.waypoint.destroy()
        }, t.defaults = {
            container: "auto",
            items: ".infinite-item",
            more: ".infinite-more-link",
            offset: "bottom-in-view",
            loadingClass: "infinite-loading",
            onBeforePageLoad: o.noop,
            onAfterPageLoad: o.noop
        }, r.Infinite = t
    }(),
    function(i) {
        i.fn.mediaWrapper = function(e) {
            var t = i.extend({
                intrinsic: !0,
                baseWidth: 16,
                baseHeight: 9
            }, e);
            return this.each(function() {
                var e;
                e = 1 == t.intrinsic && "" !== i(this).attr("width") && "" !== i(this).attr("height") ? i(this).attr("height") / i(this).attr("width") * 100 : t.baseHeight / t.baseWidth * 100, i(this).wrap('<div class="mediaWrapper" style="width: 100%; height: 100%; padding: ' + e + '% 0 0 0; " />').css({
                    position: "absolute",
                    width: "100%",
                    height: "100%",
                    top: "0",
                    left: "0"
                })
            })
        }
    }(jQuery), PointerEventsPolyfill.initialize = function(e) {
        return null == PointerEventsPolyfill.singleton && (PointerEventsPolyfill.singleton = new PointerEventsPolyfill(e)), PointerEventsPolyfill.singleton
    }, PointerEventsPolyfill.prototype.register_mouse_events = function() {
        $(document).on(this.options.mouseEvents.join(" "), this.options.selector, function(e) {
            if ("none" != $(this).css("pointer-events")) return !0;
            var t = $(this).css("display");
            $(this).css("display", "none");
            var i = document.elementFromPoint(e.clientX, e.clientY);
            return t ? $(this).css("display", t) : $(this).css("display", ""), e.target = i, $(i).trigger(e), !1
        })
    },
    function(t, i) {
        "function" == typeof define && define.amd ? define("jquery-bridget/jquery-bridget", ["jquery"], function(e) {
            return i(t, e)
        }) : "object" == typeof module && module.exports ? module.exports = i(t, require("jquery")) : t.jQueryBridget = i(t, t.jQuery)
    }(window, function(e, t) {
        "use strict";

        function i(c, o, d) {
            (d = d || t || e.jQuery) && (o.prototype.option || (o.prototype.option = function(e) {
                d.isPlainObject(e) && (this.options = d.extend(!0, this.options, e))
            }), d.fn[c] = function(e) {
                return "string" == typeof e ? (this, r = e, a = u.call(arguments, 1), l = "$()." + c + '("' + r + '")', this.each(function(e, t) {
                    var i = d.data(t, c);
                    if (i) {
                        var n = i[r];
                        if (n && "_" != r.charAt(0)) {
                            var o = n.apply(i, a);
                            s = void 0 === s ? o : s
                        } else p(l + " is not a valid method")
                    } else p(c + " not initialized. Cannot call methods, i.e. " + l)
                }), void 0 !== s ? s : this) : (n = e, this.each(function(e, t) {
                    var i = d.data(t, c);
                    i ? (i.option(n), i._init()) : (i = new o(t, n), d.data(t, c, i))
                }), this);
                var n, r, a, s, l
            }, n(d))
        }

        function n(e) {
            !e || e && e.bridget || (e.bridget = i)
        }
        var u = Array.prototype.slice,
            o = e.console,
            p = void 0 === o ? function() {} : function(e) {
                o.error(e)
            };
        return n(t || e.jQuery), i
    }),
    function(e, t) {
        "function" == typeof define && define.amd ? define("ev-emitter/ev-emitter", t) : "object" == typeof module && module.exports ? module.exports = t() : e.EvEmitter = t()
    }("undefined" != typeof window ? window : this, function() {
        function e() {}
        var t = e.prototype;
        return t.on = function(e, t) {
            if (e && t) {
                var i = this._events = this._events || {},
                    n = i[e] = i[e] || [];
                return -1 == n.indexOf(t) && n.push(t), this
            }
        }, t.once = function(e, t) {
            if (e && t) {
                this.on(e, t);
                var i = this._onceEvents = this._onceEvents || {};
                return (i[e] = i[e] || {})[t] = !0, this
            }
        }, t.off = function(e, t) {
            var i = this._events && this._events[e];
            if (i && i.length) {
                var n = i.indexOf(t);
                return -1 != n && i.splice(n, 1), this
            }
        }, t.emitEvent = function(e, t) {
            var i = this._events && this._events[e];
            if (i && i.length) {
                i = i.slice(0), t = t || [];
                for (var n = this._onceEvents && this._onceEvents[e], o = 0; o < i.length; o++) {
                    var r = i[o];
                    n && n[r] && (this.off(e, r), delete n[r]), r.apply(this, t)
                }
                return this
            }
        }, t.allOff = function() {
            delete this._events, delete this._onceEvents
        }, e
    }),
    function(e, t) {
        "use strict";
        "function" == typeof define && define.amd ? define("get-size/get-size", [], function() {
            return t()
        }) : "object" == typeof module && module.exports ? module.exports = t() : e.getSize = t()
    }(window, function() {
        "use strict";

        function v(e) {
            var t = parseFloat(e);
            return -1 == e.indexOf("%") && !isNaN(t) && t
        }

        function w(e) {
            var t = getComputedStyle(e);
            return t || i("Style returned " + t + ". Are you running this code in a hidden iframe on Firefox? See http://bit.ly/getsizebug1"), t
        }
        var b, i = "undefined" == typeof console ? function() {} : function(e) {
                console.error(e)
            },
            $ = ["paddingLeft", "paddingRight", "paddingTop", "paddingBottom", "marginLeft", "marginRight", "marginTop", "marginBottom", "borderLeftWidth", "borderRightWidth", "borderTopWidth", "borderBottomWidth"],
            x = $.length,
            C = !1;
        return function n(e) {
            if (function() {
                    if (!C) {
                        C = !0;
                        var e = document.createElement("div");
                        e.style.width = "200px", e.style.padding = "1px 2px 3px 4px", e.style.borderStyle = "solid", e.style.borderWidth = "1px 2px 3px 4px", e.style.boxSizing = "border-box";
                        var t = document.body || document.documentElement;
                        t.appendChild(e);
                        var i = w(e);
                        n.isBoxSizeOuter = b = 200 == v(i.width), t.removeChild(e)
                    }
                }(), "string" == typeof e && (e = document.querySelector(e)), e && "object" == typeof e && e.nodeType) {
                var t = w(e);
                if ("none" == t.display) return function() {
                    for (var e = {
                            width: 0,
                            height: 0,
                            innerWidth: 0,
                            innerHeight: 0,
                            outerWidth: 0,
                            outerHeight: 0
                        }, t = 0; t < x; t++) e[$[t]] = 0;
                    return e
                }();
                var i = {};
                i.width = e.offsetWidth, i.height = e.offsetHeight;
                for (var o = i.isBorderBox = "border-box" == t.boxSizing, r = 0; r < x; r++) {
                    var a = $[r],
                        s = t[a],
                        l = parseFloat(s);
                    i[a] = isNaN(l) ? 0 : l
                }
                var c = i.paddingLeft + i.paddingRight,
                    d = i.paddingTop + i.paddingBottom,
                    u = i.marginLeft + i.marginRight,
                    p = i.marginTop + i.marginBottom,
                    h = i.borderLeftWidth + i.borderRightWidth,
                    f = i.borderTopWidth + i.borderBottomWidth,
                    m = o && b,
                    g = v(t.width);
                !1 !== g && (i.width = g + (m ? 0 : c + h));
                var y = v(t.height);
                return !1 !== y && (i.height = y + (m ? 0 : d + f)), i.innerWidth = i.width - (c + h), i.innerHeight = i.height - (d + f), i.outerWidth = i.width + u, i.outerHeight = i.height + p, i
            }
        }
    }),
    function(e, t) {
        "use strict";
        "function" == typeof define && define.amd ? define("desandro-matches-selector/matches-selector", t) : "object" == typeof module && module.exports ? module.exports = t() : e.matchesSelector = t()
    }(window, function() {
        "use strict";
        var i = function() {
            var e = window.Element.prototype;
            if (e.matches) return "matches";
            if (e.matchesSelector) return "matchesSelector";
            for (var t = ["webkit", "moz", "ms", "o"], i = 0; i < t.length; i++) {
                var n = t[i] + "MatchesSelector";
                if (e[n]) return n
            }
        }();
        return function(e, t) {
            return e[i](t)
        }
    }),
    function(t, i) {
        "function" == typeof define && define.amd ? define("fizzy-ui-utils/utils", ["desandro-matches-selector/matches-selector"], function(e) {
            return i(t, e)
        }) : "object" == typeof module && module.exports ? module.exports = i(t, require("desandro-matches-selector")) : t.fizzyUIUtils = i(t, t.matchesSelector)
    }(window, function(c, r) {
        var d = {
                extend: function(e, t) {
                    for (var i in t) e[i] = t[i];
                    return e
                },
                modulo: function(e, t) {
                    return (e % t + t) % t
                },
                makeArray: function(e) {
                    var t = [];
                    if (Array.isArray(e)) t = e;
                    else if (e && "object" == typeof e && "number" == typeof e.length)
                        for (var i = 0; i < e.length; i++) t.push(e[i]);
                    else t.push(e);
                    return t
                },
                removeFrom: function(e, t) {
                    var i = e.indexOf(t); - 1 != i && e.splice(i, 1)
                },
                getParent: function(e, t) {
                    for (; e.parentNode && e != document.body;)
                        if (e = e.parentNode, r(e, t)) return e
                },
                getQueryElement: function(e) {
                    return "string" == typeof e ? document.querySelector(e) : e
                },
                handleEvent: function(e) {
                    var t = "on" + e.type;
                    this[t] && this[t](e)
                },
                filterFindElements: function(e, n) {
                    e = d.makeArray(e);
                    var o = [];
                    return e.forEach(function(e) {
                        if (e instanceof HTMLElement) {
                            if (!n) return void o.push(e);
                            r(e, n) && o.push(e);
                            for (var t = e.querySelectorAll(n), i = 0; i < t.length; i++) o.push(t[i])
                        }
                    }), o
                },
                debounceMethod: function(e, t, n) {
                    var o = e.prototype[t],
                        r = t + "Timeout";
                    e.prototype[t] = function() {
                        var e = this[r];
                        e && clearTimeout(e);
                        var t = arguments,
                            i = this;
                        this[r] = setTimeout(function() {
                            o.apply(i, t), delete i[r]
                        }, n || 100)
                    }
                },
                docReady: function(e) {
                    var t = document.readyState;
                    "complete" == t || "interactive" == t ? setTimeout(e) : document.addEventListener("DOMContentLoaded", e)
                },
                toDashed: function(e) {
                    return e.replace(/(.)([A-Z])/g, function(e, t, i) {
                        return t + "-" + i
                    }).toLowerCase()
                }
            },
            u = c.console;
        return d.htmlInit = function(s, l) {
            d.docReady(function() {
                var e = d.toDashed(l),
                    o = "data-" + e,
                    t = document.querySelectorAll("[" + o + "]"),
                    i = document.querySelectorAll(".js-" + e),
                    n = d.makeArray(t).concat(d.makeArray(i)),
                    r = o + "-options",
                    a = c.jQuery;
                n.forEach(function(e) {
                    var t, i = e.getAttribute(o) || e.getAttribute(r);
                    try {
                        t = i && JSON.parse(i)
                    } catch (t) {
                        return void(u && u.error("Error parsing " + o + " on " + e.className + ": " + t))
                    }
                    var n = new s(e, t);
                    a && a.data(e, l, n)
                })
            })
        }, d
    }),
    function(t, i) {
        "function" == typeof define && define.amd ? define("flickity/js/cell", ["get-size/get-size"], function(e) {
            return i(t, e)
        }) : "object" == typeof module && module.exports ? module.exports = i(t, require("get-size")) : (t.Flickity = t.Flickity || {}, t.Flickity.Cell = i(t, t.getSize))
    }(window, function(e, t) {
        function i(e, t) {
            this.element = e, this.parent = t, this.create()
        }
        var n = i.prototype;
        return n.create = function() {
            this.element.style.position = "absolute", this.x = 0, this.shift = 0
        }, n.destroy = function() {
            this.element.style.position = "";
            var e = this.parent.originSide;
            this.element.style[e] = ""
        }, n.getSize = function() {
            this.size = t(this.element)
        }, n.setPosition = function(e) {
            this.x = e, this.updateTarget(), this.renderPosition(e)
        }, n.updateTarget = n.setDefaultTarget = function() {
            var e = "left" == this.parent.originSide ? "marginLeft" : "marginRight";
            this.target = this.x + this.size[e] + this.size.width * this.parent.cellAlign
        }, n.renderPosition = function(e) {
            var t = this.parent.originSide;
            this.element.style[t] = this.parent.getPositionValue(e)
        }, n.wrapShift = function(e) {
            this.shift = e, this.renderPosition(this.x + this.parent.slideableWidth * e)
        }, n.remove = function() {
            this.element.parentNode.removeChild(this.element)
        }, i
    }),
    function(e, t) {
        "function" == typeof define && define.amd ? define("flickity/js/slide", t) : "object" == typeof module && module.exports ? module.exports = t() : (e.Flickity = e.Flickity || {}, e.Flickity.Slide = t())
    }(window, function() {
        "use strict";

        function e(e) {
            this.parent = e, this.isOriginLeft = "left" == e.originSide, this.cells = [], this.outerWidth = 0, this.height = 0
        }
        var t = e.prototype;
        return t.addCell = function(e) {
            if (this.cells.push(e), this.outerWidth += e.size.outerWidth, this.height = Math.max(e.size.outerHeight, this.height), 1 == this.cells.length) {
                this.x = e.x;
                var t = this.isOriginLeft ? "marginLeft" : "marginRight";
                this.firstMargin = e.size[t]
            }
        }, t.updateTarget = function() {
            var e = this.isOriginLeft ? "marginRight" : "marginLeft",
                t = this.getLastCell(),
                i = t ? t.size[e] : 0,
                n = this.outerWidth - (this.firstMargin + i);
            this.target = this.x + this.firstMargin + n * this.parent.cellAlign
        }, t.getLastCell = function() {
            return this.cells[this.cells.length - 1]
        }, t.select = function() {
            this.changeSelectedClass("add")
        }, t.unselect = function() {
            this.changeSelectedClass("remove")
        }, t.changeSelectedClass = function(t) {
            this.cells.forEach(function(e) {
                e.element.classList[t]("is-selected")
            })
        }, t.getCellElements = function() {
            return this.cells.map(function(e) {
                return e.element
            })
        }, e
    }),
    function(t, i) {
        "function" == typeof define && define.amd ? define("flickity/js/animate", ["fizzy-ui-utils/utils"], function(e) {
            return i(t, e)
        }) : "object" == typeof module && module.exports ? module.exports = i(t, require("fizzy-ui-utils")) : (t.Flickity = t.Flickity || {}, t.Flickity.animatePrototype = i(t, t.fizzyUIUtils))
    }(window, function(e, r) {
        var i = e.requestAnimationFrame || e.webkitRequestAnimationFrame,
            o = 0;
        i = i || function(e) {
            var t = (new Date).getTime(),
                i = Math.max(0, 16 - (t - o)),
                n = setTimeout(e, i);
            return o = t + i, n
        };
        var t = {
                startAnimation: function() {
                    this.isAnimating || (this.isAnimating = !0, this.restingFrames = 0, this.animate())
                },
                animate: function() {
                    this.applyDragForce(), this.applySelectedAttraction();
                    var e = this.x;
                    if (this.integratePhysics(), this.positionSlider(), this.settle(e), this.isAnimating) {
                        var t = this;
                        i(function() {
                            t.animate()
                        })
                    }
                }
            },
            a = "string" == typeof document.documentElement.style.transform ? "transform" : "WebkitTransform";
        return t.positionSlider = function() {
            var e = this.x;
            this.options.wrapAround && 1 < this.cells.length && (e = r.modulo(e, this.slideableWidth), e -= this.slideableWidth, this.shiftWrapCells(e)), e += this.cursorPosition, e = this.options.rightToLeft && a ? -e : e;
            var t = this.getPositionValue(e);
            this.slider.style[a] = this.isAnimating ? "translate3d(" + t + ",0,0)" : "translateX(" + t + ")";
            var i = this.slides[0];
            if (i) {
                var n = -this.x - i.target,
                    o = n / this.slidesWidth;
                this.dispatchEvent("scroll", null, [o, n])
            }
        }, t.positionSliderAtSelected = function() {
            this.cells.length && (this.x = -this.selectedSlide.target, this.positionSlider())
        }, t.getPositionValue = function(e) {
            return this.options.percentPosition ? .01 * Math.round(e / this.size.innerWidth * 1e4) + "%" : Math.round(e) + "px"
        }, t.settle = function(e) {
            this.isPointerDown || Math.round(100 * this.x) != Math.round(100 * e) || this.restingFrames++, 2 < this.restingFrames && (this.isAnimating = !1, delete this.isFreeScrolling, this.positionSlider(), this.dispatchEvent("settle"))
        }, t.shiftWrapCells = function(e) {
            var t = this.cursorPosition + e;
            this._shiftCells(this.beforeShiftCells, t, -1);
            var i = this.size.innerWidth - (e + this.slideableWidth + this.cursorPosition);
            this._shiftCells(this.afterShiftCells, i, 1)
        }, t._shiftCells = function(e, t, i) {
            for (var n = 0; n < e.length; n++) {
                var o = e[n],
                    r = 0 < t ? i : 0;
                o.wrapShift(r), t -= o.size.outerWidth
            }
        }, t._unshiftCells = function(e) {
            if (e && e.length)
                for (var t = 0; t < e.length; t++) e[t].wrapShift(0)
        }, t.integratePhysics = function() {
            this.x += this.velocity, this.velocity *= this.getFrictionFactor()
        }, t.applyForce = function(e) {
            this.velocity += e
        }, t.getFrictionFactor = function() {
            return 1 - this.options[this.isFreeScrolling ? "freeScrollFriction" : "friction"]
        }, t.getRestingPosition = function() {
            return this.x + this.velocity / (1 - this.getFrictionFactor())
        }, t.applyDragForce = function() {
            if (this.isPointerDown) {
                var e = this.dragX - this.x - this.velocity;
                this.applyForce(e)
            }
        }, t.applySelectedAttraction = function() {
            if (!this.isPointerDown && !this.isFreeScrolling && this.cells.length) {
                var e = (-1 * this.selectedSlide.target - this.x) * this.options.selectedAttraction;
                this.applyForce(e)
            }
        }, t
    }),
    function(a, s) {
        if ("function" == typeof define && define.amd) define("flickity/js/flickity", ["ev-emitter/ev-emitter", "get-size/get-size", "fizzy-ui-utils/utils", "./cell", "./slide", "./animate"], function(e, t, i, n, o, r) {
            return s(a, e, t, i, n, o, r)
        });
        else if ("object" == typeof module && module.exports) module.exports = s(a, require("ev-emitter"), require("get-size"), require("fizzy-ui-utils"), require("./cell"), require("./slide"), require("./animate"));
        else {
            var e = a.Flickity;
            a.Flickity = s(a, a.EvEmitter, a.getSize, a.fizzyUIUtils, e.Cell, e.Slide, e.animatePrototype)
        }
    }(window, function(t, e, i, s, n, a, o) {
        function r(e, t) {
            for (e = s.makeArray(e); e.length;) t.appendChild(e.shift())
        }

        function l(e, t) {
            var i = s.getQueryElement(e);
            if (i) {
                if (this.element = i, this.element.flickityGUID) {
                    var n = h[this.element.flickityGUID];
                    return n.option(t), n
                }
                c && (this.$element = c(this.element)), this.options = s.extend({}, this.constructor.defaults), this.option(t), this._create()
            } else u && u.error("Bad element for Flickity: " + (i || e))
        }
        var c = t.jQuery,
            d = t.getComputedStyle,
            u = t.console,
            p = 0,
            h = {};
        l.defaults = {
            accessibility: !0,
            cellAlign: "center",
            freeScrollFriction: .075,
            friction: .28,
            namespaceJQueryEvents: !0,
            percentPosition: !0,
            resize: !0,
            selectedAttraction: .025,
            setGallerySize: !0
        }, l.createMethods = [];
        var f = l.prototype;
        s.extend(f, e.prototype), f._create = function() {
            var e = this.guid = ++p;
            this.element.flickityGUID = e, (h[e] = this).selectedIndex = 0, this.restingFrames = 0, this.x = 0, this.velocity = 0, this.originSide = this.options.rightToLeft ? "right" : "left", this.viewport = document.createElement("div"), this.viewport.className = "flickity-viewport", this._createSlider(), (this.options.resize || this.options.watchCSS) && t.addEventListener("resize", this), l.createMethods.forEach(function(e) {
                this[e]()
            }, this), this.options.watchCSS ? this.watchCSS() : this.activate()
        }, f.option = function(e) {
            s.extend(this.options, e)
        }, f.activate = function() {
            if (!this.isActive) {
                this.isActive = !0, this.element.classList.add("flickity-enabled"), this.options.rightToLeft && this.element.classList.add("flickity-rtl"), this.getSize(), r(this._filterFindCellElements(this.element.children), this.slider), this.viewport.appendChild(this.slider), this.element.appendChild(this.viewport), this.reloadCells(), this.options.accessibility && (this.element.tabIndex = 0, this.element.addEventListener("keydown", this)), this.emitEvent("activate");
                var e, t = this.options.initialIndex;
                e = this.isInitActivated ? this.selectedIndex : void 0 !== t && this.cells[t] ? t : 0, this.select(e, !1, !0), this.isInitActivated = !0
            }
        }, f._createSlider = function() {
            var e = document.createElement("div");
            e.className = "flickity-slider", e.style[this.originSide] = 0, this.slider = e
        }, f._filterFindCellElements = function(e) {
            return s.filterFindElements(e, this.options.cellSelector)
        }, f.reloadCells = function() {
            this.cells = this._makeCells(this.slider.children), this.positionCells(), this._getWrapShiftCells(), this.setGallerySize()
        }, f._makeCells = function(e) {
            return this._filterFindCellElements(e).map(function(e) {
                return new n(e, this)
            }, this)
        }, f.getLastCell = function() {
            return this.cells[this.cells.length - 1]
        }, f.getLastSlide = function() {
            return this.slides[this.slides.length - 1]
        }, f.positionCells = function() {
            this._sizeCells(this.cells), this._positionCells(0)
        }, f._positionCells = function(e) {
            e = e || 0, this.maxCellHeight = e && this.maxCellHeight || 0;
            var t = 0;
            if (0 < e) {
                var i = this.cells[e - 1];
                t = i.x + i.size.outerWidth
            }
            for (var n = this.cells.length, o = e; o < n; o++) {
                var r = this.cells[o];
                r.setPosition(t), t += r.size.outerWidth, this.maxCellHeight = Math.max(r.size.outerHeight, this.maxCellHeight)
            }
            this.slideableWidth = t, this.updateSlides(), this._containSlides(), this.slidesWidth = n ? this.getLastSlide().target - this.slides[0].target : 0
        }, f._sizeCells = function(e) {
            e.forEach(function(e) {
                e.getSize()
            })
        }, f.updateSlides = function() {
            if (this.slides = [], this.cells.length) {
                var n = new a(this);
                this.slides.push(n);
                var o = "left" == this.originSide ? "marginRight" : "marginLeft",
                    r = this._getCanCellFit();
                this.cells.forEach(function(e, t) {
                    if (n.cells.length) {
                        var i = n.outerWidth - n.firstMargin + (e.size.outerWidth - e.size[o]);
                        r.call(this, t, i) || (n.updateTarget(), n = new a(this), this.slides.push(n)), n.addCell(e)
                    } else n.addCell(e)
                }, this), n.updateTarget(), this.updateSelectedSlide()
            }
        }, f._getCanCellFit = function() {
            var e = this.options.groupCells;
            if (!e) return function() {
                return !1
            };
            if ("number" == typeof e) {
                var t = parseInt(e, 10);
                return function(e) {
                    return e % t != 0
                }
            }
            var i = "string" == typeof e && e.match(/^(\d+)%$/),
                n = i ? parseInt(i[1], 10) / 100 : 1;
            return function(e, t) {
                return t <= (this.size.innerWidth + 1) * n
            }
        }, f._init = f.reposition = function() {
            this.positionCells(), this.positionSliderAtSelected()
        }, f.getSize = function() {
            this.size = i(this.element), this.setCellAlign(), this.cursorPosition = this.size.innerWidth * this.cellAlign
        };
        var m = {
            center: {
                left: .5,
                right: .5
            },
            left: {
                left: 0,
                right: 1
            },
            right: {
                right: 0,
                left: 1
            }
        };
        return f.setCellAlign = function() {
            var e = m[this.options.cellAlign];
            this.cellAlign = e ? e[this.originSide] : this.options.cellAlign
        }, f.setGallerySize = function() {
            if (this.options.setGallerySize) {
                var e = this.options.adaptiveHeight && this.selectedSlide ? this.selectedSlide.height : this.maxCellHeight;
                this.viewport.style.height = e + "px"
            }
        }, f._getWrapShiftCells = function() {
            if (this.options.wrapAround) {
                this._unshiftCells(this.beforeShiftCells), this._unshiftCells(this.afterShiftCells);
                var e = this.cursorPosition,
                    t = this.cells.length - 1;
                this.beforeShiftCells = this._getGapCells(e, t, -1), e = this.size.innerWidth - this.cursorPosition, this.afterShiftCells = this._getGapCells(e, 0, 1)
            }
        }, f._getGapCells = function(e, t, i) {
            for (var n = []; 0 < e;) {
                var o = this.cells[t];
                if (!o) break;
                n.push(o), t += i, e -= o.size.outerWidth
            }
            return n
        }, f._containSlides = function() {
            if (this.options.contain && !this.options.wrapAround && this.cells.length) {
                var e = this.options.rightToLeft,
                    t = e ? "marginRight" : "marginLeft",
                    i = e ? "marginLeft" : "marginRight",
                    n = this.slideableWidth - this.getLastCell().size[i],
                    o = n < this.size.innerWidth,
                    r = this.cursorPosition + this.cells[0].size[t],
                    a = n - this.size.innerWidth * (1 - this.cellAlign);
                this.slides.forEach(function(e) {
                    o ? e.target = n * this.cellAlign : (e.target = Math.max(e.target, r), e.target = Math.min(e.target, a))
                }, this)
            }
        }, f.dispatchEvent = function(e, t, i) {
            var n = t ? [t].concat(i) : i;
            if (this.emitEvent(e, n), c && this.$element) {
                var o = e += this.options.namespaceJQueryEvents ? ".flickity" : "";
                if (t) {
                    var r = c.Event(t);
                    r.type = e, o = r
                }
                this.$element.trigger(o, i)
            }
        }, f.select = function(e, t, i) {
            this.isActive && (e = parseInt(e, 10), this._wrapSelect(e), (this.options.wrapAround || t) && (e = s.modulo(e, this.slides.length)), this.slides[e] && (this.selectedIndex = e, this.updateSelectedSlide(), i ? this.positionSliderAtSelected() : this.startAnimation(), this.options.adaptiveHeight && this.setGallerySize(), this.dispatchEvent("select"), this.dispatchEvent("cellSelect")))
        }, f._wrapSelect = function(e) {
            var t = this.slides.length;
            if (!(this.options.wrapAround && 1 < t)) return e;
            var i = s.modulo(e, t),
                n = Math.abs(i - this.selectedIndex),
                o = Math.abs(i + t - this.selectedIndex),
                r = Math.abs(i - t - this.selectedIndex);
            !this.isDragSelect && o < n ? e += t : !this.isDragSelect && r < n && (e -= t), e < 0 ? this.x -= this.slideableWidth : t <= e && (this.x += this.slideableWidth)
        }, f.previous = function(e, t) {
            this.select(this.selectedIndex - 1, e, t)
        }, f.next = function(e, t) {
            this.select(this.selectedIndex + 1, e, t)
        }, f.updateSelectedSlide = function() {
            var e = this.slides[this.selectedIndex];
            e && (this.unselectSelectedSlide(), (this.selectedSlide = e).select(), this.selectedCells = e.cells, this.selectedElements = e.getCellElements(), this.selectedCell = e.cells[0], this.selectedElement = this.selectedElements[0])
        }, f.unselectSelectedSlide = function() {
            this.selectedSlide && this.selectedSlide.unselect()
        }, f.selectCell = function(e, t, i) {
            var n;
            n = "number" == typeof e ? this.cells[e] : ("string" == typeof e && (e = this.element.querySelector(e)), this.getCell(e));
            for (var o = 0; n && o < this.slides.length; o++)
                if (-1 != this.slides[o].cells.indexOf(n)) return void this.select(o, t, i)
        }, f.getCell = function(e) {
            for (var t = 0; t < this.cells.length; t++) {
                var i = this.cells[t];
                if (i.element == e) return i
            }
        }, f.getCells = function(e) {
            e = s.makeArray(e);
            var i = [];
            return e.forEach(function(e) {
                var t = this.getCell(e);
                t && i.push(t)
            }, this), i
        }, f.getCellElements = function() {
            return this.cells.map(function(e) {
                return e.element
            })
        }, f.getParentCell = function(e) {
            return this.getCell(e) || (e = s.getParent(e, ".flickity-slider > *"), this.getCell(e))
        }, f.getAdjacentCellElements = function(e, t) {
            if (!e) return this.selectedSlide.getCellElements();
            t = void 0 === t ? this.selectedIndex : t;
            var i = this.slides.length;
            if (i <= 1 + 2 * e) return this.getCellElements();
            for (var n = [], o = t - e; o <= t + e; o++) {
                var r = this.options.wrapAround ? s.modulo(o, i) : o,
                    a = this.slides[r];
                a && (n = n.concat(a.getCellElements()))
            }
            return n
        }, f.uiChange = function() {
            this.emitEvent("uiChange")
        }, f.childUIPointerDown = function(e) {
            this.emitEvent("childUIPointerDown", [e])
        }, f.onresize = function() {
            this.watchCSS(), this.resize()
        }, s.debounceMethod(l, "onresize", 150), f.resize = function() {
            if (this.isActive) {
                this.getSize(), this.options.wrapAround && (this.x = s.modulo(this.x, this.slideableWidth)), this.positionCells(), this._getWrapShiftCells(), this.setGallerySize(), this.emitEvent("resize");
                var e = this.selectedElements && this.selectedElements[0];
                this.selectCell(e, !1, !0)
            }
        }, f.watchCSS = function() {
            this.options.watchCSS && (-1 != d(this.element, ":after").content.indexOf("flickity") ? this.activate() : this.deactivate())
        }, f.onkeydown = function(e) {
            if (this.options.accessibility && (!document.activeElement || document.activeElement == this.element))
                if (37 == e.keyCode) {
                    var t = this.options.rightToLeft ? "next" : "previous";
                    this.uiChange(), this[t]()
                } else if (39 == e.keyCode) {
                var i = this.options.rightToLeft ? "previous" : "next";
                this.uiChange(), this[i]()
            }
        }, f.deactivate = function() {
            this.isActive && (this.element.classList.remove("flickity-enabled"), this.element.classList.remove("flickity-rtl"), this.cells.forEach(function(e) {
                e.destroy()
            }), this.unselectSelectedSlide(), this.element.removeChild(this.viewport), r(this.slider.children, this.element), this.options.accessibility && (this.element.removeAttribute("tabIndex"), this.element.removeEventListener("keydown", this)), this.isActive = !1, this.emitEvent("deactivate"))
        }, f.destroy = function() {
            this.deactivate(), t.removeEventListener("resize", this), this.emitEvent("destroy"), c && this.$element && c.removeData(this.element, "flickity"), delete this.element.flickityGUID, delete h[this.guid]
        }, s.extend(f, o), l.data = function(e) {
            var t = (e = s.getQueryElement(e)) && e.flickityGUID;
            return t && h[t]
        }, s.htmlInit(l, "flickity"), c && c.bridget && c.bridget("flickity", l), l.setJQuery = function(e) {
            c = e
        }, l.Cell = n, l
    }),
    function(t, i) {
        "function" == typeof define && define.amd ? define("unipointer/unipointer", ["ev-emitter/ev-emitter"], function(e) {
            return i(t, e)
        }) : "object" == typeof module && module.exports ? module.exports = i(t, require("ev-emitter")) : t.Unipointer = i(t, t.EvEmitter)
    }(window, function(n, e) {
        function t() {}
        var i = t.prototype = Object.create(e.prototype);
        i.bindStartEvent = function(e) {
            this._bindStartEvent(e, !0)
        }, i.unbindStartEvent = function(e) {
            this._bindStartEvent(e, !1)
        }, i._bindStartEvent = function(e, t) {
            var i = (t = void 0 === t || !!t) ? "addEventListener" : "removeEventListener";
            n.PointerEvent ? e[i]("pointerdown", this) : (e[i]("mousedown", this), e[i]("touchstart", this))
        }, i.handleEvent = function(e) {
            var t = "on" + e.type;
            this[t] && this[t](e)
        }, i.getTouch = function(e) {
            for (var t = 0; t < e.length; t++) {
                var i = e[t];
                if (i.identifier == this.pointerIdentifier) return i
            }
        }, i.onmousedown = function(e) {
            var t = e.button;
            t && 0 !== t && 1 !== t || this._pointerDown(e, e)
        }, i.ontouchstart = function(e) {
            this._pointerDown(e, e.changedTouches[0])
        }, i.onpointerdown = function(e) {
            this._pointerDown(e, e)
        }, i._pointerDown = function(e, t) {
            this.isPointerDown || (this.isPointerDown = !0, this.pointerIdentifier = void 0 !== t.pointerId ? t.pointerId : t.identifier, this.pointerDown(e, t))
        }, i.pointerDown = function(e, t) {
            this._bindPostStartEvents(e), this.emitEvent("pointerDown", [e, t])
        };
        var o = {
            mousedown: ["mousemove", "mouseup"],
            touchstart: ["touchmove", "touchend", "touchcancel"],
            pointerdown: ["pointermove", "pointerup", "pointercancel"]
        };
        return i._bindPostStartEvents = function(e) {
            if (e) {
                var t = o[e.type];
                t.forEach(function(e) {
                    n.addEventListener(e, this)
                }, this), this._boundPointerEvents = t
            }
        }, i._unbindPostStartEvents = function() {
            this._boundPointerEvents && (this._boundPointerEvents.forEach(function(e) {
                n.removeEventListener(e, this)
            }, this), delete this._boundPointerEvents)
        }, i.onmousemove = function(e) {
            this._pointerMove(e, e)
        }, i.onpointermove = function(e) {
            e.pointerId == this.pointerIdentifier && this._pointerMove(e, e)
        }, i.ontouchmove = function(e) {
            var t = this.getTouch(e.changedTouches);
            t && this._pointerMove(e, t)
        }, i._pointerMove = function(e, t) {
            this.pointerMove(e, t)
        }, i.pointerMove = function(e, t) {
            this.emitEvent("pointerMove", [e, t])
        }, i.onmouseup = function(e) {
            this._pointerUp(e, e)
        }, i.onpointerup = function(e) {
            e.pointerId == this.pointerIdentifier && this._pointerUp(e, e)
        }, i.ontouchend = function(e) {
            var t = this.getTouch(e.changedTouches);
            t && this._pointerUp(e, t)
        }, i._pointerUp = function(e, t) {
            this._pointerDone(), this.pointerUp(e, t)
        }, i.pointerUp = function(e, t) {
            this.emitEvent("pointerUp", [e, t])
        }, i._pointerDone = function() {
            this.isPointerDown = !1, delete this.pointerIdentifier, this._unbindPostStartEvents(), this.pointerDone()
        }, i.pointerDone = function() {}, i.onpointercancel = function(e) {
            e.pointerId == this.pointerIdentifier && this._pointerCancel(e, e)
        }, i.ontouchcancel = function(e) {
            var t = this.getTouch(e.changedTouches);
            t && this._pointerCancel(e, t)
        }, i._pointerCancel = function(e, t) {
            this._pointerDone(), this.pointerCancel(e, t)
        }, i.pointerCancel = function(e, t) {
            this.emitEvent("pointerCancel", [e, t])
        }, t.getPointerPoint = function(e) {
            return {
                x: e.pageX,
                y: e.pageY
            }
        }, t
    }),
    function(t, i) {
        "function" == typeof define && define.amd ? define("unidragger/unidragger", ["unipointer/unipointer"], function(e) {
            return i(t, e)
        }) : "object" == typeof module && module.exports ? module.exports = i(t, require("unipointer")) : t.Unidragger = i(t, t.Unipointer)
    }(window, function(o, r) {
        function e() {}
        var t = e.prototype = Object.create(r.prototype);
        return t.bindHandles = function() {
            this._bindHandles(!0)
        }, t.unbindHandles = function() {
            this._bindHandles(!1)
        }, t._bindHandles = function(e) {
            for (var t = (e = void 0 === e || !!e) ? "addEventListener" : "removeEventListener", i = 0; i < this.handles.length; i++) {
                var n = this.handles[i];
                this._bindStartEvent(n, e), n[t]("click", this), o.PointerEvent && (n.style.touchAction = e ? this._touchActionValue : "")
            }
        }, t._touchActionValue = "none", t.pointerDown = function(e, t) {
            if ("INPUT" == e.target.nodeName && "range" == e.target.type) return this.isPointerDown = !1, void delete this.pointerIdentifier;
            this._dragPointerDown(e, t);
            var i = document.activeElement;
            i && i.blur && i.blur(), this._bindPostStartEvents(e), this.emitEvent("pointerDown", [e, t])
        }, t._dragPointerDown = function(e, t) {
            this.pointerDownPoint = r.getPointerPoint(t), this.canPreventDefaultOnPointerDown(e, t) && e.preventDefault()
        }, t.canPreventDefaultOnPointerDown = function(e) {
            return "SELECT" != e.target.nodeName
        }, t.pointerMove = function(e, t) {
            var i = this._dragPointerMove(e, t);
            this.emitEvent("pointerMove", [e, t, i]), this._dragMove(e, t, i)
        }, t._dragPointerMove = function(e, t) {
            var i = r.getPointerPoint(t),
                n = {
                    x: i.x - this.pointerDownPoint.x,
                    y: i.y - this.pointerDownPoint.y
                };
            return !this.isDragging && this.hasDragStarted(n) && this._dragStart(e, t), n
        }, t.hasDragStarted = function(e) {
            return 3 < Math.abs(e.x) || 3 < Math.abs(e.y)
        }, t.pointerUp = function(e, t) {
            this.emitEvent("pointerUp", [e, t]), this._dragPointerUp(e, t)
        }, t._dragPointerUp = function(e, t) {
            this.isDragging ? this._dragEnd(e, t) : this._staticClick(e, t)
        }, t._dragStart = function(e, t) {
            this.isDragging = !0, this.dragStartPoint = r.getPointerPoint(t), this.isPreventingClicks = !0, this.dragStart(e, t)
        }, t.dragStart = function(e, t) {
            this.emitEvent("dragStart", [e, t])
        }, t._dragMove = function(e, t, i) {
            this.isDragging && this.dragMove(e, t, i)
        }, t.dragMove = function(e, t, i) {
            e.preventDefault(), this.emitEvent("dragMove", [e, t, i])
        }, t._dragEnd = function(e, t) {
            this.isDragging = !1, setTimeout(function() {
                delete this.isPreventingClicks
            }.bind(this)), this.dragEnd(e, t)
        }, t.dragEnd = function(e, t) {
            this.emitEvent("dragEnd", [e, t])
        }, t.onclick = function(e) {
            this.isPreventingClicks && e.preventDefault()
        }, t._staticClick = function(e, t) {
            if (!this.isIgnoringMouseUp || "mouseup" != e.type) {
                var i = e.target.nodeName;
                "INPUT" != i && "TEXTAREA" != i || e.target.focus(), this.staticClick(e, t), "mouseup" != e.type && (this.isIgnoringMouseUp = !0, setTimeout(function() {
                    delete this.isIgnoringMouseUp
                }.bind(this), 400))
            }
        }, t.staticClick = function(e, t) {
            this.emitEvent("staticClick", [e, t])
        }, e.getPointerPoint = r.getPointerPoint, e
    }),
    function(n, o) {
        "function" == typeof define && define.amd ? define("flickity/js/drag", ["./flickity", "unidragger/unidragger", "fizzy-ui-utils/utils"], function(e, t, i) {
            return o(n, e, t, i)
        }) : "object" == typeof module && module.exports ? module.exports = o(n, require("./flickity"), require("unidragger"), require("fizzy-ui-utils")) : n.Flickity = o(n, n.Flickity, n.Unidragger, n.fizzyUIUtils)
    }(window, function(n, e, t, s) {
        function o(e) {
            var t = "touchstart" == e.type,
                i = "touch" == e.pointerType,
                n = u[e.target.nodeName];
            return t || i || n
        }

        function r() {
            return {
                x: n.pageXOffset,
                y: n.pageYOffset
            }
        }
        s.extend(e.defaults, {
            draggable: !0,
            dragThreshold: 3
        }), e.createMethods.push("_createDrag");
        var i = e.prototype;
        s.extend(i, t.prototype), i._touchActionValue = "pan-y";
        var a = "createTouch" in document,
            l = !1;
        i._createDrag = function() {
            this.on("activate", this.bindDrag), this.on("uiChange", this._uiChangeDrag), this.on("childUIPointerDown", this._childUIPointerDownDrag), this.on("deactivate", this.unbindDrag), a && !l && (n.addEventListener("touchmove", function() {}), l = !0)
        }, i.bindDrag = function() {
            this.options.draggable && !this.isDragBound && (this.element.classList.add("is-draggable"), this.handles = [this.viewport], this.bindHandles(), this.isDragBound = !0)
        }, i.unbindDrag = function() {
            this.isDragBound && (this.element.classList.remove("is-draggable"), this.unbindHandles(), delete this.isDragBound)
        }, i._uiChangeDrag = function() {
            delete this.isFreeScrolling
        }, i._childUIPointerDownDrag = function(e) {
            e.preventDefault(), this.pointerDownFocus(e)
        };
        var c = {
                TEXTAREA: !0,
                INPUT: !0,
                OPTION: !0
            },
            d = {
                radio: !0,
                checkbox: !0,
                button: !0,
                submit: !0,
                image: !0,
                file: !0
            };
        i.pointerDown = function(e, t) {
            if (c[e.target.nodeName] && !d[e.target.type]) return this.isPointerDown = !1, void delete this.pointerIdentifier;
            this._dragPointerDown(e, t);
            var i = document.activeElement;
            i && i.blur && i != this.element && i != document.body && i.blur(), this.pointerDownFocus(e), this.dragX = this.x, this.viewport.classList.add("is-pointer-down"), this._bindPostStartEvents(e), this.pointerDownScroll = r(), n.addEventListener("scroll", this), this.dispatchEvent("pointerDown", e, [t])
        }, i.pointerDownFocus = function(e) {
            var t = o(e);
            if (this.options.accessibility && !t) {
                var i = n.pageYOffset;
                this.element.focus(), n.pageYOffset != i && n.scrollTo(n.pageXOffset, i)
            }
        };
        var u = {
            INPUT: !0,
            SELECT: !0
        };
        return i.canPreventDefaultOnPointerDown = function(e) {
            return !o(e)
        }, i.hasDragStarted = function(e) {
            return Math.abs(e.x) > this.options.dragThreshold
        }, i.pointerUp = function(e, t) {
            delete this.isTouchScrolling, this.viewport.classList.remove("is-pointer-down"), this.dispatchEvent("pointerUp", e, [t]), this._dragPointerUp(e, t)
        }, i.pointerDone = function() {
            n.removeEventListener("scroll", this), delete this.pointerDownScroll
        }, i.dragStart = function(e, t) {
            this.dragStartPosition = this.x, this.startAnimation(), n.removeEventListener("scroll", this), this.dispatchEvent("dragStart", e, [t])
        }, i.pointerMove = function(e, t) {
            var i = this._dragPointerMove(e, t);
            this.dispatchEvent("pointerMove", e, [t, i]), this._dragMove(e, t, i)
        }, i.dragMove = function(e, t, i) {
            e.preventDefault(), this.previousDragX = this.dragX;
            var n = this.options.rightToLeft ? -1 : 1,
                o = this.dragStartPosition + i.x * n;
            if (!this.options.wrapAround && this.slides.length) {
                var r = Math.max(-this.slides[0].target, this.dragStartPosition);
                o = r < o ? .5 * (o + r) : o;
                var a = Math.min(-this.getLastSlide().target, this.dragStartPosition);
                o = o < a ? .5 * (o + a) : o
            }
            this.dragX = o, this.dragMoveTime = new Date, this.dispatchEvent("dragMove", e, [t, i])
        }, i.dragEnd = function(e, t) {
            this.options.freeScroll && (this.isFreeScrolling = !0);
            var i = this.dragEndRestingSelect();
            if (this.options.freeScroll && !this.options.wrapAround) {
                var n = this.getRestingPosition();
                this.isFreeScrolling = -n > this.slides[0].target && -n < this.getLastSlide().target
            } else this.options.freeScroll || i != this.selectedIndex || (i += this.dragEndBoostSelect());
            delete this.previousDragX, this.isDragSelect = this.options.wrapAround, this.select(i), delete this.isDragSelect, this.dispatchEvent("dragEnd", e, [t])
        }, i.dragEndRestingSelect = function() {
            var e = this.getRestingPosition(),
                t = Math.abs(this.getSlideDistance(-e, this.selectedIndex)),
                i = this._getClosestResting(e, t, 1),
                n = this._getClosestResting(e, t, -1);
            return i.distance < n.distance ? i.index : n.index
        }, i._getClosestResting = function(e, t, i) {
            for (var n = this.selectedIndex, o = 1 / 0, r = this.options.contain && !this.options.wrapAround ? function(e, t) {
                    return e <= t
                } : function(e, t) {
                    return e < t
                }; r(t, o) && (n += i, o = t, null !== (t = this.getSlideDistance(-e, n)));) t = Math.abs(t);
            return {
                distance: o,
                index: n - i
            }
        }, i.getSlideDistance = function(e, t) {
            var i = this.slides.length,
                n = this.options.wrapAround && 1 < i,
                o = n ? s.modulo(t, i) : t,
                r = this.slides[o];
            if (!r) return null;
            var a = n ? this.slideableWidth * Math.floor(t / i) : 0;
            return e - (r.target + a)
        }, i.dragEndBoostSelect = function() {
            if (void 0 === this.previousDragX || !this.dragMoveTime || 100 < new Date - this.dragMoveTime) return 0;
            var e = this.getSlideDistance(-this.dragX, this.selectedIndex),
                t = this.previousDragX - this.dragX;
            return 0 < e && 0 < t ? 1 : e < 0 && t < 0 ? -1 : 0
        }, i.staticClick = function(e, t) {
            var i = this.getParentCell(e.target),
                n = i && i.element,
                o = i && this.cells.indexOf(i);
            this.dispatchEvent("staticClick", e, [t, n, o])
        }, i.onscroll = function() {
            var e = r(),
                t = this.pointerDownScroll.x - e.x,
                i = this.pointerDownScroll.y - e.y;
            (3 < Math.abs(t) || 3 < Math.abs(i)) && this._pointerDone()
        }, e
    }),
    function(t, i) {
        "function" == typeof define && define.amd ? define("tap-listener/tap-listener", ["unipointer/unipointer"], function(e) {
            return i(t, e)
        }) : "object" == typeof module && module.exports ? module.exports = i(t, require("unipointer")) : t.TapListener = i(t, t.Unipointer)
    }(window, function(s, l) {
        function e(e) {
            this.bindTap(e)
        }
        var t = e.prototype = Object.create(l.prototype);
        return t.bindTap = function(e) {
            e && (this.unbindTap(), this.tapElement = e, this._bindStartEvent(e, !0))
        }, t.unbindTap = function() {
            this.tapElement && (this._bindStartEvent(this.tapElement, !0), delete this.tapElement)
        }, t.pointerUp = function(e, t) {
            if (!this.isIgnoringMouseUp || "mouseup" != e.type) {
                var i = l.getPointerPoint(t),
                    n = this.tapElement.getBoundingClientRect(),
                    o = s.pageXOffset,
                    r = s.pageYOffset;
                if (i.x >= n.left + o && i.x <= n.right + o && i.y >= n.top + r && i.y <= n.bottom + r && this.emitEvent("tap", [e, t]), "mouseup" != e.type) {
                    this.isIgnoringMouseUp = !0;
                    var a = this;
                    setTimeout(function() {
                        delete a.isIgnoringMouseUp
                    }, 400)
                }
            }
        }, t.destroy = function() {
            this.pointerDone(), this.unbindTap()
        }, e
    }),
    function(n, o) {
        "function" == typeof define && define.amd ? define("flickity/js/prev-next-button", ["./flickity", "tap-listener/tap-listener", "fizzy-ui-utils/utils"], function(e, t, i) {
            return o(n, e, t, i)
        }) : "object" == typeof module && module.exports ? module.exports = o(n, require("./flickity"), require("tap-listener"), require("fizzy-ui-utils")) : o(n, n.Flickity, n.TapListener, n.fizzyUIUtils)
    }(window, function(e, t, i, n) {
        "use strict";

        function o(e, t) {
            this.direction = e, this.parent = t, this._create()
        }
        var r = "http://www.w3.org/2000/svg";
        (o.prototype = new i)._create = function() {
            this.isEnabled = !0, this.isPrevious = -1 == this.direction;
            var e = this.parent.options.rightToLeft ? 1 : -1;
            this.isLeft = this.direction == e;
            var t = this.element = document.createElement("button");
            t.className = "flickity-prev-next-button", t.className += this.isPrevious ? " previous" : " next", t.setAttribute("type", "button"), this.disable(), t.setAttribute("aria-label", this.isPrevious ? "previous" : "next");
            var i = this.createSVG();
            t.appendChild(i), this.on("tap", this.onTap), this.parent.on("select", this.update.bind(this)), this.on("pointerDown", this.parent.childUIPointerDown.bind(this.parent))
        }, o.prototype.activate = function() {
            this.bindTap(this.element), this.element.addEventListener("click", this), this.parent.element.appendChild(this.element)
        }, o.prototype.deactivate = function() {
            this.parent.element.removeChild(this.element), i.prototype.destroy.call(this), this.element.removeEventListener("click", this)
        }, o.prototype.createSVG = function() {
            var e = document.createElementNS(r, "svg");
            e.setAttribute("viewBox", "0 0 100 100");
            var t, i = document.createElementNS(r, "path"),
                n = "string" == typeof(t = this.parent.options.arrowShape) ? t : "M " + t.x0 + ",50 L " + t.x1 + "," + (t.y1 + 50) + " L " + t.x2 + "," + (t.y2 + 50) + " L " + t.x3 + ",50  L " + t.x2 + "," + (50 - t.y2) + " L " + t.x1 + "," + (50 - t.y1) + " Z";
            return i.setAttribute("d", n), i.setAttribute("class", "arrow"), this.isLeft || i.setAttribute("transform", "translate(100, 100) rotate(180) "), e.appendChild(i), e
        }, o.prototype.onTap = function() {
            if (this.isEnabled) {
                this.parent.uiChange();
                var e = this.isPrevious ? "previous" : "next";
                this.parent[e]()
            }
        }, o.prototype.handleEvent = n.handleEvent, o.prototype.onclick = function() {
            var e = document.activeElement;
            e && e == this.element && this.onTap()
        }, o.prototype.enable = function() {
            this.isEnabled || (this.element.disabled = !1, this.isEnabled = !0)
        }, o.prototype.disable = function() {
            this.isEnabled && (this.element.disabled = !0, this.isEnabled = !1)
        }, o.prototype.update = function() {
            var e = this.parent.slides;
            if (this.parent.options.wrapAround && 1 < e.length) this.enable();
            else {
                var t = e.length ? e.length - 1 : 0,
                    i = this.isPrevious ? 0 : t;
                this[this.parent.selectedIndex == i ? "disable" : "enable"]()
            }
        }, o.prototype.destroy = function() {
            this.deactivate()
        }, n.extend(t.defaults, {
            prevNextButtons: !0,
            arrowShape: {
                x0: 10,
                x1: 60,
                y1: 50,
                x2: 70,
                y2: 40,
                x3: 30
            }
        }), t.createMethods.push("_createPrevNextButtons");
        var a = t.prototype;
        return a._createPrevNextButtons = function() {
            this.options.prevNextButtons && (this.prevButton = new o(-1, this), this.nextButton = new o(1, this), this.on("activate", this.activatePrevNextButtons))
        }, a.activatePrevNextButtons = function() {
            this.prevButton.activate(), this.nextButton.activate(), this.on("deactivate", this.deactivatePrevNextButtons)
        }, a.deactivatePrevNextButtons = function() {
            this.prevButton.deactivate(), this.nextButton.deactivate(), this.off("deactivate", this.deactivatePrevNextButtons)
        }, t.PrevNextButton = o, t
    }),
    function(n, o) {
        "function" == typeof define && define.amd ? define("flickity/js/page-dots", ["./flickity", "tap-listener/tap-listener", "fizzy-ui-utils/utils"], function(e, t, i) {
            return o(n, e, t, i)
        }) : "object" == typeof module && module.exports ? module.exports = o(n, require("./flickity"), require("tap-listener"), require("fizzy-ui-utils")) : o(n, n.Flickity, n.TapListener, n.fizzyUIUtils)
    }(window, function(e, t, i, n) {
        function o(e) {
            this.parent = e, this._create()
        }(o.prototype = new i)._create = function() {
            this.holder = document.createElement("ol"), this.holder.className = "flickity-page-dots", this.dots = [], this.on("tap", this.onTap), this.on("pointerDown", this.parent.childUIPointerDown.bind(this.parent))
        }, o.prototype.activate = function() {
            this.setDots(), this.bindTap(this.holder), this.parent.element.appendChild(this.holder)
        }, o.prototype.deactivate = function() {
            this.parent.element.removeChild(this.holder), i.prototype.destroy.call(this)
        }, o.prototype.setDots = function() {
            var e = this.parent.slides.length - this.dots.length;
            0 < e ? this.addDots(e) : e < 0 && this.removeDots(-e)
        }, o.prototype.addDots = function(e) {
            for (var t = document.createDocumentFragment(), i = []; e;) {
                var n = document.createElement("li");
                n.className = "dot", t.appendChild(n), i.push(n), e--
            }
            this.holder.appendChild(t), this.dots = this.dots.concat(i)
        }, o.prototype.removeDots = function(e) {
            this.dots.splice(this.dots.length - e, e).forEach(function(e) {
                this.holder.removeChild(e)
            }, this)
        }, o.prototype.updateSelected = function() {
            this.selectedDot && (this.selectedDot.className = "dot"), this.dots.length && (this.selectedDot = this.dots[this.parent.selectedIndex], this.selectedDot.className = "dot is-selected")
        }, o.prototype.onTap = function(e) {
            var t = e.target;
            if ("LI" == t.nodeName) {
                this.parent.uiChange();
                var i = this.dots.indexOf(t);
                this.parent.select(i)
            }
        }, o.prototype.destroy = function() {
            this.deactivate()
        }, t.PageDots = o, n.extend(t.defaults, {
            pageDots: !0
        }), t.createMethods.push("_createPageDots");
        var r = t.prototype;
        return r._createPageDots = function() {
            this.options.pageDots && (this.pageDots = new o(this), this.on("activate", this.activatePageDots), this.on("select", this.updateSelectedPageDots), this.on("cellChange", this.updatePageDots), this.on("resize", this.updatePageDots), this.on("deactivate", this.deactivatePageDots))
        }, r.activatePageDots = function() {
            this.pageDots.activate()
        }, r.updateSelectedPageDots = function() {
            this.pageDots.updateSelected()
        }, r.updatePageDots = function() {
            this.pageDots.setDots()
        }, r.deactivatePageDots = function() {
            this.pageDots.deactivate()
        }, t.PageDots = o, t
    }),
    function(e, n) {
        "function" == typeof define && define.amd ? define("flickity/js/player", ["ev-emitter/ev-emitter", "fizzy-ui-utils/utils", "./flickity"], function(e, t, i) {
            return n(e, t, i)
        }) : "object" == typeof module && module.exports ? module.exports = n(require("ev-emitter"), require("fizzy-ui-utils"), require("./flickity")) : n(e.EvEmitter, e.fizzyUIUtils, e.Flickity)
    }(window, function(e, t, i) {
        function n(e) {
            this.parent = e, this.state = "stopped", r && (this.onVisibilityChange = function() {
                this.visibilityChange()
            }.bind(this), this.onVisibilityPlay = function() {
                this.visibilityPlay()
            }.bind(this))
        }
        var o, r;
        "hidden" in document ? (o = "hidden", r = "visibilitychange") : "webkitHidden" in document && (o = "webkitHidden", r = "webkitvisibilitychange"), (n.prototype = Object.create(e.prototype)).play = function() {
            if ("playing" != this.state) {
                var e = document[o];
                if (r && e) return void document.addEventListener(r, this.onVisibilityPlay);
                this.state = "playing", r && document.addEventListener(r, this.onVisibilityChange), this.tick()
            }
        }, n.prototype.tick = function() {
            if ("playing" == this.state) {
                var e = this.parent.options.autoPlay;
                e = "number" == typeof e ? e : 3e3;
                var t = this;
                this.clear(), this.timeout = setTimeout(function() {
                    t.parent.next(!0), t.tick()
                }, e)
            }
        }, n.prototype.stop = function() {
            this.state = "stopped", this.clear(), r && document.removeEventListener(r, this.onVisibilityChange)
        }, n.prototype.clear = function() {
            clearTimeout(this.timeout)
        }, n.prototype.pause = function() {
            "playing" == this.state && (this.state = "paused", this.clear())
        }, n.prototype.unpause = function() {
            "paused" == this.state && this.play()
        }, n.prototype.visibilityChange = function() {
            this[document[o] ? "pause" : "unpause"]()
        }, n.prototype.visibilityPlay = function() {
            this.play(), document.removeEventListener(r, this.onVisibilityPlay)
        }, t.extend(i.defaults, {
            pauseAutoPlayOnHover: !0
        }), i.createMethods.push("_createPlayer");
        var a = i.prototype;
        return a._createPlayer = function() {
            this.player = new n(this), this.on("activate", this.activatePlayer), this.on("uiChange", this.stopPlayer), this.on("pointerDown", this.stopPlayer), this.on("deactivate", this.deactivatePlayer)
        }, a.activatePlayer = function() {
            this.options.autoPlay && (this.player.play(), this.element.addEventListener("mouseenter", this))
        }, a.playPlayer = function() {
            this.player.play()
        }, a.stopPlayer = function() {
            this.player.stop()
        }, a.pausePlayer = function() {
            this.player.pause()
        }, a.unpausePlayer = function() {
            this.player.unpause()
        }, a.deactivatePlayer = function() {
            this.player.stop(), this.element.removeEventListener("mouseenter", this)
        }, a.onmouseenter = function() {
            this.options.pauseAutoPlayOnHover && (this.player.pause(), this.element.addEventListener("mouseleave", this))
        }, a.onmouseleave = function() {
            this.player.unpause(), this.element.removeEventListener("mouseleave", this)
        }, i.Player = n, i
    }),
    function(i, n) {
        "function" == typeof define && define.amd ? define("flickity/js/add-remove-cell", ["./flickity", "fizzy-ui-utils/utils"], function(e, t) {
            return n(i, e, t)
        }) : "object" == typeof module && module.exports ? module.exports = n(i, require("./flickity"), require("fizzy-ui-utils")) : n(i, i.Flickity, i.fizzyUIUtils)
    }(window, function(e, t, a) {
        var i = t.prototype;
        return i.insert = function(e, t) {
            var i, n, o = this._makeCells(e);
            if (o && o.length) {
                var r = this.cells.length;
                t = void 0 === t ? r : t;
                var a = (i = o, n = document.createDocumentFragment(), i.forEach(function(e) {
                        n.appendChild(e.element)
                    }), n),
                    s = t == r;
                if (s) this.slider.appendChild(a);
                else {
                    var l = this.cells[t].element;
                    this.slider.insertBefore(a, l)
                }
                if (0 === t) this.cells = o.concat(this.cells);
                else if (s) this.cells = this.cells.concat(o);
                else {
                    var c = this.cells.splice(t, r - t);
                    this.cells = this.cells.concat(o).concat(c)
                }
                this._sizeCells(o);
                var d = t > this.selectedIndex ? 0 : o.length;
                this._cellAddedRemoved(t, d)
            }
        }, i.append = function(e) {
            this.insert(e, this.cells.length)
        }, i.prepend = function(e) {
            this.insert(e, 0)
        }, i.remove = function(e) {
            var t, i, n = this.getCells(e),
                o = 0,
                r = n.length;
            for (t = 0; t < r; t++) i = n[t], o -= this.cells.indexOf(i) < this.selectedIndex ? 1 : 0;
            for (t = 0; t < r; t++)(i = n[t]).remove(), a.removeFrom(this.cells, i);
            n.length && this._cellAddedRemoved(0, o)
        }, i._cellAddedRemoved = function(e, t) {
            t = t || 0, this.selectedIndex += t, this.selectedIndex = Math.max(0, Math.min(this.slides.length - 1, this.selectedIndex)), this.cellChange(e, !0), this.emitEvent("cellAddedRemoved", [e, t])
        }, i.cellSizeChange = function(e) {
            var t = this.getCell(e);
            if (t) {
                t.getSize();
                var i = this.cells.indexOf(t);
                this.cellChange(i)
            }
        }, i.cellChange = function(e, t) {
            var i = this.slideableWidth;
            if (this._positionCells(e), this._getWrapShiftCells(), this.setGallerySize(), this.emitEvent("cellChange", [e]), this.options.freeScroll) {
                var n = i - this.slideableWidth;
                this.x += n * this.cellAlign, this.positionSlider()
            } else t && this.positionSliderAtSelected(), this.select(this.selectedIndex)
        }, t
    }),
    function(i, n) {
        "function" == typeof define && define.amd ? define("flickity/js/lazyload", ["./flickity", "fizzy-ui-utils/utils"], function(e, t) {
            return n(i, e, t)
        }) : "object" == typeof module && module.exports ? module.exports = n(i, require("./flickity"), require("fizzy-ui-utils")) : n(i, i.Flickity, i.fizzyUIUtils)
    }(window, function(e, t, o) {
        "use strict";

        function r(e, t) {
            this.img = e, this.flickity = t, this.load()
        }
        t.createMethods.push("_createLazyload");
        var i = t.prototype;
        return i._createLazyload = function() {
            this.on("select", this.lazyLoad)
        }, i.lazyLoad = function() {
            var e = this.options.lazyLoad;
            if (e) {
                var t = "number" == typeof e ? e : 0,
                    i = this.getAdjacentCellElements(t),
                    n = [];
                i.forEach(function(e) {
                    var t = function(e) {
                        if ("IMG" == e.nodeName && e.getAttribute("data-flickity-lazyload")) return [e];
                        var t = e.querySelectorAll("img[data-flickity-lazyload]");
                        return o.makeArray(t)
                    }(e);
                    n = n.concat(t)
                }), n.forEach(function(e) {
                    new r(e, this)
                }, this)
            }
        }, r.prototype.handleEvent = o.handleEvent, r.prototype.load = function() {
            this.img.addEventListener("load", this), this.img.addEventListener("error", this), this.img.src = this.img.getAttribute("data-flickity-lazyload"), this.img.removeAttribute("data-flickity-lazyload")
        }, r.prototype.onload = function(e) {
            this.complete(e, "flickity-lazyloaded")
        }, r.prototype.onerror = function(e) {
            this.complete(e, "flickity-lazyerror")
        }, r.prototype.complete = function(e, t) {
            this.img.removeEventListener("load", this), this.img.removeEventListener("error", this);
            var i = this.flickity.getParentCell(this.img),
                n = i && i.element;
            this.flickity.cellSizeChange(n), this.img.classList.add(t), this.flickity.dispatchEvent("lazyLoad", e, n)
        }, t.LazyLoader = r, t
    }),
    function(e, t) {
        "function" == typeof define && define.amd ? define("flickity/js/index", ["./flickity", "./drag", "./prev-next-button", "./page-dots", "./player", "./add-remove-cell", "./lazyload"], t) : "object" == typeof module && module.exports && (module.exports = t(require("./flickity"), require("./drag"), require("./prev-next-button"), require("./page-dots"), require("./player"), require("./add-remove-cell"), require("./lazyload")))
    }(window, function(e) {
        return e
    }),
    function(e, t) {
        "function" == typeof define && define.amd ? define("flickity-as-nav-for/as-nav-for", ["flickity/js/index", "fizzy-ui-utils/utils"], t) : "object" == typeof module && module.exports ? module.exports = t(require("flickity"), require("fizzy-ui-utils")) : e.Flickity = t(e.Flickity, e.fizzyUIUtils)
    }(window, function(n, o) {
        n.createMethods.push("_createAsNavFor");
        var e = n.prototype;
        return e._createAsNavFor = function() {
            this.on("activate", this.activateAsNavFor), this.on("deactivate", this.deactivateAsNavFor), this.on("destroy", this.destroyAsNavFor);
            var e = this.options.asNavFor;
            if (e) {
                var t = this;
                setTimeout(function() {
                    t.setNavCompanion(e)
                })
            }
        }, e.setNavCompanion = function(e) {
            e = o.getQueryElement(e);
            var t = n.data(e);
            if (t && t != this) {
                this.navCompanion = t;
                var i = this;
                this.onNavCompanionSelect = function() {
                    i.navCompanionSelect()
                }, t.on("select", this.onNavCompanionSelect), this.on("staticClick", this.onNavStaticClick), this.navCompanionSelect(!0)
            }
        }, e.navCompanionSelect = function(e) {
            if (this.navCompanion) {
                var t = this.navCompanion.selectedCells[0],
                    i = this.navCompanion.cells.indexOf(t),
                    n = i + this.navCompanion.selectedCells.length - 1,
                    o = Math.floor((n - (a = i)) * this.navCompanion.cellAlign + a);
                if (this.selectCell(o, !1, e), this.removeNavSelectedElements(), !(o >= this.cells.length)) {
                    var r = this.cells.slice(i, 1 + n);
                    this.navSelectedElements = r.map(function(e) {
                        return e.element
                    }), this.changeNavSelectedClass("add")
                }
            }
            var a
        }, e.changeNavSelectedClass = function(t) {
            this.navSelectedElements.forEach(function(e) {
                e.classList[t]("is-nav-selected")
            })
        }, e.activateAsNavFor = function() {
            this.navCompanionSelect(!0)
        }, e.removeNavSelectedElements = function() {
            this.navSelectedElements && (this.changeNavSelectedClass("remove"), delete this.navSelectedElements)
        }, e.onNavStaticClick = function(e, t, i, n) {
            "number" == typeof n && this.navCompanion.selectCell(n)
        }, e.deactivateAsNavFor = function() {
            this.removeNavSelectedElements()
        }, e.destroyAsNavFor = function() {
            this.navCompanion && (this.navCompanion.off("select", this.onNavCompanionSelect), this.off("staticClick", this.onNavStaticClick), delete this.navCompanion)
        }, n
    }),
    function(t, i) {
        "use strict";
        "function" == typeof define && define.amd ? define("imagesloaded/imagesloaded", ["ev-emitter/ev-emitter"], function(e) {
            return i(t, e)
        }) : "object" == typeof module && module.exports ? module.exports = i(t, require("ev-emitter")) : t.imagesLoaded = i(t, t.EvEmitter)
    }("undefined" != typeof window ? window : this, function(t, e) {
        function n(e, t) {
            for (var i in t) e[i] = t[i];
            return e
        }

        function o(e, t, i) {
            return this instanceof o ? ("string" == typeof e && (e = document.querySelectorAll(e)), this.elements = function(e) {
                var t = [];
                if (Array.isArray(e)) t = e;
                else if ("number" == typeof e.length)
                    for (var i = 0; i < e.length; i++) t.push(e[i]);
                else t.push(e);
                return t
            }(e), this.options = n({}, this.options), "function" == typeof t ? i = t : n(this.options, t), i && this.on("always", i), this.getImages(), a && (this.jqDeferred = new a.Deferred), void setTimeout(function() {
                this.check()
            }.bind(this))) : new o(e, t, i)
        }

        function i(e) {
            this.img = e
        }

        function r(e, t) {
            this.url = e, this.element = t, this.img = new Image
        }
        var a = t.jQuery,
            s = t.console;
        (o.prototype = Object.create(e.prototype)).options = {}, o.prototype.getImages = function() {
            this.images = [], this.elements.forEach(this.addElementImages, this)
        }, o.prototype.addElementImages = function(e) {
            "IMG" == e.nodeName && this.addImage(e), !0 === this.options.background && this.addElementBackgroundImages(e);
            var t = e.nodeType;
            if (t && l[t]) {
                for (var i = e.querySelectorAll("img"), n = 0; n < i.length; n++) {
                    var o = i[n];
                    this.addImage(o)
                }
                if ("string" == typeof this.options.background) {
                    var r = e.querySelectorAll(this.options.background);
                    for (n = 0; n < r.length; n++) {
                        var a = r[n];
                        this.addElementBackgroundImages(a)
                    }
                }
            }
        };
        var l = {
            1: !0,
            9: !0,
            11: !0
        };
        return o.prototype.addElementBackgroundImages = function(e) {
            var t = getComputedStyle(e);
            if (t)
                for (var i = /url\((['"])?(.*?)\1\)/gi, n = i.exec(t.backgroundImage); null !== n;) {
                    var o = n && n[2];
                    o && this.addBackground(o, e), n = i.exec(t.backgroundImage)
                }
        }, o.prototype.addImage = function(e) {
            var t = new i(e);
            this.images.push(t)
        }, o.prototype.addBackground = function(e, t) {
            var i = new r(e, t);
            this.images.push(i)
        }, o.prototype.check = function() {
            function t(e, t, i) {
                setTimeout(function() {
                    n.progress(e, t, i)
                })
            }
            var n = this;
            return this.progressedCount = 0, this.hasAnyBroken = !1, this.images.length ? void this.images.forEach(function(e) {
                e.once("progress", t), e.check()
            }) : void this.complete()
        }, o.prototype.progress = function(e, t, i) {
            this.progressedCount++, this.hasAnyBroken = this.hasAnyBroken || !e.isLoaded, this.emitEvent("progress", [this, e, t]), this.jqDeferred && this.jqDeferred.notify && this.jqDeferred.notify(this, e), this.progressedCount == this.images.length && this.complete(), this.options.debug && s && s.log("progress: " + i, e, t)
        }, o.prototype.complete = function() {
            var e = this.hasAnyBroken ? "fail" : "done";
            if (this.isComplete = !0, this.emitEvent(e, [this]), this.emitEvent("always", [this]), this.jqDeferred) {
                var t = this.hasAnyBroken ? "reject" : "resolve";
                this.jqDeferred[t](this)
            }
        }, (i.prototype = Object.create(e.prototype)).check = function() {
            return this.getIsImageComplete() ? void this.confirm(0 !== this.img.naturalWidth, "naturalWidth") : (this.proxyImage = new Image, this.proxyImage.addEventListener("load", this), this.proxyImage.addEventListener("error", this), this.img.addEventListener("load", this), this.img.addEventListener("error", this), void(this.proxyImage.src = this.img.src))
        }, i.prototype.getIsImageComplete = function() {
            return this.img.complete && void 0 !== this.img.naturalWidth
        }, i.prototype.confirm = function(e, t) {
            this.isLoaded = e, this.emitEvent("progress", [this, this.img, t])
        }, i.prototype.handleEvent = function(e) {
            var t = "on" + e.type;
            this[t] && this[t](e)
        }, i.prototype.onload = function() {
            this.confirm(!0, "onload"), this.unbindEvents()
        }, i.prototype.onerror = function() {
            this.confirm(!1, "onerror"), this.unbindEvents()
        }, i.prototype.unbindEvents = function() {
            this.proxyImage.removeEventListener("load", this), this.proxyImage.removeEventListener("error", this), this.img.removeEventListener("load", this), this.img.removeEventListener("error", this)
        }, (r.prototype = Object.create(i.prototype)).check = function() {
            this.img.addEventListener("load", this), this.img.addEventListener("error", this), this.img.src = this.url, this.getIsImageComplete() && (this.confirm(0 !== this.img.naturalWidth, "naturalWidth"), this.unbindEvents())
        }, r.prototype.unbindEvents = function() {
            this.img.removeEventListener("load", this), this.img.removeEventListener("error", this)
        }, r.prototype.confirm = function(e, t) {
            this.isLoaded = e, this.emitEvent("progress", [this, this.element, t])
        }, o.makeJQueryPlugin = function(e) {
            (e = e || t.jQuery) && ((a = e).fn.imagesLoaded = function(e, t) {
                return new o(this, e, t).jqDeferred.promise(a(this))
            })
        }, o.makeJQueryPlugin(), o
    }),
    function(i, n) {
        "function" == typeof define && define.amd ? define(["flickity/js/index", "imagesloaded/imagesloaded"], function(e, t) {
            return n(i, e, t)
        }) : "object" == typeof module && module.exports ? module.exports = n(i, require("flickity"), require("imagesloaded")) : i.Flickity = n(i, i.Flickity, i.imagesLoaded)
    }(window, function(e, t, i) {
        "use strict";
        t.createMethods.push("_createImagesLoaded");
        var n = t.prototype;
        return n._createImagesLoaded = function() {
            this.on("activate", this.imagesLoaded)
        }, n.imagesLoaded = function() {
            if (this.options.imagesLoaded) {
                var n = this;
                i(this.slider).on("progress", function(e, t) {
                    var i = n.getParentCell(t.img);
                    n.cellSizeChange(i && i.element), n.options.freeScroll || n.positionSliderAtSelected()
                })
            }
        }, t
    }),
    function(i, p) {
        function h(e) {
            return "function" != typeof p.createElement ? p.createElement(e) : m ? p.createElementNS.call(p, "http://www.w3.org/2000/svg", e) : p.createElement.apply(p, arguments)
        }
        var s = [],
            l = [],
            e = {
                _version: "3.3.1",
                _config: {
                    classPrefix: "",
                    enableClasses: !0,
                    enableJSClass: !0,
                    usePrefixes: !0
                },
                _q: [],
                on: function(e, t) {
                    var i = this;
                    setTimeout(function() {
                        t(i[e])
                    }, 0)
                },
                addTest: function(e, t, i) {
                    l.push({
                        name: e,
                        fn: t,
                        options: i
                    })
                },
                addAsyncTest: function(e) {
                    l.push({
                        name: null,
                        fn: e
                    })
                }
            },
            c = function() {};
        c.prototype = e, c = new c;
        var f = p.documentElement,
            m = "svg" === f.nodeName.toLowerCase(),
            n = e._config.usePrefixes ? " -webkit- -moz- -o- -ms- ".split(" ") : ["", ""];
        e._prefixes = n;
        var o = e.testStyles = function(e, t, i, n) {
            var o, r, a, s, l, c = "modernizr",
                d = h("div"),
                u = ((l = p.body) || ((l = h(m ? "svg" : "body")).fake = !0), l);
            if (parseInt(i, 10))
                for (; i--;)(a = h("div")).id = n ? n[i] : c + (i + 1), d.appendChild(a);
            return (o = h("style")).type = "text/css", o.id = "s" + c, (u.fake ? u : d).appendChild(o), u.appendChild(d), o.styleSheet ? o.styleSheet.cssText = e : o.appendChild(p.createTextNode(e)), d.id = c, u.fake && (u.style.background = "", u.style.overflow = "hidden", s = f.style.overflow, f.style.overflow = "hidden", f.appendChild(u)), r = t(d, e), u.fake ? (u.parentNode.removeChild(u), f.style.overflow = s, f.offsetHeight) : d.parentNode.removeChild(d), !!r
        };
        c.addTest("touchevents", function() {
                var t;
                if ("ontouchstart" in i || i.DocumentTouch && p instanceof DocumentTouch) t = !0;
                else {
                    var e = ["@media (", n.join("touch-enabled),("), "heartz", ")", "{#modernizr{top:9px;position:absolute}}"].join("");
                    o(e, function(e) {
                        t = 9 === e.offsetTop
                    })
                }
                return t
            }),
            function() {
                var e, t, i, n, o, r;
                for (var a in l)
                    if (l.hasOwnProperty(a)) {
                        if (e = [], (t = l[a]).name && (e.push(t.name.toLowerCase()), t.options && t.options.aliases && t.options.aliases.length))
                            for (i = 0; i < t.options.aliases.length; i++) e.push(t.options.aliases[i].toLowerCase());
                        for (n = "function" == typeof t.fn ? t.fn() : t.fn, o = 0; o < e.length; o++) 1 === (r = e[o].split(".")).length ? c[r[0]] = n : (!c[r[0]] || c[r[0]] instanceof Boolean || (c[r[0]] = new Boolean(c[r[0]])), c[r[0]][r[1]] = n), s.push((n ? "" : "no-") + r.join("-"))
                    }
            }(),
            function(e) {
                var t = f.className,
                    i = c._config.classPrefix || "";
                if (m && (t = t.baseVal), c._config.enableJSClass) {
                    var n = new RegExp("(^|\\s)" + i + "no-js(\\s|$)");
                    t = t.replace(n, "$1" + i + "js$2")
                }
                c._config.enableClasses && (t += " " + i + e.join(" " + i), m ? f.className.baseVal = t : f.className = t)
            }(s), delete e.addTest, delete e.addAsyncTest;
        for (var t = 0; t < c._q.length; t++) c._q[t]();
        i.Modernizr = c
    }(window, document),
    function(e, t) {
        "function" == typeof define && define.amd ? define([], function() {
            return t()
        }) : "object" == typeof exports ? module.exports = t() : e.Headhesive = t()
    }(this, function() {
        "use strict";

        function e(i, n) {
            function o() {
                d = l(), c = null, s = i.apply(r, a), r = a = null
            }
            var r, a, s, l = Date.now || function() {
                    return (new Date).getTime()
                },
                c = null,
                d = 0;
            return function() {
                var e = l(),
                    t = n - (e - d);
                return r = this, a = arguments, t <= 0 ? (clearTimeout(c), c = null, d = e, s = i.apply(r, a), r = a = null) : c = c || setTimeout(o, t), s
            }
        }

        function t(e, t) {
            "querySelector" in document && "addEventListener" in window && (this.visible = !1, this.options = {
                offset: 300,
                offsetSide: "top",
                classes: {
                    clone: "headhesive",
                    stick: "headhesive--stick",
                    unstick: "headhesive--unstick"
                },
                throttle: 250,
                onInit: function() {},
                onStick: function() {},
                onUnstick: function() {},
                onDestroy: function() {}
            }, this.elem = "string" == typeof e ? document.querySelector(e) : e, this.options = n(this.options, t), this.init())
        }
        var n = function(e, t) {
            for (var i in t) t.hasOwnProperty(i) && (e[i] = "object" == typeof t[i] ? n(e[i], t[i]) : t[i]);
            return e
        };
        return t.prototype = {
            constructor: t,
            init: function() {
                if (this.clonedElem = this.elem.cloneNode(!0), this.clonedElem.className += " " + this.options.classes.clone, document.body.insertBefore(this.clonedElem, document.body.firstChild), "number" == typeof this.options.offset) this.scrollOffset = this.options.offset;
                else {
                    if ("string" != typeof this.options.offset) throw new Error("Invalid offset: " + this.options.offset);
                    this._setScrollOffset()
                }
                this._throttleUpdate = e(this.update.bind(this), this.options.throttle), this._throttleScrollOffset = e(this._setScrollOffset.bind(this), this.options.throttle), window.addEventListener("scroll", this._throttleUpdate, !1), window.addEventListener("resize", this._throttleScrollOffset, !1), this.options.onInit.call(this)
            },
            _setScrollOffset: function() {
                "string" == typeof this.options.offset && (this.scrollOffset = function(e, t) {
                    for (var i = 0, n = e.offsetHeight; e;) i += e.offsetTop, e = e.offsetParent;
                    return "bottom" === t && (i += n), i
                }(document.querySelector(this.options.offset), this.options.offsetSide))
            },
            destroy: function() {
                document.body.removeChild(this.clonedElem), window.removeEventListener("scroll", this._throttleUpdate), window.removeEventListener("resize", this._throttleScrollOffset), this.options.onDestroy.call(this)
            },
            stick: function() {
                this.visible || (this.clonedElem.className = this.clonedElem.className.replace(new RegExp("(^|\\s)*" + this.options.classes.unstick + "(\\s|$)*", "g"), ""), this.clonedElem.className += " " + this.options.classes.stick, this.visible = !0, this.options.onStick.call(this))
            },
            unstick: function() {
                this.visible && (this.clonedElem.className = this.clonedElem.className.replace(new RegExp("(^|\\s)*" + this.options.classes.stick + "(\\s|$)*", "g"), ""), this.clonedElem.className += " " + this.options.classes.unstick, this.visible = !1, this.options.onUnstick.call(this))
            },
            update: function() {
                (void 0 !== window.pageYOffset ? window.pageYOffset : (document.documentElement || document.body.parentNode || document.body).scrollTop) > this.scrollOffset ? this.stick() : this.unstick()
            }
        }, t
    }),
    function() {
        function e(e, t) {
            var i, n = {};
            if ("tld?" !== e) {
                if (t = t || window.location.toString(), !e) return t;
                if (e = e.toString(), i = t.match(/^mailto:([^\/].+)/)) n.protocol = "mailto", n.email = i[1];
                else {
                    if ((i = t.match(/(.*?)\/#\!(.*)/)) && (t = i[1] + i[2]), (i = t.match(/(.*?)#(.*)/)) && (n.hash = i[2], t = i[1]), n.hash && e.match(/^#/)) return r(e, n.hash);
                    if ((i = t.match(/(.*?)\?(.*)/)) && (n.query = i[2], t = i[1]), n.query && e.match(/^\?/)) return r(e, n.query);
                    if ((i = t.match(/(.*?)\:?\/\/(.*)/)) && (n.protocol = i[1].toLowerCase(), t = i[2]), (i = t.match(/(.*?)(\/.*)/)) && (n.path = i[2], t = i[1]), n.path = (n.path || "").replace(/^([^\/])/, "/$1"), e.match(/^[\-0-9]+$/) && (e = e.replace(/^([^\/])/, "/$1")), e.match(/^\//)) return o(e, n.path.substring(1));
                    if ((i = o("/-1", n.path.substring(1))) && (i = i.match(/(.*?)\.(.*)/)) && (n.file = i[0], n.filename = i[1], n.fileext = i[2]), (i = t.match(/(.*)\:([0-9]+)$/)) && (n.port = i[2], t = i[1]), (i = t.match(/(.*?)@(.*)/)) && (n.auth = i[1], t = i[2]), n.auth && (i = n.auth.match(/(.*)\:(.*)/), n.user = i ? i[1] : n.auth, n.pass = i ? i[2] : void 0), n.hostname = t.toLowerCase(), "." === e.charAt(0)) return o(e, n.hostname);
                    n.port = n.port || ("https" === n.protocol ? "443" : "80"), n.protocol = n.protocol || ("443" === n.port ? "https" : "http")
                }
                return e in n ? n[e] : "{}" === e ? n : void 0
            }
        }

        function o(e, t) {
            var i = e.charAt(0),
                n = t.split(i);
            return i === e ? n : n[(e = parseInt(e.substring(1), 10)) < 0 ? n.length + e : e - 1]
        }

        function r(e, t) {
            for (var i = e.charAt(0), n = t.split("&"), o = [], r = {}, a = [], s = e.substring(1), l = 0, c = n.length; l < c; l++)
                if ((o = n[l].match(/(.*?)=(.*)/)) || (o = [n[l], n[l], ""]), "" !== o[1].replace(/\s/g, "")) {
                    if (o[2] = (d = o[2] || "", decodeURIComponent(d.replace(/\+/g, " "))), s === o[1]) return o[2];
                    (a = o[1].match(/(.*)\[([0-9]+)\]/)) ? (r[a[1]] = r[a[1]] || [], r[a[1]][a[2]] = o[2]) : r[o[1]] = o[2]
                } var d;
            return i === e ? r : r[s]
        }
        "function" == typeof window.define && window.define.amd ? window.define("js-url", [], function() {
            return e
        }) : (void 0 !== window.jQuery && window.jQuery.extend({
            url: function(e, t) {
                return window.url(e, t)
            }
        }), window.url = e)
    }();
var objectFitImages = function() {
        "use strict";

        function r(e, t, i) {
            var n = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='" + (t || 1) + "' height='" + (i || 0) + "'%3E%3C/svg%3E";
            f.call(e, "src") !== n && m.call(e, "src", n)
        }

        function a(e, t) {
            e.naturalWidth ? t(e) : setTimeout(a, 100, e, t)
        }

        function s(n) {
            var i, t, e = function() {
                    for (var e, t = getComputedStyle(n).fontFamily, i = {}; null !== (e = c.exec(t));) i[e[1]] = e[2];
                    return i
                }(),
                o = n[l];
            if (e["object-fit"] = e["object-fit"] || "fill", !o.img) {
                if ("fill" === e["object-fit"]) return;
                if (!o.skipTest && d && !e["object-position"]) return
            }
            if (!o.img) {
                o.img = new Image(n.width, n.height), o.img.srcset = f.call(n, "data-ofi-srcset") || n.srcset, o.img.src = f.call(n, "data-ofi-src") || n.src, m.call(n, "data-ofi-src", n.src), n.srcset && m.call(n, "data-ofi-srcset", n.srcset), r(n, n.naturalWidth || n.width, n.naturalHeight || n.height), n.srcset && (n.srcset = "");
                try {
                    i = n, t = {
                        get: function(e) {
                            return i[l].img[e || "src"]
                        },
                        set: function(e, t) {
                            return i[l].img[t || "src"] = e, m.call(i, "data-ofi-" + t, e), s(i), e
                        }
                    }, Object.defineProperty(i, "src", t), Object.defineProperty(i, "currentSrc", {
                        get: function() {
                            return t.get("currentSrc")
                        }
                    }), Object.defineProperty(i, "srcset", {
                        get: function() {
                            return t.get("srcset")
                        },
                        set: function(e) {
                            return t.set(e, "srcset")
                        }
                    })
                } catch (n) {
                    window.console && console.warn("https://bit.ly/ofi-old-browser")
                }
            }(function(e) {
                if (e.srcset && !h && window.picturefill) {
                    var t = window.picturefill._;
                    e[t.ns] && e[t.ns].evaled || t.fillImg(e, {
                        reselect: !0
                    }), e[t.ns].curSrc || (e[t.ns].supported = !1, t.fillImg(e, {
                        reselect: !0
                    })), e.currentSrc = e[t.ns].curSrc || e.src
                }
            })(o.img), n.style.backgroundImage = 'url("' + (o.img.currentSrc || o.img.src).replace(/"/g, '\\"') + '")', n.style.backgroundPosition = e["object-position"] || "center", n.style.backgroundRepeat = "no-repeat", n.style.backgroundOrigin = "content-box", /scale-down/.test(e["object-fit"]) ? a(o.img, function() {
                o.img.naturalWidth > n.width || o.img.naturalHeight > n.height ? n.style.backgroundSize = "contain" : n.style.backgroundSize = "auto"
            }) : n.style.backgroundSize = e["object-fit"].replace("none", "auto").replace("fill", "100% 100%"), a(o.img, function(e) {
                r(n, e.naturalWidth, e.naturalHeight)
            })
        }

        function o(e, t) {
            var i = !g && !e;
            if (t = t || {}, e = e || "img", u && !t.skipTest || !p) return !1;
            "img" === e ? e = document.getElementsByTagName("img") : "string" == typeof e ? e = document.querySelectorAll(e) : "length" in e || (e = [e]);
            for (var n = 0; n < e.length; n++) e[n][l] = e[n][l] || {
                skipTest: t.skipTest
            }, s(e[n]);
            i && (document.body.addEventListener("load", function(e) {
                "IMG" === e.target.tagName && o(e.target, {
                    skipTest: t.skipTest
                })
            }, !0), g = !0, e = "img"), t.watchMQ && window.addEventListener("resize", o.bind(null, e, {
                skipTest: t.skipTest
            }))
        }
        var l = "bfred-it:object-fit-images",
            c = /(object-fit|object-position)\s*:\s*([-\w\s%]+)/g,
            e = "undefined" == typeof Image ? {
                style: {
                    "object-position": 1
                }
            } : new Image,
            d = "object-fit" in e.style,
            u = "object-position" in e.style,
            p = "background-size" in e.style,
            h = "string" == typeof e.currentSrc,
            f = e.getAttribute,
            m = e.setAttribute,
            g = !1;
        return o.supportsObjectFit = d, (o.supportsObjectPosition = u) || (HTMLImageElement.prototype.getAttribute = function(e) {
            return f.call(i(this, e), e)
        }, HTMLImageElement.prototype.setAttribute = function(e, t) {
            return m.call(i(this, e), e, String(t))
        }), o;

        function i(e, t) {
            return e[l] && e[l].img && ("src" === t || "srcset" === t) ? e[l].img : e
        }
    }(),
    social = {
        twitter: function() {
            window.twttr || (window.twttr = function(e, t, i) {
                var n, o, r = e.getElementsByTagName("script")[0];
                if (!e.getElementById(i)) return (o = e.createElement("script")).id = i, o.src = "https://platform.twitter.com/widgets.js", r.parentNode.insertBefore(o, r), window.twttr || (n = {
                    _e: [],
                    ready: function(e) {
                        n._e.push(e)
                    }
                })
            }(document, 0, "twitter-wjs")), window.twttr && window.twttr.ready(function(e) {
                e.widgets.load(document.getElementById("twitter-timeline"))
            })
        },
        unload: function() {}
    },
    instagram = {
        loadContent: function(a) {
            if (a.clientID) {
                var e = "https://api.instagram.com/v1/users/self/media/recent/?access_token=" + a.clientID;
                $.ajax({
                    type: "GET",
                    url: e,
                    dataType: "jsonp",
                    success: function(e) {
                        if (200 === e.meta.code && e.data.length) {
                            e = e.data;
                            var t = 0;
                            a.el.empty();
                            for (var i = 0; i < e.length; i++) {
                                var n, o = e[i],
                                    r = o.images.low_resolution.url;
                                if (-1 < !o.images.low_resolution.url.indexOf("null") && (n = '<div class="il-photo__img instagram__bg" style="background-image:url(' + r + ')" data-filter="' + o.filter + '" /></div>', n = '<a href="' + o.link + '" target="_blank" class="instagram__link">' + n + "</a>"), o.videos && (n = '<div class="instagram__video instagram__bg" style="background-image:url(' + r + ')" data-filter="' + o.filter + '" /></div>', n = '<a href="' + o.link + '" target="_blank" class="instagram__link instagram__video-link">' + n + "</a>"), "" !== (n = n && '<div class="' + a.column + ' columns instagram__item small-down--one-whole">' + n + "</div>") && (a.el.append(n), t++), t == a.limit) break
                            }
                        }
                    },
                    error: function() {}
                })
            }
        }
    };
$(".social-feeds-wrap").each(function(e, t) {
    social.twitter();
    var i = $(this).find(".js-instafeed");
    instagram.loadContent({
        el: i,
        clientID: i.data("client-id"),
        limit: i.data("count"),
        column: i.data("column")
    })
}), $(document).on("shopify:block:select", function(e) {
    var t = e.detail.blockId,
        i = $("#shopify-section-" + e.detail.sectionId);
    (i.hasClass("slideshow-section") || i.hasClass("testimonial-section")) && sliderBlock.select(t, i), i.hasClass("page-details-section") && $(".map-section").length && mapFunction.init(), i.hasClass("cart-section") && $(".block__featured_collection").length && featuredCollectionSection.init(), i.hasClass("product-template") && 1 <= $("#shopify-product-reviews").length && SPR.$(document).ready(function() {
        return SPR.registerCallbacks(), SPR.initRatingHandler(), SPR.initDomEls(), SPR.loadProducts(), SPR.loadBadges()
    }), utils.resizeActionButtons()
}), $(document).on("shopify:block:deselect", function(e) {
    var t = $("#shopify-section-" + e.detail.sectionId);
    (t.hasClass("slideshow-section") || t.hasClass("testimonial-section")) && sliderBlock.deselect(t)
}), $(document).on("shopify:section:reorder", function(e) {
    utils.pageBannerCheck()
}), $(document).on("shopify:section:load", function(e) {
    var t = $("#shopify-section-" + e.detail.sectionId);
    utils.pageBannerCheck(), t.hasClass("social-feeds-section") && $(".social-feeds-wrap").each(function(e, t) {
        social.twitter();
        var i = $(this).find(".js-instafeed");
        instagram.loadContent({
            el: i,
            clientID: i.data("client-id"),
            limit: i.data("count"),
            column: i.data("column")
        })
    }), t.hasClass("faq-section") && faqAccordion.init(), t.hasClass("cart-section") && (cart.init(), $(".block__featured_collection").length && featuredCollectionSection.init()), t.hasClass("featured-promotions-section") && featuredPromotions.init(), t.hasClass("slideshow-section") && slideshow.init(), t.hasClass("testimonial-section") && testimonial.init(), t.hasClass("image-gallery-section") && gallery.init(), t.hasClass("featured-products-section") && (productPage.initializeQuantityBox(), productPage.productSwatches(), productPage.init(), $(".shopify-product-reviews-badge").length && SPR.$(document).ready(function() {
        return SPR.registerCallbacks(), SPR.initRatingHandler(), SPR.initDomEls(), SPR.loadProducts(), SPR.loadBadges()
    })), t.hasClass("map-section") && mapFunction.init(), t.hasClass("featured-collection-section") && featuredCollectionSection.init(), t.hasClass("video-section") && videoSection.init(), t.hasClass("recently-viewed__section") && recentlyViewed.init(), t.hasClass("product-template") && (productPage.init(), productPage.productSwatches(), productPage.relatedProducts(), recentlyViewed.init(), ($("#shopify-product-reviews").length || $(".shopify-product-reviews-badge").length) && SPR.$(document).ready(function() {
        return SPR.registerCallbacks(), SPR.initRatingHandler(), SPR.initDomEls(), SPR.loadProducts(), SPR.loadBadges()
    })), t.hasClass("article-template-section") && -1 != window.location.pathname.indexOf("/comments") && $("html,body").animate({
        scrollTop: $("#new-comment").offset().top - 140
    }, "slow"), t.hasClass("collection-template-section") && collectionSidebarFilter.init(), t.hasClass("contact-section") && mapFunction.init(), t.hasClass("search-template-section") && collectionSidebarFilter.init(), t.hasClass("header-section") && (header.init(), header.loadMegaMenu()), t.hasClass("mega-menu-section") && header.loadMegaMenu(), t.hasClass("page-details-section") && (featuredCollectionSection.init(), videoSection.init(), recentlyViewed.init()), t.hasClass("product-details-section") && (featuredCollectionSection.init(), videoSection.init(), mapFunction.init(), recentlyViewed.init())
}), $(document).on("shopify:section:unload", function(e) {
    var t = $(e.target),
        i = $("#shopify-section-" + e.detail.sectionId);
    i.hasClass("header-section") && (header.unload(t), header.unloadMegaMenu()), i.hasClass("slideshow-section") && slideshow.unload(t), i.hasClass("testimonial-section") && testimonial.unload(t), i.hasClass("video-section") && videoSection.unload(t), i.hasClass("search-section") && searchAutocomplete.unload(t), i.hasClass("product-template") && productPage.unload(t), i.hasClass("mega-menu-section") && header.unloadMegaMenu(), i.hasClass("page-details-section") && videoSection.unload(t), i.hasClass("product-details-section") && videoSection.unload(t)
}), $(document).on("shopify:section:select", function(e) {
    var t = $("#shopify-section-" + e.detail.sectionId);
    if (t.hasClass("social-feeds-section") && $(".social-feeds-wrap").each(function(e, t) {
            social.twitter()
        }), t.hasClass("mega-menu-section")) {
        var i = $(".header ." + e.detail.sectionId).data("dropdown");
        setTimeout(function() {
            $('a.mega-menu-parent[data-dropdown-rel="' + i + '"]').trigger("mouseenter"), $('a.mega-menu-parent[data-dropdown-rel="' + i + '"]').parents("header").addClass("editor-hover--true"), header.removeDataAttributes(".header .mega-menu.dropdown_container .dropdown_column")
        }, 10)
    }
    t.hasClass("featured-collection-section") && (featuredCollectionSection.unload(t), featuredCollectionSection.init()), utils.pageBannerCheck();
    var n = document.createEvent("UIEvents");
    n.initUIEvent("resize", !0, !1, window, 0), window.dispatchEvent(n)
}), $(document).on("shopify:section:deselect", function(e) {
    if ($("#shopify-section-" + e.detail.sectionId).hasClass("mega-menu-section")) {
        var t = $(".header ." + e.detail.sectionId).data("dropdown");
        $('a.mega-menu-parent[data-dropdown-rel="' + t + '"]').trigger("mouseout"), $('a.mega-menu-parent[data-dropdown-rel="' + t + '"]').parents("header").removeClass("editor-hover--true")
    }
}), $(document).ready(function() {
    $("body.cart")[0] || $("body").on("DOMSubtreeModified", ".cart_subtotal", function() {
        var e = $(".cart_subtotal .money").text().replace("$", "").split("$"),
            t = $(".announcement-bar .announcement-bar__message");
        if (0 < !$(".cart_items").children().length) var i = t.data("message");
        else {
            var n = 100 * e[0],
                o = t.data("shipping_value") - n;
            if (o <= 0) i = t.data("free_shipping_qualified");
            else {
                var r = "$" + o / 100;
                i = t.data("free_shipping_notqualified").replace("[price]", r)
            }
        }
        t.text(i)
    })
});

/* cart drawer login form added by inscoder HG */

$(document).ready(function(){
    $(document).on('click', 'header label.guest_check_label', function() {
        $(this).parent().find('input').click();
        $('label.guest_check_label').parent().find('input').click();
    });
    $(document).on('click', 'header label.login_check_label', function() {
        $(this).parent().find('input').click();
        $('label.login_check_label').parent().find('input').click();
    });
    // nav scroll
    $(document).on('click', 'label.guest_check_label', function() {
        $(this).parent().find('input').click();
        $('header label.guest_check_label').parent().find('input').click();
    });
    $(document).on('click', 'label.login_check_label', function() {
        $(this).parent().find('input').click();
        $('header label.login_check_label').parent().find('input').click();
    });

    $(document).on('change', '.guest_check', function() {
        if($(this).prop("checked") == true){
            $(".guest_check_label").parent().addClass("greenBackground"); 
            $(".login_check").parent().removeClass("greenBackground");
            $(".drawer_guest_form").css("display","block");
            $(".log_option").css("display","none");
            $(".drawer_login_form").css("display","none");
            $(".registration_drawer").css("display","none");
            $("header #drawer-recover-password").css("display","none");
        }
        else{
            $(".drawer_guest_form").css("display","none");
        }
    });
    $(document).on('change', '.login_check', function() {
        if($(this).prop("checked") == true){
            $(".login_check_label").parent().addClass("greenBackground");
            $(".guest_check").parent().removeClass("greenBackground");
            $(".log_option").css("display","flex");
            $(".drawer_guest_form").css("display","none");
            $("header #drawer-recover-password").css("display","none");
        }
        else{
            $(".drawer_login_form").css("display","none"); 
            $(".log_option").css("display","none");
        }
    });
    $(document).on('click', '.new_signup_customer', function() {
        $(".registration_drawer").css("display","block");
        $(".drawer_login_form").css("display","none");
        $("header #drawer-recover-password").css("display","none");
    });
    $(document).on('click', '.already_account', function() {
        $(".registration_drawer").css("display","none");
        $(".drawer_login_form").css("display","block");
    });
    $(document).on('click', '.login_btn', function() {
        $(".drawer_login_form").css("display","block");
        $(".log_option").css("display","none");
    });
    $(document).on('click', '.signup_btn', function() {
        $(".registration_drawer").css("display","block");
        $(".log_option").css("display","none");
    });
});

/* cart drawer phone browser bug fix */
function resizeElementHeight(element) {
  var screenHeight = window.innerHeight,
      headerDiff = parseInt($('#header').height()) + parseInt($('.announcement-bar').height()),
      visibleScreenH = parseInt(screenHeight) - parseInt(headerDiff);
  //element.style.height = ((screenHeight-headerDiff) + "px");
  element.style.top = (headerDiff + "px");
  document.documentElement.style.setProperty("--screen-height",visibleScreenH+"px");
}

var elementCartDrawer = document.getElementById('cart_content_height');
resizeElementHeight(elementCartDrawer);

window.addEventListener('resize', () => {
  resizeElementHeight(elementCartDrawer);
});

/* mobile device add class */
var classNames = [];
if (navigator.userAgent.match(/(iPad|iPhone|iPod)/i)) classNames.push('device-ios');
if (navigator.userAgent.match(/android/i)) classNames.push('device-android');

var html = document.getElementsByTagName('html')[0];

if (classNames.length) classNames.push('on-device');
if (html.classList) html.classList.add.apply(html.classList, classNames);